{
  "beach": [
    {
      "city": "Marseille",
      "country": "France",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/marseille.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-marseille-154256989765425:Square?wid=768&fit=constrain",
      "headline": "Discover Marseille Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Marseille, France your way! Explore restaurants, local attractions and things to do in your favorite Marseille, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "San Francisco",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/san-francisco.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-GettyImages-1133891066-359793688600498:Square?wid=768&fit=constrain",
      "headline": "San Francisco Adventures Await with Marriott Bonvoy Stays",
      "description": "Stay at a Marriott Bonvoy Hotel in San Francisco, CA, and enjoy easy access to Fisherman’s Wharf, the iconic Golden Gate Bridge, and endless adventures."
    },
    {
      "city": "Cancun",
      "country": "Mexico",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/cancun.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-boat-riding-cst322465-166984698498724:Square?wid=768&fit=constrain",
      "headline": "Discover Cancún Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Cancún, Mexico your way! Explore restaurants, local attractions and things to do in your favorite Cancún, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Abu Dhabi",
      "country": "United Arab Emirates",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/abu-dhabi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-are-abu-dhabi-173454035351045:Square?wid=768&fit=constrain",
      "headline": "Abu Dhabi Adventures: Culture, Coastlines, and High-Speed Thrills Await",
      "description": "Whether you’re strolling the lively markets along the Corniche, or exploring the world-famous Abu Dhabi Louvre, the city’s diverse attractions beckon. Our Abu Dhabi hotels cater to every type of traveler, whether you’re visiting for business or leisure. Enjoy free Wi-Fi, well-equipped fitness centers, and tempting dining options, ensuring a comfortable and memorable stay. Whether you’re here to experience the city’s vibrant arts scene, relax on a luxurious beach, or feel the excitement of the Formula 1 track at Yas Marina Circuit, our hotels provide the perfect base for an unforgettable adventure in Abu Dhabi."
    },
    {
      "city": "Melbourne",
      "country": "Australia",
      "Beach": "75.0",
      "Culinary": "85",
      "Golf": "80",
      "Ski": "50",
      "Spa": "60",
      "Culture": "75",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/melbourne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-melmd-regent-theatre-15294:Square?wid=768&fit=constrain",
      "headline": "Discover Melbourne Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Melbourne, Australia your way! Explore restaurants, local attractions and things to do in your favorite Melbourne, Australia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bangkok",
      "country": "Thailand",
      "Beach": "80.0",
      "Culinary": "90",
      "Golf": "70",
      "Ski": "0",
      "Spa": "75",
      "Culture": "70",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/bangkok.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/wi-bkkwi-exterior-bts-day-time-13470:Square?wid=768&fit=constrain",
      "headline": "Bangkok Your Way: Eat, Explore, and Stay with Marriott",
      "description": "Visit Bangkok, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Bangkok, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cape Town",
      "country": "South Africa",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "0",
      "Spa": "70",
      "Culture": "70",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/cape-town.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aerial-vw-cape-std-33447-167001010058079:Square?wid=768&fit=constrain",
      "headline": "Discover Cape Town Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Cape Town, South Africa your way! Explore restaurants, local attractions and things to do in your favorite Cape Town, South Africa neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Los Angeles",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "85",
      "Golf": "80",
      "Ski": "50",
      "Spa": "70",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/los-angeles.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/griffith-park-los-angeles-california:Square?wid=768&fit=constrain",
      "headline": "Discover Baltimore Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Baltimore, MD your way! Explore restaurants, local attractions and more in your favorite Los Angeles neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Dubai",
      "country": "United Arab Emirates",
      "Beach": "80.0",
      "Culinary": "80",
      "Golf": "70",
      "Ski": "0",
      "Spa": "90",
      "Culture": "50",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/dubai.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jumeirah-mosque-snst69576-1670007351783-9:Square?wid=768&fit=constrain",
      "headline": "Discover Dubai Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Dubai, United Arab Emirates your way! Explore restaurants, local attractions and things to do in your favorite Dubai, United Arab Emirates neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Busan",
      "country": "Korea, Republic of",
      "Beach": "80.0",
      "Culinary": "70",
      "Golf": "60",
      "Ski": "0",
      "Spa": "50",
      "Culture": "60",
      "Music": "70",
      "pageUrl": "https://www.marriott.com/en/destinations/busan.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-kor-busan-173453637129827:Square?wid=768&fit=constrain",
      "headline": "Discover Busan Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Busan, South Korea your way! Explore restaurants, local attractions and things to do in your favorite Busan, South Korea neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Durban",
      "country": "South Africa",
      "Beach": "90.0",
      "Culinary": "70",
      "Golf": "60",
      "Ski": "0",
      "Spa": "50",
      "Culture": "60",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/durban.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-durban-173453775066744:Square?wid=768&fit=constrain",
      "headline": "Discover Durban Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Durban, South Africa your way! Explore restaurants, local attractions and things to do in your favorite Durban, South Africa neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Barcelona",
      "country": "Spain",
      "Beach": "90.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/barcelona.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-sagrat-cor-temple92601-1669848202478-2:Square?wid=768&fit=constrain",
      "headline": "Discover Barcelona Your Way with Marriott Bonvoy Stays",
      "description": "Visit Barcelona, Spain your way! Explore restaurants, local attractions and things to do in your favorite Barcelona, Spain neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Auckland",
      "country": "New Zealand",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/auckland.mi",
      "imageUrl": "https://cache.marriott.com/marriottassets/icons/mrw_default_profile_placeholder1.png",
      "headline": "Discover Auckland Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Auckland, New Zealand your way! Explore restaurants, local attractions and things to do in your favorite Auckland, New Zealand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Brisbane",
      "country": "Australia",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/brisbane.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/wh-bnewh-bonner-bridge-36497:Square?wid=768&fit=constrain",
      "headline": "Brisbane: Riverside Adventures, Urban Culture, and Mountaintop Views",
      "description": "Brisbane, with its warm climate and scenic riverside location, is a city that offers the perfect blend of natural beauty and urban charm. The Brisbane River winds its way through the city, providing stunning views and a variety of activities, from leisurely river cruises to adventurous kayaking. The city is home to many cultural attractions, including the Queensland Gallery of Modern Art and the State Library, which showcase the area's rich artistic and intellectual heritage. For those who enjoy the outdoors, the nearby Mount Coot-tha offers breathtaking panoramic views and picturesque hiking trails, while South Bank’s Parklands and the Wheel of Brisbane are ideal for a leisurely day of relaxation and fun."
    },
    {
      "city": "Da Nang",
      "country": "Viet Nam",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/da-nang.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-marriott-danang-39715:Square?wid=768&fit=constrain",
      "headline": "Da Nang: Where Sunlit Shores Meet Timeless Cultural Wonders",
      "description": "Da Nang is a bustling coastal city that artfully combines the allure of nature with the convenience of modern urban living. Its world-famous beaches, My Khe and Non Nuoc, are a haven for those seeking the sun and sea. As a city that opens doors to ancient marvels, such as the UNESCO World Heritage Site of Hoi An and the imperial city of Hue, Da Nang is the perfect launchpad for cultural discoveries. The city's culinary landscape, ranging from local street fare to upscale dining, promises to tantalize every taste bud. With its contemporary amenities, from the international airport to a well-connected public transit system, Da Nang ensures a smooth and enjoyable journey for all visitors."
    },
    {
      "city": "Mar del Plata",
      "country": "Argentina",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/mar-del-plata.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arg-mar-del-plata-345531456586597:Square?wid=768&fit=constrain",
      "headline": "Mar del Plata: Argentina’s Sparkling Pearl of the Atlantic",
      "description": "Mar Del Plata, often referred to as the \"Pearl of the Atlantic,\" is a coastal gem that combines the charm of a seaside resort with the vibrancy of a bustling city. Known for its stunning beaches, such as Playa Bristol and Playa Grande, this destination is a favorite for those seeking sun, sand, and relaxation. The city's elegant architecture, including the iconic Casino and the Grünbein Palace, adds a touch of glamour to the landscape. Whether you're exploring the lively boardwalk, enjoying fresh seafood at one of the many beachfront restaurants, or simply soaking up the atmosphere, Mar Del Plata offers a perfect blend of natural beauty and urban sophistication."
    },
    {
      "city": "San Diego",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/san-diego.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/old-point-loma-lighthouse-san-diego-california:Square?wid=768&fit=constrain",
      "headline": "San Diego: Wild Adventures, Historic Wonders, and Coastal Comfort",
      "description": "San Diego is a city that welcomes families, with the world-famous San Diego Zoo and SeaWorld offering both educational and thrilling experiences. The USS Midway Museum provides a unique look at naval history, and Little Italy is a food lover’s paradise, with authentic Italian cuisine and charming street markets. Whether you’re here for a company meeting or a leisurely vacation, our San Diego hotels ensure that you can enjoy everything the city has to offer with ease and style."
    },
    {
      "city": "Perth",
      "country": "Australia",
      "Beach": "80.0",
      "Culinary": "60",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "40",
      "pageUrl": "https://www.marriott.com/en/destinations/perth.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/cy-permc-rottnest-island-31064:Square?wid=768&fit=constrain",
      "headline": "Perth: Where Sunlit Shores Meet Sophisticated City Adventures",
      "description": "Perth, the sun-drenched coastal metropolis, is a city where natural beauty meets urban sophistication. With its stunning beaches, lush parks, and vibrant cultural scene, Perth offers a perfect blend of relaxation and adventure. The Swan River, a serene waterway that cuts through the heart of the city, provides endless opportunities for scenic walks, boat tours, and picnics. For those seeking a deeper connection with nature, the nearby Pinnacles and Margaret River are just a short drive away, offering breathtaking landscapes and world-class surfing. Whether you're a nature enthusiast, a foodie, or a history buff, Perth has something to captivate every visitor."
    },
    {
      "city": "Rio de Janeiro",
      "country": "Brazil",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/rio-de-janeiro.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bra-rio-de-janeiro-173453854225540:Square?wid=768&fit=constrain",
      "headline": "Discover Rio de Janeiro Your Way with Marriott Bonvoy",
      "description": "Visit Rio de Janeiro, Brazil your way! Explore restaurants, local attractions and things to do in your favorite Rio de Janeiro, Brazil neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sydney",
      "country": "Australia",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "70",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/sydney.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/mc-sydmc-sydney-harbour-skyline-30873:Square?wid=768&fit=constrain",
      "headline": "Unlock Sydney’s Best Neighborhoods with Marriott Bonvoy Stays",
      "description": "Visit Sydney, Australia your way! Explore restaurants, local attractions and things to do in your favorite Sydney, Australia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Jacksonville",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "1",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/jacksonville.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/skyline-city-jacksonville-florida:Square?wid=768&fit=constrain",
      "headline": "Jacksonville: Beaches, Trails, and Culture in One Vibrant Stay",
      "description": "For those who love the great outdoors, Jacksonville is the perfect place to be. You can spend a relaxing day at Jacksonville Beach or explore the hiking trails at the Timucuan Ecological and Historic Preserve. The city is also home to a vibrant arts and culture scene, with attractions like the Cummer Museum of Art & Gardens and the Jacksonville Symphony. Our hotels in Jacksonville come with modern amenities and exceptional service, making them the perfect choice for both business and leisure travelers. Whether you’re in town for a conference or a family vacation, we’ll make sure your stay is a memorable one."
    },
    {
      "city": "Kingston",
      "country": "Jamaica",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "50",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/kingston.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jam-kingston-998348525078006:Square?wid=768&fit=constrain",
      "headline": "Discover Kingston, Jamaica: Local Flavors, Sights, and Stays",
      "description": "Visit Kingston, Jamaica your way! Explore restaurants, local attractions and things to do in your favorite Kingston, Jamaica neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cartagena",
      "country": "Colombia",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/cartagena.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-col-cartagena-173453849689140:Square?wid=768&fit=constrain",
      "headline": "Discover Cartagena Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Cartagena, Colombia your way! Explore restaurants, local attractions and things to do in your favorite Cartagena, Colombia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Naples",
      "country": "Italy",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/naples-florida.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/beach-sunset-naples-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Naples, FL Your Way with Marriott Bonvoy",
      "description": "Visit Naples, FL your way! Explore restaurants, local attractions and things to do in your favorite Naples, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Athens",
      "country": "Greece",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/athens.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ga-athens-1734538306865-3:Square?wid=768&fit=constrain",
      "headline": "Discover Athens, GA Your Way with Marriott Bonvoy Stays",
      "description": "Visit Athens, GA your way! Explore restaurants, local attractions and things to do in your favorite Athens, GA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kota Kinabalu",
      "country": "Malaysia",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kota-kinabalu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-mys-kota-kinabalu-1734538530330-4:Square?wid=768&fit=constrain",
      "headline": "Kota Kinabalu: Where Tropical Adventure Meets Timeless Heritage",
      "description": "Kota Kinabalu, with its breathtaking coastline and rich cultural tapestry, is a tropical escape that beckons you to discover its natural beauty and storied past. The city is the perfect launchpad to Kinabalu Park, home to the iconic Mount Kinabalu, a must for any adventure-seeker. Or, opt for a more serene experience at Tunku Abdul Rahman Marine Park, where postcard-perfect beaches, clear waters, and fantastic snorkeling and diving spots await. Immerse yourself in the local way of life at the lively markets, like the Sunday Market, where you can savor local flavors and find handcrafted treasures. With a seamless blend of contemporary comforts and old-world allure, Kota Kinabalu is the ultimate haven for those who crave both nature and heritage."
    },
    {
      "city": "Santa Marta",
      "country": "Colombia",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-marta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-col-santa-marta-1734538101989-0:Square?wid=768&fit=constrain",
      "headline": "Santa Marta: Colonial Charm Meets Caribbean Beaches and Mountain Adventure",
      "description": "Nestled along the Caribbean coast, Santa Marta is a vibrant city that seamlessly blends colonial charm with modern amenities. The historic city center, with its cobblestone streets and pastel-colored buildings, invites visitors to step back in time and explore the legacy of its founding. Santa Marta is also a gateway to the stunning Sierra Nevada mountain range, offering breathtaking hikes and the chance to visit indigenous communities. The city's beaches, like Playa Blanca and Taganga, are perfect for relaxing and enjoying the warm, clear waters of the Caribbean."
    },
    {
      "city": "San Juan",
      "country": "Puerto Rico",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/san-juan.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pri-san-juan-231034152762676:Square?wid=768&fit=constrain",
      "headline": "San Juan Getaway: Beaches, Festivals, and Culture at Your Doorstep",
      "description": "Immerse yourself in the vibrant spirit of San Juan, where lively markets, pristine beaches and a calendar of cultural events await. The city’s rich arts scene and annual festivals, such as the San Juan Jazz Festival, add an extra layer of excitement. Our hotels in San Juan are equipped with modern amenities, including complimentary Wi-Fi and fitness centers, to keep you connected and refreshed. With a range of locations across the city, from the historic district to the beachfront, our hotels ensure you’re never far from the action."
    },
    {
      "city": "Gdansk",
      "country": "Poland",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/gdansk.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pol-gdansk-173454121993391:Square?wid=768&fit=constrain",
      "headline": "Discover Gdansk Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Gdansk, Poland your way! Explore restaurants, local attractions and things to do in your favorite Gdansk, Poland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Virginia Beach",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/virginia-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/historic-cavalier-hotel-beach-club-virginia-beach-virginia:Square?wid=768&fit=constrain",
      "headline": "Discover Virginia Beach Your Way with Marriott Bonvoy",
      "description": "Visit Virginia Beach, VA your way! Explore restaurants, local attractions and things to do in your favorite Virginia Beach, VA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Long Beach",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/long-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/long-beach-skyline-city-buildings-california-wesLGBWIgr.306800:Square?wid=768&fit=constrain",
      "headline": "Long Beach: Where City Energy Meets Laid-Back Beach Vibes",
      "description": "Long Beach is a dynamic coastal city that has it all. From the urban excitement of a bustling city center to the laid-back vibe of beachside living, Long Beach offers the best of both worlds. The city’s vibrant waterfront is home to the Queen Mary, a historic ocean liner turned hotel and attraction, as well as the Aquarium of the Pacific, where you can explore the wonders of the underwater world. The Pine Avenue Shopping District and the Shoreline Village offer a delightful mix of boutique shopping, dining, and entertainment, making it a perfect spot for both families and couples. Whether you're enjoying the sandy beaches, attending a festival at the Long Beach Convention Center, or exploring the artistic murals and street art, the city provides endless opportunities for memorable experiences."
    },
    {
      "city": "Miami",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Santos",
      "country": "Brazil",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/santos.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bra-santos-173453758766832:Square?wid=768&fit=constrain",
      "headline": "Savor Santos: Beaches, Bazaars, and Unforgettable Brazilian Flavors",
      "description": "Immerse yourself in the local culture with a visit to the Mercado Municipal, where the scent of freshly roasted coffee and the sight of colorful tropical fruits will take you to the heart of the region's culinary delights. For a day of leisure, the Praia do Embaré is a must-see, with its soft sands and clear waters perfect for sunbathing and swimming. Many of our hotels in Santos boast modern amenities such as fitness centers, complimentary Wi-Fi, and on-site dining, ensuring your stay is both convenient and enjoyable. Whether your visit is for business or pleasure, our hotels are designed to make your stay in Santos unforgettable."
    },
    {
      "city": "Tampa",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "1",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/tampa.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/downtown-tampa-florida:Square?wid=768&fit=constrain",
      "headline": "Tampa: Coastal Cool, Urban Culture, and Historic Heartbeat",
      "description": "Tampa, a city that effortlessly marries the allure of the coast with the sophistication of urban living. The waterfront, with its celebrated Tampa Riverwalk, is a focal point, linking cultural gems such as the Florida Aquarium and the Tampa Museum of Art. Sports enthusiasts will be in their element at the Raymond James Stadium and Amalie Arena, while those with a penchant for nature can immerse themselves in the nearby Hillsborough River State Park or opt for a boat tour to encounter the local wildlife. To step back in time and savor the city's rich history, a stroll through the historic district of Ybor City is a must, where the legacy of cigar manufacturing and the influence of Spanish, Cuban, and Italian immigrants are still palpable."
    },
    {
      "city": "Nice",
      "country": "France",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/nice.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/md-ncemd-pool-with-sea-view-16606-36184:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Nice: Sunlit Riviera Charm, Culture, and Coastal Color",
      "description": "Nice, the picturesque jewel of the French Riviera, is a city that effortlessly marries the allure of its historic roots with the vibrancy of a modern Mediterranean hub. The iconic Promenade des Anglais invites you to savor a leisurely stroll along the sun-kissed coastline, indulge in beachfront relaxation, or join the lively nocturnal scene. The Old Town, a tapestry of narrow cobblestone lanes, vividly hued façades, and bustling markets, beckons you to partake in its rich local culture and culinary delights. Whether you're captivated by the Matisse Museum, unwinding in the Jardin Albert I, or savoring a dish of freshly caught seafood and a classic Niçoise salad, Nice presents a diverse palette of experiences to satisfy every traveler's palate."
    },
    {
      "city": "Alicante",
      "country": "Spain",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "0",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/alicante.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/ds-alcds-lobby-25794:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Discover Alicante Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Alicante, Spain your way! Explore restaurants, local attractions and things to do in your favorite Alicante, Spain neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lisbon",
      "country": "Portugal",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/lisbon.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-lisbon-753951065845487:Square?wid=768&fit=constrain",
      "headline": "Discover Lisbon Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Lisbon, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Lisbon, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Corpus Christi",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "40",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "30",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/corpus-christi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/skyline-sailboat-corpus-christi-bay-texas:Square?wid=768&fit=constrain",
      "headline": "Discover Corpus Christi Your Way with Marriott Bonvoy Stays",
      "description": "Visit Corpus Christi, TX your way! Explore restaurants, local attractions and things to do in your favorite Corpus Christi, TX neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Honolulu",
      "country": "United States",
      "Beach": "100.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/honolulu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-hi-honolulu-173453529708227:Square?wid=768&fit=constrain",
      "headline": "Discover Honolulu Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Honolulu, HI your way! Explore restaurants, local attractions and things to do in your favorite Honolulu, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sousse",
      "country": "Tunisia",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/sousse.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tun-sousse-173453487877866:Square?wid=768&fit=constrain",
      "headline": "Sousse: Timeless Medina Charms Meet Sunlit Mediterranean Shores",
      "description": "Sousse is a bustling coastal city that effortlessly marries ancient history with contemporary allure. As one of the largest cities on the Mediterranean coast, it is home to a plethora of cultural gems, such as the UNESCO-listed Ribat, a medieval fortress that proudly showcases the city's rich heritage. The Old City, or Medina, with its maze-like streets and magnificent architecture, beckons you to journey back in time. Sousse is also a haven for water sports and beach enthusiasts, with its sun-kissed sands and clear waters creating the perfect backdrop for swimming and diving."
    },
    {
      "city": "Santa Cruz de Tenerife",
      "country": "Spain",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-cruz.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/hiking-coast-california-couple:Square?wid=768&fit=constrain",
      "headline": "Santa Cruz: Where Coastal Chill Meets Adventure and Charm",
      "description": "Santa Cruz is a coastal paradise that effortlessly marries natural splendor with a lively, relaxed atmosphere. Renowned for its breathtaking beaches, from the iconic Santa Cruz Beach Boardwalk to hidden coves, the city offers the perfect balance of tranquility and entertainment. The historic downtown is a treasure trove of unique shops, art galleries, and delightful dining experiences, while the nearby Santa Cruz Mountains beckon with their trails for hiking and mountain biking. Whether you're dreaming of a family retreat, a romantic escape, or a solo journey of discovery, the city's diverse attractions and activities promise something special for every visitor."
    },
    {
      "city": "Hurghada",
      "country": "Egypt",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/hurghada.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-egy-hurghada-173454037217226:Square?wid=768&fit=constrain",
      "headline": "Discover Hurghada Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hurghada, Egypt your way! Explore restaurants, local attractions and things to do in your favorite Hurghada, Egypt neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "George",
      "country": "South Africa",
      "Beach": "75.0",
      "Culinary": "25",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Southampton",
      "country": "United Kingdom",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "50",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/southampton.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-southampton-173453849694187:Square?wid=768&fit=constrain",
      "headline": "Southampton: Medieval Streets, Modern Arts, and Comfortably Stylish Stays",
      "description": "No trip to Southampton would be complete without a visit to the Old Town, where you can wander the medieval walls and cobbled streets. The city is also home to the Mayflower Theatre, which hosts a variety of performances, and the Southampton City Art Gallery, which showcases both local and international art. Whether you're here for business or leisure, our Southampton hotels offer a range of amenities, including free Wi-Fi, fitness centers and complimentary breakfast, to make your stay both comfortable and memorable."
    },
    {
      "city": "Batumi",
      "country": "Georgia",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/batumi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-geo-batumi-1734537735594-9:Square?wid=768&fit=constrain",
      "headline": "Discover Batumi Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Batumi, Georgia your way! Explore restaurants, local attractions and things to do in your favorite Batumi, Georgia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bournemouth",
      "country": "United Kingdom",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/bournemouth.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-bournemouth-173453485870780:Square?wid=768&fit=constrain",
      "headline": "Bournemouth: Golden Beaches, Lively Town, Timeless Seaside Charm",
      "description": "Bournemouth is the quintessential British seaside town, where natural beauty meets vibrant urban life. You'll find seven miles of golden sandy beaches and beautiful gardens, perfect for relaxation and outdoor activities. The historic Pier offers a traditional British coastal experience, while the town center, Bournemouth Square, is a hive of entertainment, shopping, and dining. With a variety of cultural events, festivals, and charming Victorian architecture, Bournemouth is a delightful mix of old and new, making it the perfect destination for both leisure and business travelers."
    },
    {
      "city": "Phu Quoc",
      "country": "Viet Nam",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/phu-quoc.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-vnm-phu-quoc-173453791369991:Square?wid=768&fit=constrain",
      "headline": "Discover Phu Quoc Your Way with Marriott Bonvoy Stays",
      "description": "Visit Phu Quoc, Vietnam your way! Explore restaurants, local attractions and things to do in your favorite Phu Quoc, Vietnam neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Fort Lauderdale",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/fort-lauderdale.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/canals-boat-fort-lauderdale-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Fort Lauderdale Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Fort Lauderdale, FL your way! Explore restaurants, local attractions and things to do in your favorite Fort Lauderdale, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Carolina",
      "country": "Puerto Rico",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/carolina-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/waterfront-boat-cape-fear-river-wilmington-north-carolina:Square?wid=768&fit=constrain",
      "headline": "Discover Carolina Beach Your Way with Marriott Bonvoy",
      "description": "Visit Carolina Beach, NC your way! Explore restaurants, local attractions and things to do in your favorite Carolina Beach, NC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Limassol",
      "country": "Cyprus",
      "Beach": "80.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "40",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/lima.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aerial-cliff-miraflore-719962736562470:Square?wid=768&fit=constrain",
      "headline": "Lima: Colonial Charm, Modern Flavor, Unforgettable Coastal Escape",
      "description": "Lima, a city of contrasts, harmoniously intertwines its rich colonial past with a dynamic modern present. The historic center, a UNESCO World Heritage site, is a treasure trove of ornate churches, grand plazas, and charming colonial architecture that beckon you to explore a bygone era. Culinary delights await at every turn, with Lima's innovative cuisine that marries traditional flavors with contemporary flair, a true haven for the food connoisseur. Whether you're strolling through bustling markets, indulging in ceviche at a chic eatery, or marveling at the art collection of the Larco Museum, Lima promises an experience that will linger in your memory."
    },
    {
      "city": "Split",
      "country": "Croatia",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/split.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-hrv-split-173453640645885:Square?wid=768&fit=constrain",
      "headline": "Discover Split, Croatia: Local Flavors, Hidden Gems, Marriott Comfort",
      "description": "Visit Split, Croatia your way! Explore restaurants, local attractions and things to do in your favorite Split, Croatia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Charleston",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/charleston-south-carolina.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/street-house-charleston-south-carolina:Square?wid=768&fit=constrain",
      "headline": "Discover Charleston Your Way with Marriott Bonvoy Stays",
      "description": "Visit Charleston, SC your way! Explore restaurants, local attractions and things to do in your favorite Charleston, SC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hampton",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hampton.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-va-hampton-629357764479958:Square?wid=768&fit=constrain",
      "headline": "Discover Hampton, VA Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hampton, VA your way! Explore restaurants, local attractions and things to do in your favorite Hampton, VA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Ventura",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/ventura.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ventura-skyline-ocean-california:Square?wid=768&fit=constrain",
      "headline": "Discover Ventura Your Way: Eat, Explore, and Stay Bonvoy",
      "description": "Visit Ventura, CA your way! Explore restaurants, local attractions and things to do in your favorite Ventura, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "West Palm Beach",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/worth-avenue-palm-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Beach Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Palm Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Palm Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Rayong",
      "country": "Thailand",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/rayong.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/br-pyxbr-resort--aerial-17109-75170:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Rayong: Where Pristine Beaches Meet Relaxation and Adventure",
      "description": "Rayong is a city that has it all: natural beauty, a rich cultural scene, and a location that's perfect for those who want to relax and those who want to explore. The city is famous for its beautiful beaches, unspoiled national parks, and peaceful islands, which are a dream come true for beach bums and nature lovers. Our hotels in Rayong are the perfect place to stay, offering easy access to the city's top attractions and a peaceful place to rest your head. Many of our properties also offer premium amenities, like private pools and spa services, so you can relax and recharge after a day of adventure."
    },
    {
      "city": "Clearwater",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "1",
      "Spa": "1",
      "Culture": "25",
      "Music": "10",
      "pageUrl": "https://www.marriott.com/en/destinations/clearwater.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/shrimp-asparagus-seafood-dinner-ritzRKTRZre.833534_:Square?wid=768&fit=constrain",
      "headline": "Discover Clearwater Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Clearwater, FL your way! Explore restaurants, local attractions and things to do in your favorite Clearwater, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Aqaba",
      "country": "Jordan",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/aqaba.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jor-aqaba-173453634610226:Square?wid=768&fit=constrain",
      "headline": "Discover Aqaba Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Aqaba, Jordan your way! Explore restaurants, local attractions and things to do in your favorite Aqaba, Jordan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Santa Barbara",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-barbara.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/golf-course-goleta-california:Square?wid=768&fit=constrain",
      "headline": "Discover Santa Barbara Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Santa Barbara, CA your way! Explore restaurants, local attractions and things to do in your favorite Santa Barbara, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Phuket",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/phuket.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-hktmd-phuket-beach-sunset-37586-67997:Square?wid=768&fit=constrain",
      "headline": "Discover Phuket Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Phuket, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Phuket, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Fort Myers",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "20",
      "Music": "15",
      "pageUrl": "https://www.marriott.com/en/destinations/fort-myers.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/aerial-caloosahatchee-river-fort-myers-florida:Square?wid=768&fit=constrain",
      "headline": "Fort Myers: Wild Refuges, Island Adventures, and Oceanfront Bliss",
      "description": "Fort Myers is your gateway to the great outdoors, including the J.N. \"Ding\" Darling National Wildlife Refuge, where you can see a diverse range of wildlife and take in the beautiful scenery on walking trails. For those looking for a little more adventure, the nearby islands of Sanibel and Captiva are great for shelling, fishing, and boating. Many of our hotels offer amenities like private balconies with ocean views, poolside bars, and fitness centers, so you can make the most of your stay. With easy access to Southwest Florida International Airport and a variety of accommodations to suit every traveler, Fort Myers is ready to welcome you with open arms."
    },
    {
      "city": "Santa Cruz",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-cruz.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/hiking-coast-california-couple:Square?wid=768&fit=constrain",
      "headline": "Santa Cruz: Where Coastal Chill Meets Adventure and Charm",
      "description": "Santa Cruz is a coastal paradise that effortlessly marries natural splendor with a lively, relaxed atmosphere. Renowned for its breathtaking beaches, from the iconic Santa Cruz Beach Boardwalk to hidden coves, the city offers the perfect balance of tranquility and entertainment. The historic downtown is a treasure trove of unique shops, art galleries, and delightful dining experiences, while the nearby Santa Cruz Mountains beckon with their trails for hiking and mountain biking. Whether you're dreaming of a family retreat, a romantic escape, or a solo journey of discovery, the city's diverse attractions and activities promise something special for every visitor."
    },
    {
      "city": "Sarasota",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/sarasota.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/siesta-key-floriday-walking-path-beach:Square?wid=768&fit=constrain",
      "headline": "Sarasota Downtown: Bayside Stays, Shops, Culture, and Sunshine",
      "description": "In the heart of downtown Sarasota, you’ll find a vibrant city center with a variety of shops, galleries, and restaurants. The waterfront is a great place to stroll, with beautiful views of the bay and bustling marinas. If you’re looking for a more relaxing stay, our hotels offer amenities like free Wi-Fi, fitness centers, and poolside lounges. With locations near popular attractions like St. Armands Circle and the Sarasota Opera House, you’ll be close to the action and have easy access to everything this coastal city has to offer."
    },
    {
      "city": "Pensacola",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/pensacola.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/perdido-key-beach-pensacola-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Pensacola Your Way with Marriott Bonvoy Stays",
      "description": "Visit Pensacola, FL your way! Explore restaurants, local attractions and things to do in your favorite Pensacola, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Galveston",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/galveston.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/galveston-island-historic-pleasure-pier-galveston-florida:Square?wid=768&fit=constrain",
      "headline": "Galveston: Historic Charm Meets Sun‑Soaked Beach Adventure",
      "description": "Galveston is a unique beach town that combines the beauty of a historic coastal community with the excitement of a modern vacation destination. The city is famous for its beautiful beaches, which are perfect for sunbathing, swimming, and playing in the water. You can also explore the Strand Historic District, which is home to many 19th-century buildings that have been converted into shops, restaurants, and entertainment venues. The district is also a popular spot for events and festivals throughout the year, so there is always something fun to do in Galveston."
    },
    {
      "city": "Venice",
      "country": "Italy",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/venice.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-venice-416204426953302:Square?wid=768&fit=constrain",
      "headline": "Discover Venice Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Venice, Italy your way! Explore restaurants, local attractions and things to do in your favorite Venice, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Brighton",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/brighton.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-brighton-173453525190510:Square?wid=768&fit=constrain",
      "headline": "Discover Brighton Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Brighton, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Brighton, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Corfu",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/corfu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-corfu-173453640142985:Square?wid=768&fit=constrain",
      "headline": "Discover Corfu Your Way with Marriott Bonvoy Stays",
      "description": "Visit Corfu, Greece your way! Explore restaurants, local attractions and things to do in your favorite Corfu, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Panama City",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "50",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/panama-city-florida.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ocean-clouds-sunset-panama-city-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Panama City: Sun-Soaked Shores and Gulfside Getaways Await",
      "description": "Panama City is a bustling coastal destination that beckons you to savor the sunshine, discover the sands, and plunge into the pristine waters of the Gulf of Mexico. The city's picturesque beaches, from Panama City Beach to St. Andrews State Park, present a myriad of opportunities for leisure and excitement. Whether you seek to bask in the sun's glow, experience the thrill of parasailing, or simply take a leisurely stroll along the shore, Panama City caters to every type of traveler. With its warm welcome and an array of accommodations, it's the perfect launchpad for family retreats and romantic escapades."
    },
    {
      "city": "Krabi",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "10",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/krabi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tha-krabi-173453620013558:Square?wid=768&fit=constrain",
      "headline": "Krabi: Emerald Escapes, Limestone Cliffs, and Crystal Seas Await",
      "description": "Krabi is a tropical paradise that captivates with its stunning natural beauty and serene atmosphere. The city is flanked by emerald rice fields and lush mangrove forests, offering a tranquil escape for those seeking a peaceful retreat. Its coastline boasts pristine beaches, crystal-clear waters, and dramatic limestone cliffs, making it a haven for beach lovers and adventure seekers alike. Whether you're planning a relaxing vacation or an active getaway, Krabi's diverse range of attractions, from the bustling night markets to the tranquil temples, ensures there's something for everyone."
    },
    {
      "city": "Key West",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/key-west.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastal-homes-key-west-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Key West Your Way with Marriott Bonvoy Stays",
      "description": "Visit Key West, FL your way! Explore restaurants, local attractions and more in your favorite Key West neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Traverse City",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/traverse-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/boardman-river-traverse-city-michigan:Square?wid=768&fit=constrain",
      "headline": "Traverse City: Cherries, Shores, and Seasons of Pure Escape",
      "description": "Traverse City is a city that has it all, from its stunning natural landscapes to a rich cultural tapestry. As the \"Cherry Capital of the World,\" Traverse City is home to lush orchards and scenic vineyards, making it a haven for outdoor enthusiasts and food connoisseurs. The downtown area is a treasure trove of boutique shops, art galleries, and a lively farmers market. The crystal-clear waters of Grand Traverse Bay beckon with opportunities for boating, fishing, and swimming, while the nearby Sleeping Bear Dunes National Lakeshore is a wonder to behold with its majestic sand dunes and pristine beaches. Each season is a celebration, from the cherry blossom festivals in spring to the kaleidoscope of fall colors and the winter wonderland for snow sports."
    },
    {
      "city": "Carmel",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "1",
      "Spa": "50",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/carmel.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-in-carmel-173454023869485:Square?wid=768&fit=constrain",
      "headline": "Discover Carmel, IN Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Carmel, IN your way! Explore restaurants, local attractions and things to do in your favorite Carmel, IN neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Mlini",
      "country": "Croatia",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/mlini.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-hrv-mlini-173452972436820:Square?wid=768&fit=constrain",
      "headline": "Discover Mlini, Croatia: Craft Your Perfect Coastal Getaway",
      "description": "Visit Mlini, Croatia your way! Explore restaurants, local attractions and things to do in your favorite Mlini, Croatia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Monterey",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "80",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "70",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/monterey.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/old-fishermans-wharf-monterey-california-dock:Square?wid=768&fit=constrain",
      "headline": "Discover Monterey Your Way with Marriott Bonvoy Stays",
      "description": "Visit Monterey, CA your way! Explore restaurants, local attractions and things to do in your favorite Monterey, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "St George's",
      "country": "Bermuda",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Uluwatu Bali",
      "country": "Indonesia",
      "Beach": "100.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Holbox",
      "country": "Mexico",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/holbox.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-mex-holbox-173454104701111:Square?wid=768&fit=constrain",
      "headline": "Discover Holbox, Mexico Your Way with Marriott Bonvoy",
      "description": "Visit Holbox, Mexico your way! Explore restaurants, local attractions and things to do in your favorite Holbox, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "El Segundo",
      "country": "USA",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/el-segundo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-el-segundo-173453619008597:Square?wid=768&fit=constrain",
      "headline": "Discover El Segundo: Local Flavor, Coastal Charm, Marriott Comfort",
      "description": "Visit El Segundo, CA your way! Explore restaurants, local attractions and things to do in your favorite El Segundo, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New Buffalo",
      "country": "USA",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/buffalo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ny-buffalo-173453844102758:Square?wid=768&fit=constrain",
      "headline": "Create Your Perfect Buffalo Getaway with Marriott Bonvoy",
      "description": "Visit Buffalo, NY your way! Explore restaurants, local attractions and things to do in your favorite Buffalo, NY neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "La Jolla",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/la-jolla.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-la-jolla-173453851716742:Square?wid=768&fit=constrain",
      "headline": "La Jolla: Oceanfront Flavors, Coastal Wonders, and Endless Relaxation",
      "description": "Whether you’re savoring fresh seafood at one of the many oceanfront restaurants or enjoying a day of golf at Torrey Pines, La Jolla’s diverse attractions cater to every interest. Many of our hotels offer amenities such as complimentary Wi-Fi, spa services, and fitness centers, making it easy to unwind and recharge after a day of exploration. For those looking to dive deeper into the city’s natural wonders, the Birch Aquarium and the La Jolla Ecological Reserve are must-visit destinations, providing a glimpse into the marine life and coastal ecosystems that make La Jolla truly special."
    },
    {
      "city": "Dar es Salaam",
      "country": "United Republic of Tanzania",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/dar-es-salaam.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tza-dar-es-salaam-173453498693672:Square?wid=768&fit=constrain",
      "headline": "Discover Dar es Salaam: Local Flavors, Sights & Stays with Marriott",
      "description": "Visit Dar es Salaam, Tanzania your way! Explore restaurants, local attractions and things to do in your favorite Dar es Salaam, Tanzania neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Costa Navarino",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/costa-navarino.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-costa-navarino-173453293708717:Square?wid=768&fit=constrain",
      "headline": "Discover Costa Navarino: Your Personalized Greek Getaway with Marriott",
      "description": "Visit Costa Navarino, Greece your way! Explore restaurants, local attractions and things to do in your favorite Costa Navarino, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Pattaya",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/pattaya.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tha-pattaya-173454121491934:Square?wid=768&fit=constrain",
      "headline": "Explore Pattaya Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Pattaya, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Pattaya, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Fuerteventura",
      "country": "Spain",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/ventura.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ventura-skyline-ocean-california:Square?wid=768&fit=constrain",
      "headline": "Discover Ventura Your Way: Eat, Explore, and Stay Bonvoy",
      "description": "Visit Ventura, CA your way! Explore restaurants, local attractions and things to do in your favorite Ventura, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Porto Cervo",
      "country": "Italy",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/porto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-porto-1734533917305-4:Square?wid=768&fit=constrain",
      "headline": "Discover Porto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Porto, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Porto, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lagos",
      "country": "Portugal",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/lagos-portugal.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/wi-faoaa-outdoor-pool-40024:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Discover Lagos, Portugal: Local Flavors, Coastal Charm, Marriott Comfort",
      "description": "Visit Lagos, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Lagos, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Key Largo",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/key-largo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pier-dock-ocean-florida-keys:Square?wid=768&fit=constrain",
      "headline": "Discover Key Largo Your Way with Marriott Bonvoy Stays",
      "description": "Visit Key Largo, FL your way! Explore restaurants, local attractions and things to do in your favorite Key Largo, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Daytona Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/daytona-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pier-dock-ocean-coast-daytona-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Unlock Daytona Beach: Eat, Explore, and Stay with Marriott",
      "description": "Visit Daytona Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Daytona Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bora Bora",
      "country": "French Polynesia",
      "Beach": "100.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/bora-bora.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pyf-bora-bora-230141600241362:Square?wid=768&fit=constrain",
      "headline": "Discover Bora Bora Your Way with Marriott Bonvoy Stays",
      "description": "Visit Bora Bora, French Polynesia your way! Explore restaurants, local attractions and things to do in your favorite Bora Bora, French Polynesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Marco Island",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/marco-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/tigertail-beach-marco-island-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Marco Island: Your Personalized Marriott Bonvoy Getaway",
      "description": "Visit Marco Island, FL your way! Explore restaurants, local attractions and things to do in your favorite Marco Island, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nha Trang",
      "country": "Vietnam",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/nha-trang.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-NhaTrang--24284-168917108711683:Square?wid=768&fit=constrain",
      "headline": "Nha Trang: Thrills, History, and Coastal Comfort for Everyone",
      "description": "Nha Trang is more than just a pretty face. It has a little something for everyone. History buffs will love the Long Son Pagoda and Po Nagar Cham Towers. Thrill-seekers can get their fix at the Dragon King Water Park or by exploring the diving spots in Nha Trang Bay. Our properties offer modern conveniences like free Wi-Fi, fitness centers, and family-friendly rooms, so you can enjoy your stay in comfort. Whether you’re here for a romantic getaway, a family vacation, or a business trip, Nha Trang’s diverse offerings and our exceptional service will make your stay one to remember."
    },
    {
      "city": "Coronado",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/coronado.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/sanci-grounds-7810:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Discover Coronado Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Coronado, CA your way! Explore restaurants, local attractions and things to do in your favorite Coronado, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Orange Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/orange-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-al-orange-beach-173453863873276:Square?wid=768&fit=constrain",
      "headline": "Discover Orange Beach Your Way with Marriott Bonvoy Stays",
      "description": "Visit Orange Beach, AL your way! Explore restaurants, local attractions and things to do in your favorite Orange Beach, AL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "St Thomas",
      "country": "Virgin Islands (US)",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/st-thomas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-vir-st-thomas-173453936179165:Square?wid=768&fit=constrain",
      "headline": "Discover St. Thomas Your Way with Marriott Bonvoy Stays",
      "description": "Visit St. Thomas, Virgin Islands (US) your way! Explore restaurants, local attractions and things to do in your favorite St. Thomas, Virgin Islands (US) neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Giardini Naxos",
      "country": "Italy",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/naxos.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-naxos-173453067867853:Square?wid=768&fit=constrain",
      "headline": "Discover Naxos Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Naxos, Greece your way! Explore restaurants, local attractions and things to do in your favorite Naxos, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hilton Head Island",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hilton-head-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/beach-hilton-head-south-carolina:Square?wid=768&fit=constrain",
      "headline": "Discover Hilton Head Island Your Way with Marriott Bonvoy",
      "description": "Visit Hilton Head Island, SC your way! Explore restaurants, local attractions and things to do in your favorite Hilton Head Island, SC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Mykonos",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/mykonos.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-mykonos-173454136693238:Square?wid=768&fit=constrain",
      "headline": "Mykonos Magic: Where Sunlit Streets Meet Aegean Nights",
      "description": "Mykonos, with its iconic windmills and pristine beaches, is a vibrant island that captures the essence of the Aegean Sea. Known for its lively nightlife and chic boutiques, the city offers a perfect blend of relaxation and excitement. Whether you're exploring the historic Little Venice district with its colorful buildings and seaside balconies, or enjoying the sun at one of the many stunning beaches, Mykonos ensures a memorable experience. The city's white-washed Cycladic architecture and charming cobblestone streets are a photographer’s dream, while its rich cultural heritage is evident in the numerous museums and archaeological sites."
    },
    {
      "city": "Newport Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/newport-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/newport-beach-pacific-ocean-aerial-dock:Square?wid=768&fit=constrain",
      "headline": "Newport Beach: Coastal Flavors, Luxe Stays, Unforgettable Ocean Views",
      "description": "Dining in Newport Beach is a culinary journey, with an array of restaurants serving fresh seafood and innovative dishes that reflect the city’s coastal influence. From cozy beachside cafes to upscale waterfront dining, you can find the perfect spot to enjoy a meal with stunning views. Whether you’re planning a romantic getaway, a family vacation, or a business trip, the hotels in Newport Beach are designed to cater to your every need, with features like complimentary Wi-Fi, fitness centers, and meeting spaces. With such a prime location, you’ll be just steps away from the best of what the city has to offer."
    },
    {
      "city": "Bali",
      "country": "Indonesia",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Miami Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bodrum",
      "country": "Türkiye",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/bodrum.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-bodrum-173454124540667:Square?wid=768&fit=constrain",
      "headline": "Discover Bodrum Your Way with Marriott Bonvoy Stays",
      "description": "Visit Bodrum, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Bodrum, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bal Harbour - Miami Beach",
      "country": "USA",
      "Beach": "95.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lihue - Kauai",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kauai.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastline-kauai-hawaii:Square?wid=768&fit=constrain",
      "headline": "Discover Kauai Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Kauai, HI your way! Explore restaurants, local attractions and things to do in your favorite Kauai, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "George Town",
      "country": "Penang, Malaysia",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Fort Myers Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/fort-myers.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/aerial-caloosahatchee-river-fort-myers-florida:Square?wid=768&fit=constrain",
      "headline": "Fort Myers: Wild Refuges, Island Adventures, and Oceanfront Bliss",
      "description": "Fort Myers is your gateway to the great outdoors, including the J.N. \"Ding\" Darling National Wildlife Refuge, where you can see a diverse range of wildlife and take in the beautiful scenery on walking trails. For those looking for a little more adventure, the nearby islands of Sanibel and Captiva are great for shelling, fishing, and boating. Many of our hotels offer amenities like private balconies with ocean views, poolside bars, and fitness centers, so you can make the most of your stay. With easy access to Southwest Florida International Airport and a variety of accommodations to suit every traveler, Fort Myers is ready to welcome you with open arms."
    },
    {
      "city": "Waikiki Beach",
      "country": "USA",
      "Beach": "95.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/waikiki.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-hi-waikiki-173453790867451:Square?wid=768&fit=constrain",
      "headline": "Waikiki Wonders: Culture, Creatures, and Comfort in Paradise",
      "description": "Waikiki is more than just a pretty face. It's a treasure trove of culture and history. Explore the marine life of the Pacific at the Waikiki Aquarium or take a walk on the wild side at the Honolulu Zoo. For a deeper dive into Hawaiian heritage, the Bishop Museum is a must-see, with its captivating exhibits on the islands' history and culture. Our Waikiki hotels are brimming with thoughtful amenities, from free Wi-Fi to fitness centers and complimentary breakfasts, to ensure your stay is enjoyable and stress-free. Whether you're here for romance, family fun, or business, our hotels' charm and exceptional service will make your visit truly unforgettable."
    },
    {
      "city": "Koh Samui",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "70",
      "Golf": "50",
      "Ski": "0",
      "Spa": "80",
      "Culture": "50",
      "Music": "40",
      "pageUrl": "https://www.marriott.com/en/destinations/koh-samui.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tha-koh-samui-173453461018165:Square?wid=768&fit=constrain",
      "headline": "Discover Koh Samui Your Way with Marriott Bonvoy Stays",
      "description": "Visit Koh Samui, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Koh Samui, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Jacksonville Beach",
      "country": "USA",
      "Beach": "85.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "30",
      "Music": "40",
      "pageUrl": "https://www.marriott.com/en/destinations/jacksonville.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/skyline-city-jacksonville-florida:Square?wid=768&fit=constrain",
      "headline": "Jacksonville: Beaches, Trails, and Culture in One Vibrant Stay",
      "description": "For those who love the great outdoors, Jacksonville is the perfect place to be. You can spend a relaxing day at Jacksonville Beach or explore the hiking trails at the Timucuan Ecological and Historic Preserve. The city is also home to a vibrant arts and culture scene, with attractions like the Cummer Museum of Art & Gardens and the Jacksonville Symphony. Our hotels in Jacksonville come with modern amenities and exceptional service, making them the perfect choice for both business and leisure travelers. Whether you’re in town for a conference or a family vacation, we’ll make sure your stay is a memorable one."
    },
    {
      "city": "Sandestin",
      "country": "USA",
      "Beach": "80.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "30",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/destin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ocean-beach-destin-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Destin Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Destin, FL your way! Explore restaurants, local attractions and things to do in your favorite Destin, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Goa",
      "country": "India",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/goa.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-goa-173453729314518:Square?wid=768&fit=constrain",
      "headline": "Discover Goa Your Way With Marriott Bonvoy Stays",
      "description": "Visit Goa, India your way! Explore restaurants, local attractions and things to do in your favorite Goa, India neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Delray Beach",
      "country": "USA",
      "Beach": "85.0",
      "Culinary": "60",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "30",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/delray-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/harbor-delray-beach-florida-boat:Square?wid=768&fit=constrain",
      "headline": "Discover Delray Beach: Gardens, Parks, and Coastal Adventures Await",
      "description": "To truly experience Delray Beach, you need to get outside and explore. The city is home to a number of parks and nature reserves, each offering a unique way to connect with the great outdoors. The Morikami Museum and Japanese Gardens are a local favorite, providing a peaceful place to relax and reflect. The Delray Beach Tennis Center is another popular spot, hosting a variety of events throughout the year. No matter which of our hotels in Delray Beach you choose, you'll find yourself in the perfect location to experience everything the city has to offer. Plus, with amenities like free Wi-Fi, on-site dining, and fitness centers, you'll have everything you need to make the most of your stay."
    },
    {
      "city": "Cebu",
      "country": "Philippines",
      "Beach": "80.0",
      "Culinary": "70",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "40",
      "pageUrl": "https://www.marriott.com/en/destinations/cebu-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-Cebu-PH-Beach-92198-168564756293135:Square?wid=768&fit=constrain",
      "headline": "Discover Cebu City Your Way with Marriott Bonvoy Stays",
      "description": "Visit Cebu City, Philippines your way! Explore restaurants, local attractions and things to do in your favorite Cebu City, Philippines neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Gulfport",
      "country": "USA",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/gulfport.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ms-gulfport-173453850718925:Square?wid=768&fit=constrain",
      "headline": "Gulfport: Where Sun‑Kissed Shores Meet Coastal Culture",
      "description": "Gulfport is a charming coastal city that perfectly captures the essence of the Gulf Coast lifestyle. Its stunning beaches and the glistening waters of the Gulf invite you to relax and enjoy a wide range of water activities, from leisurely sunbathing to exciting fishing trips. The Gulfport Beach Boardwalk is a must-see, offering a delightful stroll past vibrant shops, dining spots, and entertainment venues. History buffs will appreciate the beautifully restored Gulfport Union Station, a former railroad depot that now serves as a cultural and event hub, celebrating the city's heritage. Whether you seek a beachfront escape or a cultural adventure, Gulfport seamlessly blends the best of both worlds."
    },
    {
      "city": "Sharm El Sheikh",
      "country": "Egypt",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "0",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/sharm-el-sheikh.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-egy-sharm-el-sheikh-173447130965449:Square?wid=768&fit=constrain",
      "headline": "Sharm El Sheikh: Where Sunlit Serenity Meets Underwater Adventure",
      "description": "Sharm El Sheikh is a sun-drenched paradise that seamlessly blends natural beauty with world-class amenities. Known as the \"City of Peace,\" this coastal gem offers pristine beaches, crystal-clear waters, and a vibrant coral reef that is perfect for snorkeling and diving. The city’s luxury resorts and spas provide an idyllic setting for relaxation, while its bustling markets and high-end shopping areas cater to every taste. Whether you’re seeking a tranquil escape or an adrenaline-fueled adventure, Sharm El Sheikh’s diverse offerings ensure that every visit is memorable."
    },
    {
      "city": "Santa Monica",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-monica.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-santa-monica-173453526195035:Square?wid=768&fit=constrain",
      "headline": "Sun, Surf, and Style: Discover Electric Santa Monica",
      "description": "Santa Monica, with its world-famous pier and sun-soaked beaches, is the epitome of Southern Californian charm. The city's lively boardwalk, the Promenade, is a magnet for those seeking a vibrant scene, with its mix of unique shops, top-notch dining, and street performers creating an electric atmosphere. Just steps from the Pacific Ocean, the beach beckons for leisurely strolls, sun-soaked afternoons, or perhaps a bit of surfing. And if you're in the mood for a bit of culture, the downtown area is a treasure trove of art galleries, theaters, and museums."
    },
    {
      "city": "Daytona Beach Shores",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "25",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "10",
      "pageUrl": "https://www.marriott.com/en/destinations/daytona-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pier-dock-ocean-coast-daytona-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Unlock Daytona Beach: Eat, Explore, and Stay with Marriott",
      "description": "Visit Daytona Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Daytona Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Pattaya City",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/pattaya.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tha-pattaya-173454121491934:Square?wid=768&fit=constrain",
      "headline": "Explore Pattaya Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Pattaya, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Pattaya, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Myrtle Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "10",
      "pageUrl": "https://www.marriott.com/en/destinations/myrtle-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/boardwalk-north-myrtle-beach-south-carolina:Square?wid=768&fit=constrain",
      "headline": "Myrtle Beach: Golf Heaven, Cultural Gems, Unforgettable Stays Await",
      "description": "Myrtle Beach is a golfer’s paradise, with over 100 golf courses, each offering unique challenges and scenic views. The city also boasts a rich cultural scene, with museums, art galleries, and historical sites that provide a deeper understanding of its heritage. Whether you’re planning a family vacation, a romantic getaway, or a business trip, our hotels ensure that your experience in Myrtle Beach is nothing short of exceptional."
    },
    {
      "city": "Amelia Island",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "10",
      "pageUrl": "https://www.marriott.com/en/destinations/amelia-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/city-hall-fernandina-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Amelia Island Your Way with Marriott Bonvoy Stays",
      "description": "Visit Amelia Island, FL your way! Explore restaurants, local attractions and things to do in your favorite Amelia Island, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hua Hin",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hua-hin.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/hhqmr-pool-0043:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Discover Hua Hin Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hua Hin, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Hua Hin, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Surfers Paradise",
      "country": "Australia",
      "Beach": "100.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/ise.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-ise-173453726802789:Square?wid=768&fit=constrain",
      "headline": "Discover Ise Your Way: Stay, Savor, and Explore with Marriott",
      "description": "Visit Ise, Japan your way! Explore restaurants, local attractions and things to do in your favorite Ise, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Arta",
      "country": "Mallorca, Spain",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/jakarta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-jakarta-173453295716463:Square?wid=768&fit=constrain",
      "headline": "Discover Jakarta Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Jakarta, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Jakarta, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Atlantic City",
      "country": "USA",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/atlantic-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/marina-atlantic-city-new-jersey:Square?wid=768&fit=constrain",
      "headline": "Discover Atlantic City Your Way with Marriott Bonvoy Rewards",
      "description": "Visit Atlantic City, NJ your way! Explore restaurants, local attractions and things to do in your favorite Atlantic City, NJ neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Manhattan Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/manhattan-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-manhattan-beach-173453721276755:Square?wid=768&fit=constrain",
      "headline": "Manhattan Beach: Where Laid-Back Coastal Charm Meets Urban Sophistication",
      "description": "Manhattan Beach is a charming coastal town that effortlessly marries the allure of a small beach community with the elegance of a thriving coastal city. Its wide, sandy beaches and lively boardwalk attract beachgoers and water sports enthusiasts alike. The Strand, a picturesque bike path, offers stunning ocean vistas and is perfect for a leisurely stroll or invigorating bike ride. Just moments from the vibrant downtown area, you'll find an array of high-end boutiques, art galleries, and gourmet dining options, catering to those in search of both tranquility and urban energy."
    },
    {
      "city": "Fort Walton Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/fort-walton-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/beach-ocean-surfboards-fort-walton-florda:Square?wid=768&fit=constrain",
      "headline": "Fort Walton Beach: Emerald Waters, Sugar Sands, Endless Coastal Adventures",
      "description": "Fort Walton Beach is a coastal gem that artfully blends natural splendor with a lively community vibe. Its reputation for pristine, sugar-white sands and sparkling emerald waters make it an idyllic spot for both relaxation and water sports. The city's proud military heritage is on display at the Air Force Armament Museum, and the Gulfarium Marine Adventure Park offers an entertaining and educational experience for all ages. Whether you're in the mood for basking in the sun, immersing yourself in local culture, or partaking in outdoor adventures, Fort Walton Beach is your gateway to a memorable stay, complete with a warm welcome from the locals."
    },
    {
      "city": "Clearwater Beach",
      "country": "USA",
      "Beach": "100.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/clearwater.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/shrimp-asparagus-seafood-dinner-ritzRKTRZre.833534_:Square?wid=768&fit=constrain",
      "headline": "Discover Clearwater Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Clearwater, FL your way! Explore restaurants, local attractions and things to do in your favorite Clearwater, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Palm Beach",
      "country": "Aruba",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/worth-avenue-palm-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Beach Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Palm Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Palm Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paracas",
      "country": "Peru",
      "Beach": "80.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/paracas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-per-paracas-173453401761714:Square?wid=768&fit=constrain",
      "headline": "Design Your Perfect Paracas Getaway with Marriott Bonvoy",
      "description": "Visit Paracas, Peru your way! Explore restaurants, local attractions and things to do in your favorite Paracas, Peru neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Maui",
      "country": "USA",
      "Beach": "95.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/maui.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastline-rainbow-maui-hawaii-wesHNMWIls.708720:Square?wid=768&fit=constrain",
      "headline": "Discover Maui Your Way with Marriott Bonvoy Stays",
      "description": "Visit Maui, HI your way! Explore restaurants, local attractions and things to do in your favorite Maui, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Point Clear",
      "country": "USA",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/point-clear.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-al-point-clear-173453848127065:Square?wid=768&fit=constrain",
      "headline": "Point Clear: Coastal Adventure Days, Charming Gulf Coast Nights",
      "description": "For those who love the great outdoors, Point Clear is a dream destination. The city is surrounded by nature reserves and parks, offering a wide range of activities, from bird-watching to fishing and boating. After a day of adventure, you can relax at one of the city’s many charming restaurants or cafes, where you can enjoy the delicious flavors of the Gulf Coast. Our hotels in Point Clear offer a variety of accommodation options, from beachfront resorts to cozy inns, so you can find the perfect place to stay. We cater to all your needs, ensuring that your stay is as enjoyable as the city itself."
    },
    {
      "city": "Cabo San Lucas",
      "country": "Mexico",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/cabo-san-lucas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/el-arco-lovers-beach-cabo-san-lucas-mexico:Square?wid=768&fit=constrain",
      "headline": "Discover Cabo San Lucas Your Way with Marriott Bonvoy",
      "description": "Visit Cabo San Lucas, Mexico your way! Explore restaurants, local attractions and things to do in your favorite Cabo San Lucas, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Jekyll Island",
      "country": "USA",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/jekyll-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/dunes-jekyll-island-georgia:Square?wid=768&fit=constrain",
      "headline": "Discover Jekyll Island Your Way with Marriott Bonvoy",
      "description": "Visit Jekyll Island, GA your way! Explore restaurants, local attractions and things to do in your favorite Jekyll Island, GA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Ocean City",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/ocean-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ocean-city-beach-maryland:Square?wid=768&fit=constrain",
      "headline": "Discover Ocean City, MD Your Way with Marriott Bonvoy",
      "description": "Visit Ocean City, MD your way! Explore restaurants, local attractions and things to do in your favorite Ocean City, MD neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Pensacola Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/pensacola.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/perdido-key-beach-pensacola-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Pensacola Your Way with Marriott Bonvoy Stays",
      "description": "Visit Pensacola, FL your way! Explore restaurants, local attractions and things to do in your favorite Pensacola, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "St. Thomas",
      "country": "Virgin Islands (US)",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/st-thomas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-vir-st-thomas-173453936179165:Square?wid=768&fit=constrain",
      "headline": "Discover St. Thomas Your Way with Marriott Bonvoy Stays",
      "description": "Visit St. Thomas, Virgin Islands (US) your way! Explore restaurants, local attractions and things to do in your favorite St. Thomas, Virgin Islands (US) neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hilton Head",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hilton-head-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/beach-hilton-head-south-carolina:Square?wid=768&fit=constrain",
      "headline": "Discover Hilton Head Island Your Way with Marriott Bonvoy",
      "description": "Visit Hilton Head Island, SC your way! Explore restaurants, local attractions and things to do in your favorite Hilton Head Island, SC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kauai",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kauai.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastline-kauai-hawaii:Square?wid=768&fit=constrain",
      "headline": "Discover Kauai Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Kauai, HI your way! Explore restaurants, local attractions and things to do in your favorite Kauai, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Saint George",
      "country": "Grenada",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Santorini",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/santorini.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-santorini-587986249568062:Square?wid=768&fit=constrain",
      "headline": "Discover Santorini Your Way with Marriott Bonvoy Stays",
      "description": "Visit Santorini, Greece your way! Explore restaurants, local attractions and things to do in your favorite Santorini, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Elounda - Crete",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/crete.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-crete-151586342206659:Square?wid=768&fit=constrain",
      "headline": "Discover Crete Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Crete, Greece your way! Explore restaurants, local attractions and things to do in your favorite Crete, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Marina del Rey",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/marina-del-rey.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-marina-del-rey-173453723293971:Square?wid=768&fit=constrain",
      "headline": "Marina Del Rey: Coastal Charm Meets Urban Convenience",
      "description": "Take a stroll through the vibrant local scene at Fisherman's Village, a charming waterfront promenade with an array of shops, restaurants, and entertainment options. For a more laid-back experience, explore the city's beautiful beaches and parks. Many of our hotels offer amenities like free Wi-Fi, fitness centers, and on-site dining to make your stay comfortable and convenient. Whether you're visiting for business or pleasure, Marina Del Rey's unique blend of coastal beauty and city conveniences is sure to make your stay a memorable one."
    },
    {
      "city": "Oceanside",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/oceanside.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-oceanside-173453463528540:Square?wid=768&fit=constrain",
      "headline": "Oceanside: Where Laid-Back Beach Vibes Meet City Energy",
      "description": "Oceanside is a coastal city that offers the perfect blend of beach town charm and big city amenities. With its iconic pier and beautiful beaches, Oceanside is the perfect place to relax and enjoy the sunshine. The city’s vibrant downtown area is home to a variety of shops, restaurants, and galleries, making it easy to find something to do. Whether you’re interested in surfing, fishing, or exploring the local history at the Pacific Marine Museum, Oceanside has something for everyone."
    },
    {
      "city": "Chania-Crete",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/crete.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-crete-151586342206659:Square?wid=768&fit=constrain",
      "headline": "Discover Crete Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Crete, Greece your way! Explore restaurants, local attractions and things to do in your favorite Crete, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Khao Lak",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/khao-lak.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/jw-hktkl-surfer-paradise-37288:Square?wid=768&fit=constrain",
      "headline": "Khao Lak: Serene Shores and Adventure in Tropical Paradise",
      "description": "Khao Lak is a peaceful coastal haven that strikes the perfect balance between relaxation and adventure. Its unspoiled beaches, verdant forests, and calm ambiance make it an ideal choice for those in search of a tranquil retreat. The city is graced with an array of luxurious resorts and spa sanctuaries, ensuring a revitalizing experience for every visitor. Whether you desire to bask on the soft sands of Khao Lak or to discover the vibrant coral reefs and aquatic life of the Similan and Surin Islands, this city is the idyllic backdrop for your tropical escape."
    },
    {
      "city": "Albufeira",
      "country": "Portugal",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/albufeira.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-albufeira-173453398046111:Square?wid=768&fit=constrain",
      "headline": "Discover Albufeira Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Albufeira, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Albufeira, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Rehoboth Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/rehoboth-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/beer-brewery-bartender-pint-stout:Square?wid=768&fit=constrain",
      "headline": "Rehoboth Beach: Laid-Back Boardwalk Bliss by the Sea",
      "description": "Rehoboth Beach is a charming coastal town, boasting wide sandy beaches and a delightful boardwalk. The city's laid-back vibe and family-friendly attractions make it a perfect spot for a quick escape or a longer holiday. Whether you're a thrill-seeker looking to surf the waves or prefer a leisurely beach day, the options are endless. Take a stroll along the iconic boardwalk, home to a variety of unique shops, dining spots, and entertainment venues. The city's dedication to preserving its natural beauty and rich history is evident in the pristine beaches and well-kept parks, providing a peaceful and rejuvenating experience for all."
    },
    {
      "city": "Cannes",
      "country": "France",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/cannes.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-cannes-144090374638627:Square?wid=768&fit=constrain",
      "headline": "Cannes Your Way: Discover, Dine & Stay with Marriott",
      "description": "Visit Cannes, France your way! Explore restaurants, local attractions and things to do in your favorite Cannes, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "",
      "country": "Antigua and Barbuda",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/dauphin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-al-dauphin-173453400254665:Square?wid=768&fit=constrain",
      "headline": "Dauphin Island: Where Coastal Relaxation Meets Living History & Nature",
      "description": "But there's more to Dauphin than just the beach. The city is rich in local culture and history. Visit the Fort Morgan Historic Site, a crucial military installation dating back to the Civil War. Or take a trip to the Dauphin Island Sea Lab for an educational experience that brings the marine world to life. For a more natural experience, the Audubon Bird Sanctuary is a must-see, with its beautiful trails and excellent birdwatching opportunities. Whether you're planning a family vacation, a romantic getaway, or a solo adventure, Dauphin’s unique blend of relaxation and discovery is sure to make your trip an unforgettable one."
    },
    {
      "city": "Panama City",
      "country": "Panama",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/panama-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/skyscrapers-skyline-buildings-panama-city:Square?wid=768&fit=constrain",
      "headline": "Discover Panama City Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Panama City, Panama your way! Explore restaurants, local attractions and things to do in your favorite Panama City, Panama neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Phu Quoc City",
      "country": "Vietnam",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/phu-quoc.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-vnm-phu-quoc-173453791369991:Square?wid=768&fit=constrain",
      "headline": "Discover Phu Quoc Your Way with Marriott Bonvoy Stays",
      "description": "Visit Phu Quoc, Vietnam your way! Explore restaurants, local attractions and things to do in your favorite Phu Quoc, Vietnam neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Curacao",
      "country": "Curacao",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/curacao.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-cuw-173447132991641:Square?wid=768&fit=constrain",
      "headline": "Curacao, Your Way: Discover Neighborhood Gems with Marriott Bonvoy",
      "description": "Visit Curacao your way! Explore restaurants, local attractions and things to do in your favorite Curacao neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paradise Island",
      "country": "Bahamas",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/ise.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-ise-173453726802789:Square?wid=768&fit=constrain",
      "headline": "Discover Ise Your Way: Stay, Savor, and Explore with Marriott",
      "description": "Visit Ise, Japan your way! Explore restaurants, local attractions and things to do in your favorite Ise, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cape Coral",
      "country": "USA",
      "Beach": "75.0",
      "Culinary": "25",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/cape-coral.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/gnocchi-italian-soup-pasta-lunch-dinner-mhrsMIAJTre.555526:Square?wid=768&fit=constrain",
      "headline": "Cape Coral: Where Waterfront Adventure Meets Natural Gulf Coast Beauty",
      "description": "Cape Coral is the ultimate destination for those who appreciate the marriage of natural beauty and waterfront leisure. With an extensive canal system, the city offers an unparalleled boating and fishing experience. The pristine beaches, such as the iconic Cape Coral Beach, are perfect for sunbathing, swimming, and relaxation. Cape Coral's charm extends to its many parks and nature preserves, including the J.N. \"Ding\" Darling National Wildlife Refuge, where you can observe a diverse array of wildlife and enjoy scenic trails. The city's vibrant community is reflected in its numerous events and festivals, making it a dynamic destination for travelers of all ages."
    },
    {
      "city": "Phuket Island",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/phuket.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-hktmd-phuket-beach-sunset-37586-67997:Square?wid=768&fit=constrain",
      "headline": "Discover Phuket Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Phuket, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Phuket, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paros",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/paros.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-paros-173453073398731:Square?wid=768&fit=constrain",
      "headline": "Discover Paros, Greece Your Way with Marriott Bonvoy",
      "description": "Visit Paros, Greece your way! Explore restaurants, local attractions and things to do in your favorite Paros, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Aruba",
      "country": "Aruba",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/aruba.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/downtown-island-oranjestad-aruba:Square?wid=768&fit=constrain",
      "headline": "Explore Aruba Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Aruba your way! Explore restaurants, local attractions and things to do in your favorite Aruba neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kapolei - Oahu",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/oahu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-surfers-waikiki-beach-668237464326125:Square?wid=768&fit=constrain",
      "headline": "Discover Oahu Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Oahu, HI your way! Explore restaurants, local attractions and things to do in your favorite Oahu, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Miramar Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/miramar-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-fl-miramar-beach-994507683841077:Square?wid=768&fit=constrain",
      "headline": "Miramar Beach: Emerald Waters, Sugar Sands, Endless Coastal Calm",
      "description": "Miramar Beach, a coastal haven, beckons with its tranquil and idyllic setting, perfect for those in search of a peaceful retreat. The city's pristine, sugar-white sands and sparkling emerald waters are a haven for beach enthusiasts and water sports aficionados alike. The natural beauty of the area is enhanced by a selection of luxurious resorts and quaint boutiques that grace the scenic boardwalk, offering the ideal mix of relaxation and discovery. Whether you're basking in the sun, taking a leisurely beachfront stroll, or exploring the wonders of the local marine life at the Gulfarium Marine Adventure Park, Miramar Beach has something to captivate every visitor."
    },
    {
      "city": "Palm Beach Shores",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/worth-avenue-palm-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Beach Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Palm Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Palm Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Carolina Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "25",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/carolina-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/waterfront-boat-cape-fear-river-wilmington-north-carolina:Square?wid=768&fit=constrain",
      "headline": "Discover Carolina Beach Your Way with Marriott Bonvoy",
      "description": "Visit Carolina Beach, NC your way! Explore restaurants, local attractions and things to do in your favorite Carolina Beach, NC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Zanzibar",
      "country": "United Republic of Tanzania",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/zanzibar.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tza-zanzibar-173453395536835:Square?wid=768&fit=constrain",
      "headline": "Discover Zanzibar Your Way with Marriott Bonvoy Stays",
      "description": "Visit Zanzibar, Tanzania your way! Explore restaurants, local attractions and things to do in your favorite Zanzibar, Tanzania neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "South Padre Island",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/south-padre-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/boardwalk-south-padre-island-texas:Square?wid=768&fit=constrain",
      "headline": "Discover South Padre Island: Dine, Play, Stay with Marriott",
      "description": "Visit South Padre Island, TX your way! Explore restaurants, local attractions and things to do in your favorite South Padre Island, TX neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Jeju-do",
      "country": "South Korea",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/jeju-do.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-kor-jeju-do-173453618505169:Square?wid=768&fit=constrain",
      "headline": "Your Jeju, Your Way: Explore More with Marriott Bonvoy",
      "description": "Visit Jeju-do, South Korea your way! Explore restaurants, local attractions and things to do in your favorite Jeju-do, South Korea neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Gulf Shores",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/gulf-shores.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/orange-beach-summer-gulf-shores-alabama:Square?wid=768&fit=constrain",
      "headline": "Discover Gulf Shores Your Way with Marriott Bonvoy Stays",
      "description": "Visit Gulf Shores, AL your way! Explore restaurants, local attractions and things to do in your favorite Gulf Shores, AL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "St. Croix",
      "country": "Virgin Islands (US)",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/st-croix.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-vir-st-croix-173454090621522:Square?wid=768&fit=constrain",
      "headline": "Discover St. Croix Your Way with Marriott Bonvoy Stays",
      "description": "Visit St Croix, Virgin Islands (US) your way! Explore restaurants, local attractions and things to do in your favorite St Croix, Virgin Islands (US) neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cascais",
      "country": "Portugal",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/cascais.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-cascais-173453423662064:Square?wid=768&fit=constrain",
      "headline": "Cascais: Timeless Portuguese Charm Meets Chic Seaside Escape",
      "description": "Cascais is a sun-soaked coastal gem that effortlessly marries the allure of a traditional Portuguese town with the elegance of a contemporary seaside escape. Renowned for its immaculate beaches, from the intimate Praia da Rainha to the windswept expanse of Praia do Guincho, it beckons to both sun-worshippers and aquatic adventurers. The historic heart of the city, with its cobbled streets and pastel-hued facades, is a walking tour of pure delight, while the lively marina and vibrant market offer a glimpse into local life. For the culture seeker, the galleries and museums, including the esteemed Cultural Center of Cascais, are a treasure trove of art and history."
    },
    {
      "city": "Treasure Island",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/treasure-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/seashells-shells-star-fish-beach-souvenir:Square?wid=768&fit=constrain",
      "headline": "Design Your Perfect Getaway in Treasure Island, Florida",
      "description": "Visit Treasure Island, FL your way! Explore restaurants, local attractions and things to do in your favorite Treasure Island, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sopot",
      "country": "Poland",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/sopot.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pol-sopot-173453642150010:Square?wid=768&fit=constrain",
      "headline": "Discover Sopot Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Sopot, Poland your way! Explore restaurants, local attractions and things to do in your favorite Sopot, Poland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nha Trang City",
      "country": "Vietnam",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "75",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/nha-trang.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-NhaTrang--24284-168917108711683:Square?wid=768&fit=constrain",
      "headline": "Nha Trang: Thrills, History, and Coastal Comfort for Everyone",
      "description": "Nha Trang is more than just a pretty face. It has a little something for everyone. History buffs will love the Long Son Pagoda and Po Nagar Cham Towers. Thrill-seekers can get their fix at the Dragon King Water Park or by exploring the diving spots in Nha Trang Bay. Our properties offer modern conveniences like free Wi-Fi, fitness centers, and family-friendly rooms, so you can enjoy your stay in comfort. Whether you’re here for a romantic getaway, a family vacation, or a business trip, Nha Trang’s diverse offerings and our exceptional service will make your stay one to remember."
    },
    {
      "city": "Palm Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/worth-avenue-palm-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Beach Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Palm Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Palm Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Newport Coast",
      "country": "USA",
      "Beach": "85.0",
      "Culinary": "60",
      "Golf": "70",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/newport.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/newport-rhode-island-mansion-cliff:Square?wid=768&fit=constrain",
      "headline": "Discover Newport, RI Your Way with Marriott Bonvoy",
      "description": "Visit Newport, RI your way! Explore restaurants, local attractions and things to do in your favorite Newport, RI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Panama City Beach",
      "country": "USA",
      "Beach": "100.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "30",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/panama-city-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/beach-path-sunrish-sunset-panama-city-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Panama City Beach Your Way with Marriott Bonvoy",
      "description": "Visit Panama City Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Panama City Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Dana Point",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "60",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "40",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/dana-point.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-dana-point-173453469866690:Square?wid=768&fit=constrain",
      "headline": "Discover Dana Point Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Dana Point, CA your way! Explore restaurants, local attractions and things to do in your favorite Dana Point, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "La Altagracia",
      "country": "Dominican Republic",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/agra.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-agra-173447132490696:Square?wid=768&fit=constrain",
      "headline": "Agra: Timeless Taj, Majestic Forts, Echoes of Mughal Grandeur",
      "description": "Agra, a city steeped in history and culture, is an essential stop for any traveler seeking to experience the grandeur of India’s past. The city is crowned by the majestic Taj Mahal, a UNESCO World Heritage site and one of the most recognizable buildings in the world, which stands as a timeless symbol of love and architectural brilliance. Beyond the Taj, Agra is home to other significant landmarks such as the Agra Fort, a massive red sandstone fortress that once served as the main residence of the Mughal emperors, and the Fatehpur Sikri, an abandoned city that offers a glimpse into the opulence of the 16th century. Whether you’re a history buff, a culture enthusiast, or simply looking to capture the essence of a bygone era, Agra’s rich tapestry of sites and stories will leave you in awe."
    },
    {
      "city": "Belitung",
      "country": "Indonesia",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/belitung.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-belitung-1734539366808-0:Square?wid=768&fit=constrain",
      "headline": "Discover Belitung Your Way with Marriott Bonvoy Escapes",
      "description": "Visit Belitung, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Belitung, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "A Coruna",
      "country": "Spain",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "50",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/a-coruna.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-esp-a-coruna-173454069234710:Square?wid=768&fit=constrain",
      "headline": "A Coruña: Ancient Lighthouse Legends, Modern Coastal Vibes",
      "description": "A Coruna is a captivating coastal city where ancient history meets contemporary charm. Known for its stunning beaches, such as Riazor and Orzán, the city offers a perfect blend of relaxation and adventure. The Tower of Hercules, a UNESCO World Heritage Site and one of the oldest lighthouses in the world, stands as a testament to the city’s rich Roman heritage. Whether you’re exploring the vibrant Old Town with its narrow streets and historic landmarks or enjoying the modern amenities of the city’s shopping districts and restaurants, A Coruna ensures a diverse and enriching experience for every visitor."
    },
    {
      "city": "Kiawah Island",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "85",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kiawah-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-sc-kiawah-island-173454083152541:Square?wid=768&fit=constrain",
      "headline": "Discover Kiawah Island: Your Personalized Marriott Bonvoy Getaway",
      "description": "Visit Kiawah Island, SC your way! Explore restaurants, local attractions and things to do in your favorite Kiawah Island, SC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Seogwipo-si, jeju-do",
      "country": "South Korea",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/jeju-do.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-kor-jeju-do-173453618505169:Square?wid=768&fit=constrain",
      "headline": "Your Jeju, Your Way: Explore More with Marriott Bonvoy",
      "description": "Visit Jeju-do, South Korea your way! Explore restaurants, local attractions and things to do in your favorite Jeju-do, South Korea neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lahaina - Maui",
      "country": "USA",
      "Beach": "100.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/maui.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastline-rainbow-maui-hawaii-wesHNMWIls.708720:Square?wid=768&fit=constrain",
      "headline": "Discover Maui Your Way with Marriott Bonvoy Stays",
      "description": "Visit Maui, HI your way! Explore restaurants, local attractions and things to do in your favorite Maui, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sesimbra",
      "country": "Portugal",
      "Beach": "80.0",
      "Culinary": "60",
      "Golf": "25",
      "Ski": "0",
      "Spa": "30",
      "Culture": "50",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/sesimbra.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-sesimbra-173453464531541:Square?wid=768&fit=constrain",
      "headline": "Sesimbra: Portugal’s Secret Coastline of Cliffs, Castles and Calm",
      "description": "Sesimbra, a charming coastal town, is a well-kept secret that promises the perfect mix of serenity and excitement. Tucked away along the Atlantic coast, its allure lies in the unspoiled beaches, clear waters, and striking cliffs that paint a mesmerizing picture. Bask in the sun at Praia do Ginjal or journey back in time at the Sesimbra Castle, an emblem of the town's storied past. The lively marina beckons fishing and sailing aficionados, while the nearby Arrábida Natural Park is a playground for hikers and nature lovers. Whether you're dreaming of a peaceful retreat or an action-packed getaway, Sesimbra's array of offerings and warm welcome will ensure a stay to remember."
    },
    {
      "city": "Legian Bali",
      "country": "Indonesia",
      "Beach": "90.0",
      "Culinary": "70",
      "Golf": "25",
      "Ski": "0",
      "Spa": "80",
      "Culture": "30",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Monte Carlo",
      "country": "Monaco",
      "Beach": "80.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "80",
      "Culture": "50",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/monte-carlo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-mco-monte-carlo-173452968420014:Square?wid=768&fit=constrain",
      "headline": "Explore Monte-Carlo Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Monte-Carlo, Monaco your way! Explore restaurants, local attractions and things to do in your favorite Monte-Carlo, Monaco neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Rhodes",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/rhodes.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-rhodes-173453775566454:Square?wid=768&fit=constrain",
      "headline": "Discover Rhodes, Greece: Local Flavors, Hidden Gems, Marriott Style",
      "description": "Visit Rhodes, Greece your way! Explore restaurants, local attractions and things to do in your favorite Rhodes, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "George Town",
      "country": "Pulau Pinang",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Grand Cayman",
      "country": "Cayman Islands",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/grand-cayman.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-stingray-city-snorkeling-340616536073012:Square?wid=768&fit=constrain",
      "headline": "Discover Grand Cayman Your Way with Marriott Bonvoy Stays",
      "description": "Visit Grand Cayman, Cayman Islands your way! Explore restaurants, local attractions and things to do in your favorite Grand Cayman, Cayman Islands neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Destin/Miramar Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/destin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ocean-beach-destin-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Destin Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Destin, FL your way! Explore restaurants, local attractions and things to do in your favorite Destin, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Chania – Crete",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/crete.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-crete-151586342206659:Square?wid=768&fit=constrain",
      "headline": "Discover Crete Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Crete, Greece your way! Explore restaurants, local attractions and things to do in your favorite Crete, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Muang Phuket",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/phuket.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-hktmd-phuket-beach-sunset-37586-67997:Square?wid=768&fit=constrain",
      "headline": "Discover Phuket Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Phuket, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Phuket, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sifnos",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/sifnos.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-sifnos-173454139926520:Square?wid=768&fit=constrain",
      "headline": "Sifnos: Hidden Aegean Gem of Sun, Sea and Story",
      "description": "Sifnos is a well-kept secret in the Aegean, celebrated for its captivating white-washed villages and the mesmerizing azure waters that surround it. The island's main town, Apollonia, is a delightful labyrinth of narrow streets, adorned with the classic Cycladic architecture, inviting artisanal shops, and welcoming tavernas. You can choose to immerse yourself in the ancient history of Sifnos by visiting its well-preserved archaeological sites, like the Castle of Kastro and the Tower of Agios Andreas, or simply unwind on one of the many pristine beaches, such as Platis Gialos and Vathi. The island's rich cultural tapestry is further woven by its lively festivals and the genuine warmth of its people, making it the ideal destination for those in search of both relaxation and discovery."
    },
    {
      "city": "La Ciotat",
      "country": "France",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/la-ciotat.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-la-ciotat-173454023950592:Square?wid=768&fit=constrain",
      "headline": "La Ciotat: Sunlit Seaside Charm Meets Wild Calanques Adventure",
      "description": "La Ciotat is a charming coastal town that effortlessly marries the allure of a traditional Provencal village with the appeal of a Mediterranean resort. Its wide beaches and crystal-clear waters are an invitation to a peaceful seaside vacation. The vibrant old port, abuzz with the activity of local fishermen and a lively market, is a window into the town's rich maritime past. La Ciotat also serves as a gateway to the Calanques, a breathtaking series of fjord-like inlets and coves, ideal for outdoor activities like hiking, swimming, and boating. Whether you're meandering through the historic streets or enjoying a leisurely boat trip, the town's natural splendor and easygoing ambiance will captivate you."
    },
    {
      "city": "Seminyak Bali",
      "country": "Indonesia",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Destin",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/destin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ocean-beach-destin-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Destin Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Destin, FL your way! Explore restaurants, local attractions and things to do in your favorite Destin, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Southampton",
      "country": "Bermuda",
      "Beach": "90.0",
      "Culinary": "60",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "30",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/hampton.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-va-hampton-629357764479958:Square?wid=768&fit=constrain",
      "headline": "Discover Hampton, VA Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hampton, VA your way! Explore restaurants, local attractions and things to do in your favorite Hampton, VA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kolympia",
      "country": "Greece",
      "Beach": "80.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "30",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/olympia.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-wa-olympia-173454022945476:Square?wid=768&fit=constrain",
      "headline": "Discover Olympia Your Way: Neighborhood Flavors, Sights & Stays",
      "description": "Visit Olympia, WA your way! Explore restaurants, local attractions and things to do in your favorite Olympia, WA neighborhoods as a Marriott Bonvoy Hotel guest."
    }
  ],
  "culinary": [
    {
      "city": "Marseille",
      "country": "France",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/marseille.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-marseille-154256989765425:Square?wid=768&fit=constrain",
      "headline": "Discover Marseille Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Marseille, France your way! Explore restaurants, local attractions and things to do in your favorite Marseille, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "San Francisco",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/san-francisco.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-GettyImages-1133891066-359793688600498:Square?wid=768&fit=constrain",
      "headline": "San Francisco Adventures Await with Marriott Bonvoy Stays",
      "description": "Stay at a Marriott Bonvoy Hotel in San Francisco, CA, and enjoy easy access to Fisherman’s Wharf, the iconic Golden Gate Bridge, and endless adventures."
    },
    {
      "city": "Turin",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "50",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/turin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-turin-173453066862739:Square?wid=768&fit=constrain",
      "headline": "Turin Treasures: Markets, Chocolate, and Baroque City Magic",
      "description": "Immerse yourself in the local culture and traditions at the Shiny Market of Porta Palazzo, the largest open-air market in Europe, or treat yourself to some of the city’s famous chocolate at one of the many artisan shops. Many of our hotels offer amenities like free Wi-Fi, fitness centers, and on-site dining to help you make the most of your stay. Whether you’re visiting for business or pleasure, Turin’s mix of baroque architecture, modern art, and cutting-edge technology promises a memorable and enriching stay."
    },
    {
      "city": "Boston",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "25",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/boston.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/sailing-boats-charles-river-downtown-boston:Square?wid=768&fit=constrain",
      "headline": "Boston Bites, Sights, and Scenic Nights Await You",
      "description": "Boston’s culinary scene is also not to be missed. Savor everything from fresh seafood at the Quincy Market to world-class dining in the South End. With easy access to the city’s public transportation, you can effortlessly navigate to the Harvard University campus, explore the museums of the Back Bay, or enjoy the scenic views along the Charles River. No matter your interests, Boston’s diverse neighborhoods and attractions promise an unforgettable experience."
    },
    {
      "city": "Portland",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "25",
      "Spa": "50",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/portland-maine.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/portland-maine-coast-boats:Square?wid=768&fit=constrain",
      "headline": "Discover Portland, ME: Eat, Explore, and Stay with Marriott",
      "description": "Visit Portland, ME your way! Explore restaurants, local attractions and things to do in your favorite Portland, ME neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Memphis",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/memphis.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/downtown-memphis-aerial-skyline:Square?wid=768&fit=constrain",
      "headline": "Discover Memphis Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Memphis, TN your way! Explore restaurants, local attractions and things to do in your favorite Memphis, TN neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Las Vegas",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "25",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/las-vegas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/momofuku-couple-dining-las-vegas-nevada:Square?wid=768&fit=constrain",
      "headline": "Beyond the Strip: Las Vegas Adventures and Relaxing Hotel Retreats",
      "description": "But there’s more to Las Vegas than the Strip. The city is a gateway to outdoor adventure and natural beauty. Drive a short distance to explore the stunning Red Rock Canyon, hike in the Valley of Fire State Park, or take a day trip to the awe-inspiring Grand Canyon. Our hotels offer a peaceful retreat after a day of exploration, with spacious rooms, top-notch dining, and serene pools that provide a relaxing escape from the city’s energy. Whether you’re planning a romantic getaway, a family vacation, or a business trip, Las Vegas has something for everyone, and our hotels are here to make your stay unforgettable."
    },
    {
      "city": "Sapporo",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "90",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/sapporo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-sapporo-173453757260135:Square?wid=768&fit=constrain",
      "headline": "Sapporo Seasons: Snow Sculptures, City Lights, Culture in Bloom",
      "description": "Sapporo, the dynamic capital of Hokkaido, is a city that celebrates both its winter and summer seasons with equal fervor. The Sapporo Snow Festival, a world-renowned event, sees the city come alive with intricate ice sculptures and snow activities, drawing visitors from across the globe. But beyond this winter spectacle, Sapporo offers a rich cultural tapestry, with attractions like the Historical Village of Hokkaido and the Hokkaido Museum. The Sapporo Clock Tower stands as a testament to the city's heritage, while the modern amenities and vibrant atmosphere of the city make it an ideal gateway to the natural beauty that surrounds it, from the peaceful Maruyama Park to the lively shopping districts of Susukino and Odori."
    },
    {
      "city": "Beirut",
      "country": "Lebanon",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/beirut.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-lbn-beirut-1734535307137-5:Square?wid=768&fit=constrain",
      "headline": "Experience Beirut Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Beirut, Lebanon your way! Explore restaurants, local attractions and things to do in your favorite Beirut, Lebanon neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hamburg",
      "country": "Germany",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/hamburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-hamburg-173454132906462:Square?wid=768&fit=constrain",
      "headline": "Discover Hamburg Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hamburg, Germany your way! Explore restaurants, local attractions and things to do in your favorite Hamburg, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Abu Dhabi",
      "country": "United Arab Emirates",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/abu-dhabi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-are-abu-dhabi-173454035351045:Square?wid=768&fit=constrain",
      "headline": "Abu Dhabi Adventures: Culture, Coastlines, and High-Speed Thrills Await",
      "description": "Whether you’re strolling the lively markets along the Corniche, or exploring the world-famous Abu Dhabi Louvre, the city’s diverse attractions beckon. Our Abu Dhabi hotels cater to every type of traveler, whether you’re visiting for business or leisure. Enjoy free Wi-Fi, well-equipped fitness centers, and tempting dining options, ensuring a comfortable and memorable stay. Whether you’re here to experience the city’s vibrant arts scene, relax on a luxurious beach, or feel the excitement of the Formula 1 track at Yas Marina Circuit, our hotels provide the perfect base for an unforgettable adventure in Abu Dhabi."
    },
    {
      "city": "Budapest",
      "country": "Hungary",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/budapest.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-hun-budapest-173454024873448:Square?wid=768&fit=constrain",
      "headline": "Discover Budapest Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Budapest, Hungary your way! Explore restaurants, local attractions and things to do in your favorite Budapest, Hungary neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Vienna",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/vienna.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-vienna-173453913119285:Square?wid=768&fit=constrain",
      "headline": "Vienna: Imperial Splendor Meets Cutting-Edge Arts and Culture",
      "description": "Vienna, a city where the grandeur of baroque architecture meets the pulse of innovative art and culture, is a masterful blend of history and modernity. As the epicenter of classical music, it boasts the prestigious Vienna State Opera and the renowned Vienna Philharmonic, delivering world-class performances throughout the year. The city's imperial legacy is on display in its opulent palaces, from Schönbrunn to the Hofburg, offering a window into the lavish past of the Habsburg dynasty. Whether you're meandering through the verdant gardens of the Belvedere Palace or savoring a coffee in a traditional café, Vienna's allure and sophistication will enchant you at every step."
    },
    {
      "city": "Melbourne",
      "country": "Australia",
      "Beach": "75.0",
      "Culinary": "85",
      "Golf": "80",
      "Ski": "50",
      "Spa": "60",
      "Culture": "75",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/melbourne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-melmd-regent-theatre-15294:Square?wid=768&fit=constrain",
      "headline": "Discover Melbourne Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Melbourne, Australia your way! Explore restaurants, local attractions and things to do in your favorite Melbourne, Australia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bangkok",
      "country": "Thailand",
      "Beach": "80.0",
      "Culinary": "90",
      "Golf": "70",
      "Ski": "0",
      "Spa": "75",
      "Culture": "70",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/bangkok.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/wi-bkkwi-exterior-bts-day-time-13470:Square?wid=768&fit=constrain",
      "headline": "Bangkok Your Way: Eat, Explore, and Stay with Marriott",
      "description": "Visit Bangkok, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Bangkok, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cape Town",
      "country": "South Africa",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "0",
      "Spa": "70",
      "Culture": "70",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/cape-town.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aerial-vw-cape-std-33447-167001010058079:Square?wid=768&fit=constrain",
      "headline": "Discover Cape Town Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Cape Town, South Africa your way! Explore restaurants, local attractions and things to do in your favorite Cape Town, South Africa neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Los Angeles",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "85",
      "Golf": "80",
      "Ski": "50",
      "Spa": "70",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/los-angeles.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/griffith-park-los-angeles-california:Square?wid=768&fit=constrain",
      "headline": "Discover Baltimore Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Baltimore, MD your way! Explore restaurants, local attractions and more in your favorite Los Angeles neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Dubai",
      "country": "United Arab Emirates",
      "Beach": "80.0",
      "Culinary": "80",
      "Golf": "70",
      "Ski": "0",
      "Spa": "90",
      "Culture": "50",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/dubai.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jumeirah-mosque-snst69576-1670007351783-9:Square?wid=768&fit=constrain",
      "headline": "Discover Dubai Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Dubai, United Arab Emirates your way! Explore restaurants, local attractions and things to do in your favorite Dubai, United Arab Emirates neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Berlin",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "80",
      "Golf": "40",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/berlin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-berlin-173453772557748:Square?wid=768&fit=constrain",
      "headline": "Discover Berlin Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Berlin, Germany your way! Explore restaurants, local attractions and things to do in your favorite Berlin, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Barcelona",
      "country": "Spain",
      "Beach": "90.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/barcelona.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-sagrat-cor-temple92601-1669848202478-2:Square?wid=768&fit=constrain",
      "headline": "Discover Barcelona Your Way with Marriott Bonvoy Stays",
      "description": "Visit Barcelona, Spain your way! Explore restaurants, local attractions and things to do in your favorite Barcelona, Spain neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Manila",
      "country": "Philippines",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/manila.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-Manila-622377505928859-168330237401458:Square?wid=768&fit=constrain",
      "headline": "Discover Manila Your Way: Neighborhood Eats, Sights & Stays",
      "description": "Visit Manila, Philippines your way! Explore restaurants, local attractions and things to do in your favorite Manila, Philippines neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Philadelphia",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/philadelphia.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/river-skyline-philadelphia-pennsylvania:Square?wid=768&fit=constrain",
      "headline": "Discover Philadelphia Your Way with Marriott Bonvoy Stays",
      "description": "Visit Philadelphia, PA your way! Explore restaurants, local attractions and things to do in your favorite Philadelphia, PA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Auckland",
      "country": "New Zealand",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/auckland.mi",
      "imageUrl": "https://cache.marriott.com/marriottassets/icons/mrw_default_profile_placeholder1.png",
      "headline": "Discover Auckland Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Auckland, New Zealand your way! Explore restaurants, local attractions and things to do in your favorite Auckland, New Zealand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Stockholm",
      "country": "Sweden",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/stockholm.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-swe-stockholm-173453462024427:Square?wid=768&fit=constrain",
      "headline": "Stockholm Stays: Nordic Flavors, Scenic Walks, Effortless Connections",
      "description": "Dining in Stockholm is a culinary journey through Nordic flavors, with a range of Michelin-starred restaurants and cozy local eateries just steps away from many of our properties. For a relaxing day, head to one of the city’s beautiful parks, such as Djurgården, or take a stroll along the waterfront promenades. Business travelers will appreciate the modern conference facilities and free Wi-Fi, while leisure guests can enjoy complimentary breakfast and fitness centers. With easy access to the central train station and major airports, your stay in Stockholm will be as smooth and enjoyable as the city itself."
    },
    {
      "city": "Buenos Aires",
      "country": "Argentina",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/buenos-aires.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-centro-cultural-recoleta-485852901431222:Square?wid=768&fit=constrain",
      "headline": "Experience Buenos Aires Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Buenos Aires, Argentina your way! Explore restaurants, local attractions and things to do in your favorite Buenos Aires, Argentina neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Osaka",
      "country": "Japan",
      "Beach": "25.0",
      "Culinary": "85",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/osaka.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/rz-osarz-osaka-shinsaibashi-23169:Square?wid=768&fit=constrain",
      "headline": "Discover Osaka Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Osaka, Japan your way! Explore restaurants, local attractions and things to do in your favorite Osaka, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Chicago",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "85",
      "Golf": "75",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/chicago.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1065188752:Square?wid=768&fit=constrain",
      "headline": "Discover Chicago Your Way With Marriott Bonvoy Hotels",
      "description": "Visit Chicago, IL your way! Explore restaurants, local attractions and more in your favorite Chicago neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Dublin",
      "country": "Ireland",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/dublin.mi",
      "imageUrl": "https://cache.marriott.com/marriottassets/icons/mrw_default_profile_placeholder1.png",
      "headline": "Dublin Delights: Music, River Views & Unforgettable City Stays",
      "description": "Stroll the colorful streets of Temple Bar, where the sound of Irish music spills from the pubs, or take a leisurely walk along the River Liffey, soaking in the views and local life. Many of our hotels offer amenities like free Wi-Fi, on-site dining and fitness centers, ensuring your stay is as comfortable as it is memorable. Whether you’re in town for a business meeting or a leisurely getaway, Dublin’s diverse offerings, from historic castles to modern shopping districts, promise an unforgettable experience."
    },
    {
      "city": "Brussels",
      "country": "Belgium",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/brussels.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bel-brussels-1734540377219-8:Square?wid=768&fit=constrain",
      "headline": "Discover Brussels Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Brussels, Belgium your way! Explore restaurants, local attractions and things to do in your favorite Brussels, Belgium neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Da Nang",
      "country": "Viet Nam",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/da-nang.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-marriott-danang-39715:Square?wid=768&fit=constrain",
      "headline": "Da Nang: Where Sunlit Shores Meet Timeless Cultural Wonders",
      "description": "Da Nang is a bustling coastal city that artfully combines the allure of nature with the convenience of modern urban living. Its world-famous beaches, My Khe and Non Nuoc, are a haven for those seeking the sun and sea. As a city that opens doors to ancient marvels, such as the UNESCO World Heritage Site of Hoi An and the imperial city of Hue, Da Nang is the perfect launchpad for cultural discoveries. The city's culinary landscape, ranging from local street fare to upscale dining, promises to tantalize every taste bud. With its contemporary amenities, from the international airport to a well-connected public transit system, Da Nang ensures a smooth and enjoyable journey for all visitors."
    },
    {
      "city": "Austin",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/austin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/skyline-downtown-austin-texas:Square?wid=768&fit=constrain",
      "headline": "Discover Austin’s Vibe: Stay, Play, and Explore with Marriott",
      "description": "Stay at a Marriott Bonvoy Hotel in Austin, TX, and experience the city’s culture. Explore exceptional live music venues, Lady Bird Lake, and South Congress!"
    },
    {
      "city": "Rotterdam",
      "country": "Netherlands",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/rotterdam.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-nld-rotterdam-247789534125239:Square?wid=768&fit=constrain",
      "headline": "Discover Rotterdam: Neighborhood Adventures Await Marriott Bonvoy Guests",
      "description": "Visit Rotterdam, Netherlands your way! Explore restaurants, local attractions and things to do in your favorite Rotterdam, Netherlands neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Mar del Plata",
      "country": "Argentina",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/mar-del-plata.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arg-mar-del-plata-345531456586597:Square?wid=768&fit=constrain",
      "headline": "Mar del Plata: Argentina’s Sparkling Pearl of the Atlantic",
      "description": "Mar Del Plata, often referred to as the \"Pearl of the Atlantic,\" is a coastal gem that combines the charm of a seaside resort with the vibrancy of a bustling city. Known for its stunning beaches, such as Playa Bristol and Playa Grande, this destination is a favorite for those seeking sun, sand, and relaxation. The city's elegant architecture, including the iconic Casino and the Grünbein Palace, adds a touch of glamour to the landscape. Whether you're exploring the lively boardwalk, enjoying fresh seafood at one of the many beachfront restaurants, or simply soaking up the atmosphere, Mar Del Plata offers a perfect blend of natural beauty and urban sophistication."
    },
    {
      "city": "Manhattan",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "50",
      "Culture": "90",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/manhattan-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-manhattan-beach-173453721276755:Square?wid=768&fit=constrain",
      "headline": "Manhattan Beach: Where Laid-Back Coastal Charm Meets Urban Sophistication",
      "description": "Manhattan Beach is a charming coastal town that effortlessly marries the allure of a small beach community with the elegance of a thriving coastal city. Its wide, sandy beaches and lively boardwalk attract beachgoers and water sports enthusiasts alike. The Strand, a picturesque bike path, offers stunning ocean vistas and is perfect for a leisurely stroll or invigorating bike ride. Just moments from the vibrant downtown area, you'll find an array of high-end boutiques, art galleries, and gourmet dining options, catering to those in search of both tranquility and urban energy."
    },
    {
      "city": "Kyoto",
      "country": "Japan",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "50",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kyoto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/50464712-kyoto_destination_fushimi-inari-1:Square?wid=768&fit=constrain",
      "headline": "Discover Kyoto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Kyoto, Japan your way! Explore restaurants, local attractions and things to do in your favorite Kyoto, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kuala Lumpur",
      "country": "Malaysia",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kuala-lumpur.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/fp-kulfc-kulfc-splash-pool-6059-21502:Square?wid=768&fit=constrain",
      "headline": "Klang Valley: Where City Lights, Culture, and Calm Converge",
      "description": "The Klang Valley is where Malaysia’s capital energy comes alive — a vibrant region that blends cosmopolitan flair with cultural richness. From the dazzling skyline of Kuala Lumpur to the creative pulse of Petaling Jaya, the family-friendly charm of Puchong, the lifestyle scene of Setia Alam, and the serene beauty of Putrajaya, each destination invites exploration in its own way. Whether you're chasing city lights or peaceful escapes, the Klang Valley offers a dynamic mix of experiences for every kind of traveler."
    },
    {
      "city": "San Diego",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/san-diego.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/old-point-loma-lighthouse-san-diego-california:Square?wid=768&fit=constrain",
      "headline": "San Diego: Wild Adventures, Historic Wonders, and Coastal Comfort",
      "description": "San Diego is a city that welcomes families, with the world-famous San Diego Zoo and SeaWorld offering both educational and thrilling experiences. The USS Midway Museum provides a unique look at naval history, and Little Italy is a food lover’s paradise, with authentic Italian cuisine and charming street markets. Whether you’re here for a company meeting or a leisurely vacation, our San Diego hotels ensure that you can enjoy everything the city has to offer with ease and style."
    },
    {
      "city": "Guadalajara",
      "country": "Mexico",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/guadalajara.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-mex-guadalajara-173454107711087:Square?wid=768&fit=constrain",
      "headline": "Discover Guadalajara Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Guadalajara, Mexico your way! Explore restaurants, local attractions and things to do in your favorite Guadalajara, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Milan",
      "country": "Italy",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/milan.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-907949732-milan-italy-23312:Square?wid=768&fit=constrain",
      "headline": "Discover Milan Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Milan, Italy your way! Explore restaurants, local attractions and things to do in your favorite Milan, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Rome",
      "country": "Italy",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "100",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/rome.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-colosseum-amphitheatre-567863631375111:Square?wid=768&fit=constrain",
      "headline": "Discover Rome Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Rome, Italy your way! Explore restaurants, local attractions and things to do in your favorite Rome, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Houston",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/houston.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/gerald-d-hines-waterfall-park-arches-houston-texas:Square?wid=768&fit=constrain",
      "headline": "Discover Houston Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Houston, TX your way! Explore restaurants, local attractions and things to do in your favorite Houston, TX neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paris",
      "country": "France",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "100",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/paris.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arc-de-triomphe-paris-634207441403522:Square?wid=768&fit=constrain",
      "headline": "Discover Paris Your Way with Marriott Bonvoy Stays",
      "description": "Visit Paris, France your way! Explore restaurants, local attractions and more in your favorite Paris neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Shanghai",
      "country": "China",
      "Beach": "10.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/shanghai.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-Destination-Marketing-SH-476057048542497:Square?wid=768&fit=constrain",
      "headline": "Discover Shanghai Your Way with Marriott Bonvoy Stays",
      "description": "Visit Shanghai, China your way! Explore restaurants, local attractions and things to do in your favorite Shanghai, China neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Mumbai",
      "country": "India",
      "Beach": "60.0",
      "Culinary": "85",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "70",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/mumbai.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-chhatrapati-shivaji-12840-167045141964092:Square?wid=768&fit=constrain",
      "headline": "Discover Mumbai Your Way with Marriott Bonvoy Hotel Stays",
      "description": "Visit Mumbai, India your way! Explore restaurants, local attractions and things to do in your favorite Mumbai, India neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sao Paulo",
      "country": "Brazil",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/sao-paulo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ibirapuera-neighborhood-649944870849732:Square?wid=768&fit=constrain",
      "headline": "Sao Paulo Getaway: Art, Green Escapes, and Urban Style",
      "description": "Discover the vibrant arts and culture scene of Sao Paulo at the Pinacoteca or the Museu de Arte de Sao Paulo, or take a stroll through the greenery of Ibirapuera Park, an urban oasis. Many of our hotels offer amenities like complimentary Wi-Fi, fitness centers, and on-site dining, ensuring your stay is comfortable and convenient. From the historic downtown to the trendy Vila Madalena, our hotels provide the perfect gateway to experience the city’s unique blend of tradition and innovation."
    },
    {
      "city": "Seoul",
      "country": "Korea, Republic of",
      "Beach": "25.0",
      "Culinary": "80",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "70",
      "pageUrl": "https://www.marriott.com/en/destinations/seoul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-656494262-22627:Square?wid=768&fit=constrain",
      "headline": "Discover Seoul Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Seoul, South Korea your way! Explore restaurants, local attractions and things to do in your favorite Seoul, South Korea neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Tokyo",
      "country": "Japan",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "90",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/tokyo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/al-tyoal-asakusa-32531:Square?wid=768&fit=constrain",
      "headline": "Tokyo Tastemakers: Culture, Cuisine, and City Nights Await",
      "description": "Immerse yourself in Tokyo’s rich culture and Michelin-starred culinary scene. From the sushi bars of Tsukiji Outer Market to the trendy neighborhoods of Harajuku and Ginza, there’s something for every taste. Our hotels are the perfect starting point for your adventures, with many offering complimentary breakfast and evening events that capture the spirit of the city."
    },
    {
      "city": "Ho Chi Minh City",
      "country": "Viet Nam",
      "Beach": "50.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "60",
      "Music": "70",
      "pageUrl": "https://www.marriott.com/en/destinations/ho-chi-minh-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/si-sgnsi-hotel-prime-location-2-29347:Square?wid=768&fit=constrain",
      "headline": "Ho Chi Minh City: Where Timeless Traditions Meet Urban Energy",
      "description": "Ho Chi Minh City, a city that never sleeps, is a fascinating blend of old and new, where the traditions of Vietnamese culture meet the fast pace of modern city life. The city is a whirlwind of activity, with historic sites such as the War Remnants Museum and the Notre-Dame Cathedral, and modern landmarks like the city’s many skyscrapers and bustling markets. You can explore the intricate beauty of the Reunification Palace, take a leisurely stroll through the Botanical Gardens, or sample the city’s famous street food at one of the many vendors. Our hotels in Ho Chi Minh City are the perfect base for your urban adventure, offering a comfortable and convenient place to stay."
    },
    {
      "city": "London",
      "country": "United Kingdom",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "90",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/london.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-skyline-w-twr-brdg94263-167001018629978:Square?wid=768&fit=constrain",
      "headline": "Discover London Your Way with Marriott Bonvoy Hotels",
      "description": "Visit London, United Kingdom your way! Explore restaurants, local attractions and more in your favorite London neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New York City",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "85",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/nyc.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lower-manhattan-skyline-new-york-city-new-york:Square?wid=768&fit=constrain",
      "headline": "Experience New York City Your Way With Marriott Bonvoy",
      "description": "Visit New York City, NY your way! Explore restaurants, local attractions and more in your favorite New York City neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lima",
      "country": "Peru",
      "Beach": "25.0",
      "Culinary": "85",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "70",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/lima.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aerial-cliff-miraflore-719962736562470:Square?wid=768&fit=constrain",
      "headline": "Lima: Colonial Charm, Modern Flavor, Unforgettable Coastal Escape",
      "description": "Lima, a city of contrasts, harmoniously intertwines its rich colonial past with a dynamic modern present. The historic center, a UNESCO World Heritage site, is a treasure trove of ornate churches, grand plazas, and charming colonial architecture that beckon you to explore a bygone era. Culinary delights await at every turn, with Lima's innovative cuisine that marries traditional flavors with contemporary flair, a true haven for the food connoisseur. Whether you're strolling through bustling markets, indulging in ceviche at a chic eatery, or marveling at the art collection of the Larco Museum, Lima promises an experience that will linger in your memory."
    },
    {
      "city": "Rio de Janeiro",
      "country": "Brazil",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/rio-de-janeiro.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bra-rio-de-janeiro-173453854225540:Square?wid=768&fit=constrain",
      "headline": "Discover Rio de Janeiro Your Way with Marriott Bonvoy",
      "description": "Visit Rio de Janeiro, Brazil your way! Explore restaurants, local attractions and things to do in your favorite Rio de Janeiro, Brazil neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Singapore",
      "country": "Singapore",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "70",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/singapore.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/rz-sinrz-hotel-within-marina-bay-36470:Square?wid=768&fit=constrain",
      "headline": "Singapore: Where Urban Energy Meets Lush Tropical Escapes",
      "description": "Singapore is a city that’s not just about the urban jungle, but also about real jungles. The Singapore Zoo, Jurong Bird Park, and the Singapore Botanic Gardens are just a few of the green spots where you can relax and reconnect with nature. Our hotels in Singapore often have their own tranquil spaces, including rooftop pools and spas, perfect for unwinding after a day of exploration. With a wide range of deals and packages, we make it easy to enjoy the best of Singapore, from its bustling markets to its serene beaches, ensuring your visit is nothing short of extraordinary."
    },
    {
      "city": "Sydney",
      "country": "Australia",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "70",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/sydney.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/mc-sydmc-sydney-harbour-skyline-30873:Square?wid=768&fit=constrain",
      "headline": "Unlock Sydney’s Best Neighborhoods with Marriott Bonvoy Stays",
      "description": "Visit Sydney, Australia your way! Explore restaurants, local attractions and things to do in your favorite Sydney, Australia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Naples",
      "country": "Italy",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/naples-florida.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/beach-sunset-naples-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Naples, FL Your Way with Marriott Bonvoy",
      "description": "Visit Naples, FL your way! Explore restaurants, local attractions and things to do in your favorite Naples, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Genoa",
      "country": "Italy",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/genoa.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-genoa-173453074904827:Square?wid=768&fit=constrain",
      "headline": "Discover Genoa Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Genoa, Italy your way! Explore restaurants, local attractions and things to do in your favorite Genoa, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Baltimore",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/baltimore.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/harbor-boats-skyline-baltimore-maryland:Square?wid=768&fit=constrain",
      "headline": "Discover Baltimore Your Way with Marriott Bonvoy Stays",
      "description": "Visit Baltimore, MD your way! Explore restaurants, local attractions and things to do in your favorite Baltimore, MD neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Manchester",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/chester.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-chester-173453914624154:Square?wid=768&fit=constrain",
      "headline": "Discover Chester Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Chester, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Chester, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Shizuoka",
      "country": "Japan",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/izu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-izu-173453733344136:Square?wid=768&fit=constrain",
      "headline": "Discover Izu, Japan Your Way with Marriott Bonvoy",
      "description": "Visit Izu, Japan your way! Explore restaurants, local attractions and things to do in your favorite Izu, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nashville",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/nashville.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lower-broadway-nashville-tennessee:Square?wid=768&fit=constrain",
      "headline": "Discover Nashville Your Way with Marriott Bonvoy Stays",
      "description": "Visit Nashville, TN your way! Explore restaurants, local attractions and more in your favorite Nashville neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Athens",
      "country": "Greece",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/athens.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ga-athens-1734538306865-3:Square?wid=768&fit=constrain",
      "headline": "Discover Athens, GA Your Way with Marriott Bonvoy Stays",
      "description": "Visit Athens, GA your way! Explore restaurants, local attractions and things to do in your favorite Athens, GA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Amsterdam",
      "country": "Netherlands",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/amsterdam.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-1313361488-amsterdam-hero-10682:Square?wid=768&fit=constrain",
      "headline": "Discover Amsterdam Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Amsterdam, Netherlands your way! Explore restaurants, local attractions and things to do in your favorite Amsterdam, Netherlands neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Seattle",
      "country": "United States",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "50",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/seattle.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-Seattle-Destination-844280376200442:Square?wid=768&fit=constrain",
      "headline": "Discover Seattle Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Seattle, WA your way! Explore restaurants, local attractions and things to do in your favorite Seattle, WA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Baku",
      "country": "Azerbaijan",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/baku.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aze-baku-173453292196930:Square?wid=768&fit=constrain",
      "headline": "Discover Baku Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Baku, Azerbaijan your way! Explore restaurants, local attractions and things to do in your favorite Baku, Azerbaijan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Prague",
      "country": "Czech Republic",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/prague.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-cze-prague-801029132422535:Square?wid=768&fit=constrain",
      "headline": "Discover Prague Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Prague, Czech Republic your way! Explore restaurants, local attractions and things to do in your favorite Prague, Czech Republic neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Copenhagen",
      "country": "Denmark",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/copenhagen.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-dnk-copenhagen-173447135499986:Square?wid=768&fit=constrain",
      "headline": "Discover Copenhagen’s Best Neighborhoods with Marriott Bonvoy Stays",
      "description": "Visit Copenhagen, Denmark your way! Explore restaurants, local attractions and things to do in your favorite Copenhagen, Denmark neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Dallas",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "0",
      "Culture": "50",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/dallas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/city-skyline-buildings-office-downtown-dallas-texas:Square?wid=768&fit=constrain",
      "headline": "Discover Dallas Your Way with Marriott Bonvoy Hotel Stays",
      "description": "Visit Dallas, TX your way! Explore restaurants, local attractions and things to do in your favorite Dallas, TX neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Munich",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "80",
      "Golf": "50",
      "Ski": "0",
      "Spa": "0",
      "Culture": "80",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/munich.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-munich-173453527700652:Square?wid=768&fit=constrain",
      "headline": "Explore Munich Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Munich, Germany your way! Explore restaurants, local attractions and things to do in your favorite Munich, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Atlanta",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "1",
      "Spa": "25",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/atlanta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-Atlanta-Destination-358889675313710:Square?wid=768&fit=constrain",
      "headline": "Discover Atlanta Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Atlanta, GA your way! Explore restaurants, local attractions and things to do in your favorite Atlanta, GA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Toulouse",
      "country": "France",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/toulouse.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-toulouse-1734539156446-9:Square?wid=768&fit=constrain",
      "headline": "Discover Toulouse Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Toulouse, France your way! Explore restaurants, local attractions and things to do in your favorite Toulouse, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "San Juan",
      "country": "Puerto Rico",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/san-juan.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pri-san-juan-231034152762676:Square?wid=768&fit=constrain",
      "headline": "San Juan Getaway: Beaches, Festivals, and Culture at Your Doorstep",
      "description": "Immerse yourself in the vibrant spirit of San Juan, where lively markets, pristine beaches and a calendar of cultural events await. The city’s rich arts scene and annual festivals, such as the San Juan Jazz Festival, add an extra layer of excitement. Our hotels in San Juan are equipped with modern amenities, including complimentary Wi-Fi and fitness centers, to keep you connected and refreshed. With a range of locations across the city, from the historic district to the beachfront, our hotels ensure you’re never far from the action."
    },
    {
      "city": "Zurich",
      "country": "Switzerland",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/zurich.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-1267692130-zurich-hero-11029:Square?wid=768&fit=constrain",
      "headline": "Discover Zurich Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Zurich, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Zurich, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Utrecht",
      "country": "Netherlands",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/utrecht.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/ox-amsou-moxy-bike-2-33789:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Utrecht: Sustainable Innovation Meets Historic Canals and Culture",
      "description": "Utrecht is more than just a city with a rich history and a lot of culture. It is a modern city with a strong focus on sustainability and innovation. Utrecht is home to the largest university in the Netherlands and has a growing tech and business sector. This makes the city attractive for visitors and professionals. Whether you are in Utrecht for business or leisure, our hotels offer a great place to stay. Most of our hotels offer free Wi-Fi, fitness center and are close to the city’s main attractions. Visit the Oudegracht, the Rijksmuseum Volkenkunde or take a stroll through the city’s charming streets."
    },
    {
      "city": "Yogyakarta",
      "country": "Indonesia",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/yogyakarta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-yogyakarta-173453396038968:Square?wid=768&fit=constrain",
      "headline": "Discover Yogyakarta Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Yogyakarta, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Yogyakarta, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Florence",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/florence.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-florence-991758286415192:Square?wid=768&fit=constrain",
      "headline": "Discover Florence Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Florence, Italy your way! Explore restaurants, local attractions and things to do in your favorite Florence, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New Delhi",
      "country": "India",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/new-delhi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-new-delhi-173453713038356:Square?wid=768&fit=constrain",
      "headline": "Discover New Delhi Your Way with Marriott Bonvoy Hotels",
      "description": "Visit New Delhi, India your way! Explore restaurants, local attractions and things to do in your favorite New Delhi, India neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bristol",
      "country": "United Kingdom",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/bristol.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-bristol-1734535272004-7:Square?wid=768&fit=constrain",
      "headline": "Bristol: Where Historic Harbors, Street Art and Innovation Collide",
      "description": "Bristol, a city with a rich history and a contemporary vibe, is a place where creativity and heritage converge. Internationally recognized for its street art, which includes the enigmatic works of Banksy, Bristol's walls are a canvas of vibrant murals and graffiti, each telling a story of the city's journey. From the historic harborside, now a hub of chic bars, eateries, and shops, to the iconic Clifton Suspension Bridge, there's a wealth of sights to explore. The city's dedication to sustainability and innovation is evident in its green spaces, eco-friendly projects, and burgeoning tech sector, making it a compelling choice for all types of travelers."
    },
    {
      "city": "Kansas City",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/kansas-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/liberty-memorial-park-kansas-city:Square?wid=768&fit=constrain",
      "headline": "Discover Kansas City Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Kansas City, MO your way! Explore restaurants, local attractions and things to do in your favorite Kansas City, MO neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Miami",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Minneapolis",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "25",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/minneapolis.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/hamburger-fries-cheeese-burger-cyLHRCY.1063398:Square?wid=768&fit=constrain",
      "headline": "Minneapolis: Where Urban Energy Meets Lakeside Calm",
      "description": "Minneapolis is a city that effortlessly combines the thrill of urban living with the serenity of nature. Its lively arts scene is a testament to its cultural richness, with renowned institutions like the Walker Art Center and the Minneapolis Institute of Art waiting to captivate you with their diverse exhibits. For those who love the outdoors, the Chain of Lakes and the expansive Minneapolis Sculpture Garden offer scenic beauty and ample space for leisurely strolls. The city's dedication to sustainability and pedestrian-friendly spaces ensures that exploring is a delight, with bike paths and a comprehensive public transit system to take you to all the must-see spots."
    },
    {
      "city": "Bologna",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/bologna.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-bologna-173453460515988:Square?wid=768&fit=constrain",
      "headline": "Discover Bologna Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bologna, Italy your way! Explore restaurants, local attractions and things to do in your favorite Bologna, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New Orleans",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/new-orleans.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-NOLA-DESTINATION-260136935781775:Square?wid=768&fit=constrain",
      "headline": "Discover New Orleans Your Way with Marriott Bonvoy Stays",
      "description": "Visit New Orleans, LA your way! Explore restaurants, local attractions and more in your favorite New Orleans neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Doha",
      "country": "Qatar",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/doha.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-boat-along-city-coast-439523581653199:Square?wid=768&fit=constrain",
      "headline": "Discover Doha Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Doha, Qatar your way! Explore restaurants, local attractions and things to do in your favorite Doha, Qatar neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nice",
      "country": "France",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/nice.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/md-ncemd-pool-with-sea-view-16606-36184:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Nice: Sunlit Riviera Charm, Culture, and Coastal Color",
      "description": "Nice, the picturesque jewel of the French Riviera, is a city that effortlessly marries the allure of its historic roots with the vibrancy of a modern Mediterranean hub. The iconic Promenade des Anglais invites you to savor a leisurely stroll along the sun-kissed coastline, indulge in beachfront relaxation, or join the lively nocturnal scene. The Old Town, a tapestry of narrow cobblestone lanes, vividly hued façades, and bustling markets, beckons you to partake in its rich local culture and culinary delights. Whether you're captivated by the Matisse Museum, unwinding in the Jardin Albert I, or savoring a dish of freshly caught seafood and a classic Niçoise salad, Nice presents a diverse palette of experiences to satisfy every traveler's palate."
    },
    {
      "city": "Lyon",
      "country": "France",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/lyon.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-lyon-173453626543266:Square?wid=768&fit=constrain",
      "headline": "Discover Lyon Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Lyon, France your way! Explore restaurants, local attractions and things to do in your favorite Lyon, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lisbon",
      "country": "Portugal",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/lisbon.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-lisbon-753951065845487:Square?wid=768&fit=constrain",
      "headline": "Discover Lisbon Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Lisbon, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Lisbon, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Honolulu",
      "country": "United States",
      "Beach": "100.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/honolulu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-hi-honolulu-173453529708227:Square?wid=768&fit=constrain",
      "headline": "Discover Honolulu Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Honolulu, HI your way! Explore restaurants, local attractions and things to do in your favorite Honolulu, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bilbao",
      "country": "Spain",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bilbao.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-esp-bilbao-173454138699547:Square?wid=768&fit=constrain",
      "headline": "Discover Bilbao Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bilbao, Spain your way! Explore restaurants, local attractions and things to do in your favorite Bilbao, Spain neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bordeaux",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "10",
      "pageUrl": "https://www.marriott.com/en/destinations/bordeaux.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-bordeaux-173454025372459:Square?wid=768&fit=constrain",
      "headline": "Unlock Bordeaux’s Best Neighborhoods with Marriott Bonvoy Hotels",
      "description": "Visit Bordeaux, France your way! Explore restaurants, local attractions and things to do in your favorite Bordeaux, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Porto",
      "country": "Portugal",
      "Beach": "50.0",
      "Culinary": "80",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/porto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-porto-1734533917305-4:Square?wid=768&fit=constrain",
      "headline": "Discover Porto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Porto, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Porto, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Padova",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/padova.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-padova-173454141941118:Square?wid=768&fit=constrain",
      "headline": "Padova: Where Ancient Academia Meets Art, Science and Strolls",
      "description": "If you’re looking to soak up the city’s academic heritage, a visit to the University of Padova is a must. One of the oldest in the world, the university’s ancient halls and botanical gardens are a joy to explore. Padova is also a city of art and science, with the Prato della Valle, a large elliptical square surrounded by statues, being a particularly pleasant place for a stroll. Our hotels are conveniently located near these attractions, making them the perfect base for your business or leisure trip."
    },
    {
      "city": "Brescia",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/brescia.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-brescia-173454643106835:Square?wid=768&fit=constrain",
      "headline": "Brescia: Timeless History Meets Vibrant Lombard Style",
      "description": "Welcome to Brescia, a city that seamlessly intertwines its rich historical tapestry with the vibrant pulse of contemporary Italian life. As one of the most significant urban centers in the Lombardy region, Brescia proudly showcases several UNESCO World Heritage sites, including the ancient ruins of the Capitolium and the Tempio Capitolino, which are poignant reminders of the city's storied past. The Piazza della Loggia, with its stunning Renaissance architecture, is a testament to the city's appreciation of beauty and design. Brescia is also a gateway to the breathtaking natural landscapes of rolling hills and tranquil lakes, offering a perfect balance for travelers in search of both historical depth and scenic beauty."
    },
    {
      "city": "Ljubljana",
      "country": "Slovenia",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/ljubljana.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-svn-ljubljana-173453853723258:Square?wid=768&fit=constrain",
      "headline": "Discover Ljubljana: Eat, Explore, and Stay with Marriott Bonvoy",
      "description": "Visit Ljubljana, Slovenia your way! Explore restaurants, local attractions and things to do in your favorite Ljubljana, Slovenia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Fort Lauderdale",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/fort-lauderdale.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/canals-boat-fort-lauderdale-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Fort Lauderdale Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Fort Lauderdale, FL your way! Explore restaurants, local attractions and things to do in your favorite Fort Lauderdale, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Basel",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/basel.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-basel-173447133994326:Square?wid=768&fit=constrain",
      "headline": "Basel Bliss: Riverside Strolls, Green Escapes, and Cozy Stays",
      "description": "Stroll along the Rhine’s scenic banks, where boat tours, riverside promenades, and local markets await. The city’s dedication to green spaces is evident in its many parks and gardens, offering the perfect setting for a leisurely walk or a relaxing afternoon. Our hotels in Basel offer a variety of thoughtful amenities, including complimentary Wi-Fi, fitness centers, and free breakfast, to ensure your stay is as comfortable as it is memorable. With a range of locations from the city center to quieter residential areas, our hotels cater to every type of traveler, making it easy to experience the best of Basel."
    },
    {
      "city": "George Town",
      "country": "Malaysia",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Dijon",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/dijon.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-dijon-173453625541198:Square?wid=768&fit=constrain",
      "headline": "Discover Dijon Your Way: Savor, Explore, Stay with Marriott",
      "description": "Visit Dijon, France your way! Explore restaurants, local attractions and things to do in your favorite Dijon, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Savannah",
      "country": "United States",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/savannah.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/cocktail-bar-martini-glass-mhrsSJCSJre.383128:Square?wid=768&fit=constrain",
      "headline": "Discover Savannah Your Way with Marriott Bonvoy Stays",
      "description": "Visit Savannah, GA your way! Explore restaurants, local attractions and things to do in your favorite Savannah, GA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lausanne",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/lausanne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-lausanne-173453832692852:Square?wid=768&fit=constrain",
      "headline": "Lausanne: Olympic Spirit, Lakeside Charm, Timeless Swiss Allure",
      "description": "Lausanne, a city that effortlessly marries the past with the present, is a charming jewel perched on the shores of Lake Geneva. As the Olympic Capital, it is home to the International Olympic Committee and the Olympic Museum, a pilgrimage site for sports aficionados. The city's old town, with its labyrinth of cobblestone streets and medieval facades, is a window to history. Lausanne is also celebrated for its dynamic arts and culture scene, with a plethora of museums, galleries, and theaters showcasing local and international talent. Whether you're indulging in the delights of Swiss cuisine at a cozy bistro or taking in the sweeping vistas from the top of the Cathédrale Notre-Dame, there's a treasure to be found for every visitor."
    },
    {
      "city": "Charleston",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/charleston-south-carolina.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/street-house-charleston-south-carolina:Square?wid=768&fit=constrain",
      "headline": "Discover Charleston Your Way with Marriott Bonvoy Stays",
      "description": "Visit Charleston, SC your way! Explore restaurants, local attractions and things to do in your favorite Charleston, SC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bolzano",
      "country": "Italy",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "75",
      "Spa": "1",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/bolzano.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-bolzano-364815414850938:Square?wid=768&fit=constrain",
      "headline": "Bolzano: Where Italian Elegance Meets Alpine Innovation",
      "description": "Bolzano is a captivating blend of Italian elegance and Alpine charm, where the historic meets the contemporary in a seamless fusion. The city's old town, with its medieval architecture and vibrant market squares, is a living museum that invites visitors to step back in time. Yet, Bolzano is also a hub of innovation, known for its cutting-edge technology park and the South Tyrol Museum of Archaeology, home to the famous Ice Man, Ötzi. Whether you're exploring the city's cultural landmarks, shopping in its upscale boutiques, or savoring the local cuisine, Bolzano offers a unique and enriching experience."
    },
    {
      "city": "Boulder",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/boulder.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-co-boulder-173453291695185:Square?wid=768&fit=constrain",
      "headline": "Boulder: Where Rugged Flatirons Meet Vibrant City Life",
      "description": "Boulder is a city that’s both vibrant and visually stunning, nestled at the base of the Flatirons and offering a perfect mix of natural and urban appeal. Known for its active lifestyle and outdoor activities, the city has a variety of hiking trails, biking paths, and climbing opportunities for all skill levels. The iconic Boulder Creek Path meanders through the city, linking residents and visitors to parks, cafes, and cultural hotspots. As a center for innovation and learning, Boulder is home to a thriving tech sector and the University of Colorado, making it an exciting destination for both business and leisure travelers."
    },
    {
      "city": "Mendoza",
      "country": "Argentina",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "1",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/mendoza.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arg-mendoza-173453423159679:Square?wid=768&fit=constrain",
      "headline": "Discover Mendoza Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Mendoza, Argentina your way! Explore restaurants, local attractions and things to do in your favorite Mendoza, Argentina neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Asheville",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/asheville.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/band-voilin-drums-musicians-music-folk-blues:Square?wid=768&fit=constrain",
      "headline": "Asheville: Mountain Art Haven with Old-World Charm",
      "description": "Asheville, a city nestled in the Blue Ridge Mountains, is a place of vibrant culture and rich history. Known as the \"Paris of the South,\" it is home to a myriad of art galleries, craft breweries, and unique boutiques, making it a haven for those with a creative spirit. The historic Biltmore Estate, America’s largest privately-owned home, is a must-see, with its opulent rooms, extensive gardens, and award-winning winery. The downtown area, with its well-preserved Art Deco architecture, offers a unique blend of old-world charm and modern sophistication, where you can enjoy live music, street performances, and a diverse culinary scene."
    },
    {
      "city": "Santa Barbara",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-barbara.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/golf-course-goleta-california:Square?wid=768&fit=constrain",
      "headline": "Discover Santa Barbara Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Santa Barbara, CA your way! Explore restaurants, local attractions and things to do in your favorite Santa Barbara, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Santa Fe",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "85",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-fe.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/santa-fe-train-station-new-mexico:Square?wid=768&fit=constrain",
      "headline": "Discover Santa Fe Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Santa Fe, NM your way! Explore restaurants, local attractions and things to do in your favorite Santa Fe, NM neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Guadalajara",
      "country": "Spain",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/guadalajara.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-mex-guadalajara-173454107711087:Square?wid=768&fit=constrain",
      "headline": "Discover Guadalajara Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Guadalajara, Mexico your way! Explore restaurants, local attractions and things to do in your favorite Guadalajara, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Como",
      "country": "Italy",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/lake-como.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-lake-como-173453822550183:Square?wid=768&fit=constrain",
      "headline": "Discover Lake Como Your Way with Marriott Bonvoy Stays",
      "description": "Visit Lake Como, Italy your way! Explore restaurants, local attractions and things to do in your favorite Lake Como, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Toledo",
      "country": "Spain",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/toledo-spain.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-oh-toledo-spain-173452972938875:Square?wid=768&fit=constrain",
      "headline": "Discover Toledo Your Way with Marriott Bonvoy Stays",
      "description": "Visit Toledo, OH your way! Explore restaurants, local attractions and things to do in your favorite Toledo, OH neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Phuket",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/phuket.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-hktmd-phuket-beach-sunset-37586-67997:Square?wid=768&fit=constrain",
      "headline": "Discover Phuket Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Phuket, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Phuket, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lucca",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/lucca.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-lucca-228130211076355:Square?wid=768&fit=constrain",
      "headline": "Discover Lucca Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Lucca, Italy your way! Explore restaurants, local attractions and things to do in your favorite Lucca, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Napa",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/napa.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/napa-valley-vineyard-winery-california:Square?wid=768&fit=constrain",
      "headline": "Sip, Soar, and Savor: Napa’s Unforgettable Wine Country Escape",
      "description": "Napa is synonymous with world-class wine and culinary experiences, set against a backdrop of picturesque vineyards and rolling hills. This charming city is not only a haven for wine enthusiasts but also offers a plethora of outdoor activities, from hot air balloon rides over the valley to scenic hikes in the nearby mountains. Whether you're planning a romantic getaway, a family vacation, or a corporate retreat, Napa's hotels provide the perfect base to explore the city's renowned wineries, artisanal eateries, and cultural attractions."
    },
    {
      "city": "Venice",
      "country": "Italy",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/venice.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-venice-416204426953302:Square?wid=768&fit=constrain",
      "headline": "Discover Venice Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Venice, Italy your way! Explore restaurants, local attractions and things to do in your favorite Venice, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lima",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/lima.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aerial-cliff-miraflore-719962736562470:Square?wid=768&fit=constrain",
      "headline": "Lima: Colonial Charm, Modern Flavor, Unforgettable Coastal Escape",
      "description": "Lima, a city of contrasts, harmoniously intertwines its rich colonial past with a dynamic modern present. The historic center, a UNESCO World Heritage site, is a treasure trove of ornate churches, grand plazas, and charming colonial architecture that beckon you to explore a bygone era. Culinary delights await at every turn, with Lima's innovative cuisine that marries traditional flavors with contemporary flair, a true haven for the food connoisseur. Whether you're strolling through bustling markets, indulging in ceviche at a chic eatery, or marveling at the art collection of the Larco Museum, Lima promises an experience that will linger in your memory."
    },
    {
      "city": "Corfu",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/corfu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-corfu-173453640142985:Square?wid=768&fit=constrain",
      "headline": "Discover Corfu Your Way with Marriott Bonvoy Stays",
      "description": "Visit Corfu, Greece your way! Explore restaurants, local attractions and things to do in your favorite Corfu, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sintra",
      "country": "Portugal",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "90",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/sintra.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-sintra-173453463030965:Square?wid=768&fit=constrain",
      "headline": "Sintra: Fairytale Palaces Amid Lush, Enchanted Hills",
      "description": "Sintra is a city where history and nature blend seamlessly, creating a truly magical atmosphere. Known for its opulent palaces and castles, the city offers a glimpse into Portugal’s royal past, with each monument telling a story of its own. The colorful Pena Palace, perched atop a hill, is a must-visit, as is the mysterious Quinta da Regaleira, with its enigmatic symbols and underground tunnels. Sintra’s lush, verdant landscapes, including the Serra de Sintra, provide a serene backdrop for hiking and picnics, making it a perfect escape for those seeking natural beauty and tranquility."
    },
    {
      "city": "Key West",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/key-west.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastal-homes-key-west-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Key West Your Way with Marriott Bonvoy Stays",
      "description": "Visit Key West, FL your way! Explore restaurants, local attractions and more in your favorite Key West neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Aspen",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "90",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/aspen.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ski-snowmass-green-cabin-colorado:Square?wid=768&fit=constrain",
      "headline": "Aspen: Where Rocky Mountain Adventure Meets Luxury and Culture",
      "description": "Aspen is a year-round playground for the senses, combining world-class skiing, snowboarding and snowmobiling with a vibrant arts and culture scene, exciting nightlife, great restaurants and luxury accommodations. This historic mining town is surrounded by the majestic peaks of the Rocky Mountains and is a haven for outdoor enthusiasts with its beautiful hiking, mountain biking, horseback riding and whitewater rafting in the summer. Aspen is also a center for the arts, hosting the annual Aspen Music Festival and the Food & Wine Classic, as well as a number of high-end art galleries."
    },
    {
      "city": "Carmel",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "1",
      "Spa": "50",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/carmel.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-in-carmel-173454023869485:Square?wid=768&fit=constrain",
      "headline": "Discover Carmel, IN Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Carmel, IN your way! Explore restaurants, local attractions and things to do in your favorite Carmel, IN neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Monterey",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "80",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "70",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/monterey.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/old-fishermans-wharf-monterey-california-dock:Square?wid=768&fit=constrain",
      "headline": "Discover Monterey Your Way with Marriott Bonvoy Stays",
      "description": "Visit Monterey, CA your way! Explore restaurants, local attractions and things to do in your favorite Monterey, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Uluwatu Bali",
      "country": "Indonesia",
      "Beach": "100.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nagoya Honshu",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/nagoya.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-nagoya-737012206932219:Square?wid=768&fit=constrain",
      "headline": "Discover Nagoya Your Way with Marriott Bonvoy Stays",
      "description": "Visit Nagoya, Japan your way! Explore restaurants, local attractions and things to do in your favorite Nagoya, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "La Jolla",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/la-jolla.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-la-jolla-173453851716742:Square?wid=768&fit=constrain",
      "headline": "La Jolla: Oceanfront Flavors, Coastal Wonders, and Endless Relaxation",
      "description": "Whether you’re savoring fresh seafood at one of the many oceanfront restaurants or enjoying a day of golf at Torrey Pines, La Jolla’s diverse attractions cater to every interest. Many of our hotels offer amenities such as complimentary Wi-Fi, spa services, and fitness centers, making it easy to unwind and recharge after a day of exploration. For those looking to dive deeper into the city’s natural wonders, the Birch Aquarium and the La Jolla Ecological Reserve are must-visit destinations, providing a glimpse into the marine life and coastal ecosystems that make La Jolla truly special."
    },
    {
      "city": "Paso Robles",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/paso-robles.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/vineyard-winery-california-dusk:Square?wid=768&fit=constrain",
      "headline": "Paso Robles: Small-Town Charm Meets World-Class Wine Country",
      "description": "Paso Robles is a city that's the perfect blend of the warmth of a small town and the sophistication of a world-class wine region. Known as the \"City of Oaks,\" its landscape is dotted with rolling hills, vineyards, and majestic oak trees, providing a stunning backdrop for a variety of outdoor activities. Whether you're a wine enthusiast, a golf aficionado, or someone who enjoys the tranquility of a spa retreat, you'll find something to love in Paso Robles. The city's downtown area is a bustling hub of boutiques, art galleries, and gourmet eateries, making it an ideal place to relax and explore."
    },
    {
      "city": "Costa Navarino",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/costa-navarino.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-costa-navarino-173453293708717:Square?wid=768&fit=constrain",
      "headline": "Discover Costa Navarino: Your Personalized Greek Getaway with Marriott",
      "description": "Visit Costa Navarino, Greece your way! Explore restaurants, local attractions and things to do in your favorite Costa Navarino, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Pattaya",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/pattaya.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tha-pattaya-173454121491934:Square?wid=768&fit=constrain",
      "headline": "Explore Pattaya Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Pattaya, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Pattaya, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Porto Cervo",
      "country": "Italy",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/porto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-porto-1734533917305-4:Square?wid=768&fit=constrain",
      "headline": "Discover Porto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Porto, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Porto, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Beyoglu/Istanbul",
      "country": "Türkiye",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/istanbul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-istanbul-173454093632192:Square?wid=768&fit=constrain",
      "headline": "Discover Istanbul Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Istanbul, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Istanbul, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lagos",
      "country": "Portugal",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/lagos-portugal.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/wi-faoaa-outdoor-pool-40024:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Discover Lagos, Portugal: Local Flavors, Coastal Charm, Marriott Comfort",
      "description": "Visit Lagos, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Lagos, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Izmir",
      "country": "Türkiye",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/izmir.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-izmir-173454751712818:Square?wid=768&fit=constrain",
      "headline": "Discover Izmir Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Izmir, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Izmir, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paris La Défense",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/paris.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arc-de-triomphe-paris-634207441403522:Square?wid=768&fit=constrain",
      "headline": "Discover Paris Your Way with Marriott Bonvoy Stays",
      "description": "Visit Paris, France your way! Explore restaurants, local attractions and more in your favorite Paris neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Scottsdale",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "90",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/scottsdale.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aerial-from-camelback-349440964711826:Square?wid=768&fit=constrain",
      "headline": "Unlock Scottsdale: Your Neighborhood Adventure with Marriott Bonvoy",
      "description": "Visit Scottsdale, AZ your way! Explore restaurants, local attractions and things to do in your favorite Scottsdale, AZ neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Istanbul",
      "country": "Türkiye",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/istanbul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-istanbul-173454093632192:Square?wid=768&fit=constrain",
      "headline": "Discover Istanbul Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Istanbul, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Istanbul, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Metro Manila",
      "country": "Philippines",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/manila.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-Manila-622377505928859-168330237401458:Square?wid=768&fit=constrain",
      "headline": "Discover Manila Your Way: Neighborhood Eats, Sights & Stays",
      "description": "Visit Manila, Philippines your way! Explore restaurants, local attractions and things to do in your favorite Manila, Philippines neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nha Trang",
      "country": "Vietnam",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/nha-trang.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-NhaTrang--24284-168917108711683:Square?wid=768&fit=constrain",
      "headline": "Nha Trang: Thrills, History, and Coastal Comfort for Everyone",
      "description": "Nha Trang is more than just a pretty face. It has a little something for everyone. History buffs will love the Long Son Pagoda and Po Nagar Cham Towers. Thrill-seekers can get their fix at the Dragon King Water Park or by exploring the diving spots in Nha Trang Bay. Our properties offer modern conveniences like free Wi-Fi, fitness centers, and family-friendly rooms, so you can enjoy your stay in comfort. Whether you’re here for a romantic getaway, a family vacation, or a business trip, Nha Trang’s diverse offerings and our exceptional service will make your stay one to remember."
    },
    {
      "city": "Paris/Bagnolet",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/paris.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arc-de-triomphe-paris-634207441403522:Square?wid=768&fit=constrain",
      "headline": "Discover Paris Your Way with Marriott Bonvoy Stays",
      "description": "Visit Paris, France your way! Explore restaurants, local attractions and more in your favorite Paris neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Mykonos",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/mykonos.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-mykonos-173454136693238:Square?wid=768&fit=constrain",
      "headline": "Mykonos Magic: Where Sunlit Streets Meet Aegean Nights",
      "description": "Mykonos, with its iconic windmills and pristine beaches, is a vibrant island that captures the essence of the Aegean Sea. Known for its lively nightlife and chic boutiques, the city offers a perfect blend of relaxation and excitement. Whether you're exploring the historic Little Venice district with its colorful buildings and seaside balconies, or enjoying the sun at one of the many stunning beaches, Mykonos ensures a memorable experience. The city's white-washed Cycladic architecture and charming cobblestone streets are a photographer’s dream, while its rich cultural heritage is evident in the numerous museums and archaeological sites."
    },
    {
      "city": "Bali",
      "country": "Indonesia",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Miami Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New York",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/york.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-york-368750268357195:Square?wid=768&fit=constrain",
      "headline": "York: Timeless Streets, Towering Views, Perfect Stays for All",
      "description": "York is a city of contrasts. From the panoramic views at Clifford's Tower to the many museums, galleries and shops, there is something for everyone. The city is also home to the Shambles, a narrow, cobbled street lined with shops and restaurants. The York Railway Station is the main station in the city and offers regular services to a number of destinations. Many of our hotels offer on-site dining, fitness and leisure facilities and free Wi-Fi. With a range of modern and historic hotels, we have the perfect place to stay for every type of traveler."
    },
    {
      "city": "Bal Harbour - Miami Beach",
      "country": "USA",
      "Beach": "95.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "George Town",
      "country": "Penang, Malaysia",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Waikiki Beach",
      "country": "USA",
      "Beach": "95.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/waikiki.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-hi-waikiki-173453790867451:Square?wid=768&fit=constrain",
      "headline": "Waikiki Wonders: Culture, Creatures, and Comfort in Paradise",
      "description": "Waikiki is more than just a pretty face. It's a treasure trove of culture and history. Explore the marine life of the Pacific at the Waikiki Aquarium or take a walk on the wild side at the Honolulu Zoo. For a deeper dive into Hawaiian heritage, the Bishop Museum is a must-see, with its captivating exhibits on the islands' history and culture. Our Waikiki hotels are brimming with thoughtful amenities, from free Wi-Fi to fitness centers and complimentary breakfasts, to ensure your stay is enjoyable and stress-free. Whether you're here for romance, family fun, or business, our hotels' charm and exceptional service will make your visit truly unforgettable."
    },
    {
      "city": "Antwerp",
      "country": "Belgium",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "80",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/antwerp.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bel-antwerp-173453933670517:Square?wid=768&fit=constrain",
      "headline": "Discover Antwerp Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Antwerp, Belgium your way! Explore restaurants, local attractions and things to do in your favorite Antwerp, Belgium neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Goa",
      "country": "India",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/goa.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-goa-173453729314518:Square?wid=768&fit=constrain",
      "headline": "Discover Goa Your Way With Marriott Bonvoy Stays",
      "description": "Visit Goa, India your way! Explore restaurants, local attractions and things to do in your favorite Goa, India neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Santa Monica",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-monica.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-santa-monica-173453526195035:Square?wid=768&fit=constrain",
      "headline": "Sun, Surf, and Style: Discover Electric Santa Monica",
      "description": "Santa Monica, with its world-famous pier and sun-soaked beaches, is the epitome of Southern Californian charm. The city's lively boardwalk, the Promenade, is a magnet for those seeking a vibrant scene, with its mix of unique shops, top-notch dining, and street performers creating an electric atmosphere. Just steps from the Pacific Ocean, the beach beckons for leisurely strolls, sun-soaked afternoons, or perhaps a bit of surfing. And if you're in the mood for a bit of culture, the downtown area is a treasure trove of art galleries, theaters, and museums."
    },
    {
      "city": "Macau",
      "country": "China",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/macau.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/macau-daytrips1:Square?wid=768&fit=constrain",
      "headline": "Discover Macau Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Macau, China your way! Explore restaurants, local attractions and things to do in your favorite Macau, China neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hong Kong",
      "country": "Hong Kong",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/hong-kong.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-JordHammond-HongKong-739569223059559:Square?wid=768&fit=constrain",
      "headline": "Hong Kong: Electric Nights, Timeless Sights, Endless City Delights",
      "description": "Hong Kong is a city that never stops. A place where the ancient and the modern sit side by side, it’s a city of contrasts. From the soaring skyscrapers to the bustling street markets and the serene temples, you’ll find something new to explore around every corner. As a global financial hub, Hong Kong is a city that knows how to live well. With world-class dining, luxury shopping, and efficient public transport, it’s a city that has it all. Our hotels in Hong Kong are perfectly placed to help you explore everything the city has to offer, from the iconic Victoria Peak to the famous Star Ferry and the vibrant Causeway Bay."
    },
    {
      "city": "Palm Springs",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "90",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-springs.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/biking-bike-street-palm-springs-california:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Springs Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Palm Springs, CA your way! Explore restaurants, local attractions and things to do in your favorite Palm Springs, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Georgetown",
      "country": "Malaysia",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Jakarta Pusat",
      "country": "Indonesia",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/jakarta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-jakarta-173453295716463:Square?wid=768&fit=constrain",
      "headline": "Discover Jakarta Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Jakarta, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Jakarta, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hua Hin",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hua-hin.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/hhqmr-pool-0043:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Discover Hua Hin Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hua Hin, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Hua Hin, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "West Hollywood",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/hollywood.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-hollywood-173453621519438:Square?wid=768&fit=constrain",
      "headline": "Discover Hollywood Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hollywood, CA your way! Explore restaurants, local attractions and things to do in your favorite Hollywood, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sirkeci / Fatih / Istanbul",
      "country": "Türkiye",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/istanbul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-istanbul-173454093632192:Square?wid=768&fit=constrain",
      "headline": "Discover Istanbul Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Istanbul, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Istanbul, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Maui",
      "country": "USA",
      "Beach": "95.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/maui.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastline-rainbow-maui-hawaii-wesHNMWIls.708720:Square?wid=768&fit=constrain",
      "headline": "Discover Maui Your Way with Marriott Bonvoy Stays",
      "description": "Visit Maui, HI your way! Explore restaurants, local attractions and things to do in your favorite Maui, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kota Jakarta Selatan",
      "country": "Indonesia",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/jakarta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-jakarta-173453295716463:Square?wid=768&fit=constrain",
      "headline": "Discover Jakarta Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Jakarta, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Jakarta, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cabo San Lucas",
      "country": "Mexico",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/cabo-san-lucas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/el-arco-lovers-beach-cabo-san-lucas-mexico:Square?wid=768&fit=constrain",
      "headline": "Discover Cabo San Lucas Your Way with Marriott Bonvoy",
      "description": "Visit Cabo San Lucas, Mexico your way! Explore restaurants, local attractions and things to do in your favorite Cabo San Lucas, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Osaka Honshu",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/osaka.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/rz-osarz-osaka-shinsaibashi-23169:Square?wid=768&fit=constrain",
      "headline": "Discover Osaka Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Osaka, Japan your way! Explore restaurants, local attractions and things to do in your favorite Osaka, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Mougins",
      "country": "France",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/mougins.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-mougins-173453292698137:Square?wid=768&fit=constrain",
      "headline": "Mougins: Medieval Charm, Gourmet Heart of the French Riviera",
      "description": "Nestled in the heart of the French Riviera, Mougins is a charming village that effortlessly marries medieval allure with modern elegance. Its narrow cobblestone streets, delightful squares, and Provençal architecture create an idyllic setting for a peaceful escape. Mougins is also a haven for food enthusiasts, boasting a number of Michelin-starred restaurants and a vibrant culinary scene that reflects the region's dedication to gastronomy. Whether you're perusing the local market, admiring the works in the art galleries, or simply soaking in the tranquil beauty of the hills, Mougins promises a truly unique and memorable experience."
    },
    {
      "city": "Long Island City",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/long-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/seafood-wine-dinner-restaurant-candle-swh.438335:Square?wid=768&fit=constrain",
      "headline": "Experience Long Island Your Way with Marriott Bonvoy Stays",
      "description": "Visit Long Island, NY your way! Explore restaurants, local attractions and things to do in your favorite Long Island, NY neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Santorini",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/santorini.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-santorini-587986249568062:Square?wid=768&fit=constrain",
      "headline": "Discover Santorini Your Way with Marriott Bonvoy Stays",
      "description": "Visit Santorini, Greece your way! Explore restaurants, local attractions and things to do in your favorite Santorini, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Geneva",
      "country": "Switzerland",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "50",
      "Spa": "75",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/geneva.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-geneva-429826027636888:Square?wid=768&fit=constrain",
      "headline": "Geneva: Where Alpine Beauty Meets Global Peace and Culture",
      "description": "Geneva is a city that effortlessly combines the best of both worlds—a stunning lakefront setting with breathtaking views of the Alps, and a place where international diplomacy meets a rich tapestry of culture and history. Known as the \"Peace Capital,\" Geneva is home to numerous international organizations, including the United Nations and the Red Cross, making it a hub for global affairs. But don't be fooled by its serious side—Geneva offers a delightful blend of sophisticated charm and natural beauty, from its iconic Jet d'Eau to the tranquil Botanical Garden. Whether you're exploring the historic Old Town, enjoying the vibrant culinary scene, or taking a leisurely stroll along the lake, every corner of the city invites you to discover its unique blend of elegance and warmth."
    },
    {
      "city": "Elounda - Crete",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/crete.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-crete-151586342206659:Square?wid=768&fit=constrain",
      "headline": "Discover Crete Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Crete, Greece your way! Explore restaurants, local attractions and things to do in your favorite Crete, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Chania-Crete",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/crete.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-crete-151586342206659:Square?wid=768&fit=constrain",
      "headline": "Discover Crete Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Crete, Greece your way! Explore restaurants, local attractions and things to do in your favorite Crete, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Saint Rémy de Provence",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/saint-remy-de-provence.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-saint-remy-de-provenc-173453391742515:Square?wid=768&fit=constrain",
      "headline": "Discover Saint-Rémy-de-Provence: Your Marriott Bonvoy Getaway Awaits",
      "description": "Visit Saint-Rémy-de-Provence, France your way! Explore restaurants, local attractions and things to do in your favorite Saint-Rémy-de-Provence, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cannes",
      "country": "France",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/cannes.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-cannes-144090374638627:Square?wid=768&fit=constrain",
      "headline": "Cannes Your Way: Discover, Dine & Stay with Marriott",
      "description": "Visit Cannes, France your way! Explore restaurants, local attractions and things to do in your favorite Cannes, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Frankfurt/Offenbach",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/frankfurt.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-frankfurt-1734538639117-1:Square?wid=768&fit=constrain",
      "headline": "Frankfurt Uncovered: Breweries, Historic Squares, Forest Escapes Await",
      "description": "Uncover the charm of Frankfurt’s neighborhoods. Trendy Sachsenhausen is home to craft breweries and traditional German pubs. The historic Römerberg square is perfect for a leisurely stroll or a visit to the town hall. Nature lovers can escape to the Frankfurt City Forest or one of the city’s many parks. Our hotels are strategically located to give you easy access to all these attractions and more."
    },
    {
      "city": "Hong Kong",
      "country": "China",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/hong-kong.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-JordHammond-HongKong-739569223059559:Square?wid=768&fit=constrain",
      "headline": "Hong Kong: Electric Nights, Timeless Sights, Endless City Delights",
      "description": "Hong Kong is a city that never stops. A place where the ancient and the modern sit side by side, it’s a city of contrasts. From the soaring skyscrapers to the bustling street markets and the serene temples, you’ll find something new to explore around every corner. As a global financial hub, Hong Kong is a city that knows how to live well. With world-class dining, luxury shopping, and efficient public transport, it’s a city that has it all. Our hotels in Hong Kong are perfectly placed to help you explore everything the city has to offer, from the iconic Victoria Peak to the famous Star Ferry and the vibrant Causeway Bay."
    },
    {
      "city": "Phuket Island",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/phuket.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-hktmd-phuket-beach-sunset-37586-67997:Square?wid=768&fit=constrain",
      "headline": "Discover Phuket Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Phuket, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Phuket, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nha Trang City",
      "country": "Vietnam",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "75",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/nha-trang.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-NhaTrang--24284-168917108711683:Square?wid=768&fit=constrain",
      "headline": "Nha Trang: Thrills, History, and Coastal Comfort for Everyone",
      "description": "Nha Trang is more than just a pretty face. It has a little something for everyone. History buffs will love the Long Son Pagoda and Po Nagar Cham Towers. Thrill-seekers can get their fix at the Dragon King Water Park or by exploring the diving spots in Nha Trang Bay. Our properties offer modern conveniences like free Wi-Fi, fitness centers, and family-friendly rooms, so you can enjoy your stay in comfort. Whether you’re here for a romantic getaway, a family vacation, or a business trip, Nha Trang’s diverse offerings and our exceptional service will make your stay one to remember."
    },
    {
      "city": "Ascona",
      "country": "Switzerland",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "80",
      "Culture": "40",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/ascona.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-ascona-173453773057922:Square?wid=768&fit=constrain",
      "headline": "Discover Ascona Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Ascona, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Ascona, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sedona",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "80",
      "Culture": "50",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/sedona.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/sedona-airport-road-city-arizona:Square?wid=768&fit=constrain",
      "headline": "Sedona Escapes: Art, Flavors, and Red Rock Wonders Await",
      "description": "The heart of Sedona is a treasure trove of local delights, from one-of-a-kind shops and art galleries to restaurants that serve up a mix of southwestern cuisine and international flavors. And with iconic sites like Cathedral Rock, Bell Rock, and Oak Creek Canyon just a short drive away, you can easily experience the area’s awe-inspiring vistas and serene landscapes. Our hotels in Sedona are designed to complement the natural beauty of the surroundings, with many offering stunning views, spa services, and wellness programs. Stay connected with free Wi-Fi and enjoy the convenience of being close to both the city’s vibrant heart and its serene natural wonders."
    },
    {
      "city": "Porto Ercole",
      "country": "Italy",
      "Beach": "70.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "40",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/porto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-porto-1734533917305-4:Square?wid=768&fit=constrain",
      "headline": "Discover Porto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Porto, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Porto, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Osaka-City",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/osaka.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/rz-osarz-osaka-shinsaibashi-23169:Square?wid=768&fit=constrain",
      "headline": "Discover Osaka Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Osaka, Japan your way! Explore restaurants, local attractions and things to do in your favorite Osaka, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kyoto-City",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kyoto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/50464712-kyoto_destination_fushimi-inari-1:Square?wid=768&fit=constrain",
      "headline": "Discover Kyoto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Kyoto, Japan your way! Explore restaurants, local attractions and things to do in your favorite Kyoto, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Venice Tessera",
      "country": "Italy",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/venice.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-venice-416204426953302:Square?wid=768&fit=constrain",
      "headline": "Discover Venice Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Venice, Italy your way! Explore restaurants, local attractions and things to do in your favorite Venice, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lahaina - Maui",
      "country": "USA",
      "Beach": "100.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/maui.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastline-rainbow-maui-hawaii-wesHNMWIls.708720:Square?wid=768&fit=constrain",
      "headline": "Discover Maui Your Way with Marriott Bonvoy Stays",
      "description": "Visit Maui, HI your way! Explore restaurants, local attractions and things to do in your favorite Maui, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Jakarta Selatan",
      "country": "Indonesia",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/jakarta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-jakarta-173453295716463:Square?wid=768&fit=constrain",
      "headline": "Discover Jakarta Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Jakarta, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Jakarta, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Pienza",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "20",
      "Culture": "80",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/pienza.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-pienza-173454120488043:Square?wid=768&fit=constrain",
      "headline": "Pienza: Tuscany’s Timeless Renaissance Dream in Rolling Hills",
      "description": "Pienza, a small gem in the heart of Tuscany, is a place that captures the hearts of those who visit with its harmonious Renaissance architecture and stunning landscapes. Pienza was designed to be the \"ideal city\" by Pope Pius II in the 15th century. The historic center of Pienza is a UNESCO World Heritage site and is home to beautiful works of art, such as the Palazzo Piccolomini and the Cathedral of Santa Maria Assunta. The city’s narrow streets and charming squares invite you to wander and take in the timeless beauty, while the surrounding vineyards and rolling hills are the perfect setting for a leisurely walk or a scenic drive."
    },
    {
      "city": "Ubud Bali",
      "country": "Indonesia",
      "Beach": "0.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "0",
      "Spa": "90",
      "Culture": "70",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Monte Carlo",
      "country": "Monaco",
      "Beach": "80.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "80",
      "Culture": "50",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/monte-carlo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-mco-monte-carlo-173452968420014:Square?wid=768&fit=constrain",
      "headline": "Explore Monte-Carlo Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Monte-Carlo, Monaco your way! Explore restaurants, local attractions and things to do in your favorite Monte-Carlo, Monaco neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "George Town",
      "country": "Pulau Pinang",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Kyoto City",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/kyoto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/50464712-kyoto_destination_fushimi-inari-1:Square?wid=768&fit=constrain",
      "headline": "Discover Kyoto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Kyoto, Japan your way! Explore restaurants, local attractions and things to do in your favorite Kyoto, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Grand Cayman",
      "country": "Cayman Islands",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/grand-cayman.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-stingray-city-snorkeling-340616536073012:Square?wid=768&fit=constrain",
      "headline": "Discover Grand Cayman Your Way with Marriott Bonvoy Stays",
      "description": "Visit Grand Cayman, Cayman Islands your way! Explore restaurants, local attractions and things to do in your favorite Grand Cayman, Cayman Islands neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Reims",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/reims.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-reims-173453638635767:Square?wid=768&fit=constrain",
      "headline": "Discover Reims Your Way with Marriott Bonvoy Stays",
      "description": "Visit Reims, France your way! Explore restaurants, local attractions and things to do in your favorite Reims, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Berkeley",
      "country": "USA",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/berkeley.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-berkeley-173453512275196:Square?wid=768&fit=constrain",
      "headline": "Berkeley: Where Free Spirits, Great Minds, and Bay Views Meet",
      "description": "Berkeley is a vibrant and culturally rich city that seamlessly blends academic prestige with a laid-back, progressive atmosphere. As the home of the University of California, Berkeley, the city is a hub of intellectual activity and innovation, where the spirit of free thought and creativity flourishes. Stroll through the bustling Telegraph Avenue, lined with eclectic shops and street performers, or explore the diverse culinary scene that showcases everything from farm-to-table dining to international flavors. With its proximity to the San Francisco Bay and the East Bay Regional Parks, Berkeley offers both urban excitement and natural beauty, making it a perfect destination for travelers of all interests."
    },
    {
      "city": "Santiago de Chile",
      "country": "Chile",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "50",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santiago.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-skyline-andes-mountains-859940256730875:Square?wid=768&fit=constrain",
      "headline": "Discover Santiago, Chile Your Way with Marriott Bonvoy",
      "description": "Visit Santiago, Chile your way! Explore restaurants, local attractions and things to do in your favorite Santiago, Chile neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paradise Valley",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/ise.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-ise-173453726802789:Square?wid=768&fit=constrain",
      "headline": "Discover Ise Your Way: Stay, Savor, and Explore with Marriott",
      "description": "Visit Ise, Japan your way! Explore restaurants, local attractions and things to do in your favorite Ise, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Miami Lakes",
      "country": "USA",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Chania – Crete",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/crete.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-crete-151586342206659:Square?wid=768&fit=constrain",
      "headline": "Discover Crete Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Crete, Greece your way! Explore restaurants, local attractions and things to do in your favorite Crete, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Muang Phuket",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/phuket.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-hktmd-phuket-beach-sunset-37586-67997:Square?wid=768&fit=constrain",
      "headline": "Discover Phuket Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Phuket, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Phuket, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Macau",
      "country": "Macau",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/macau.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/macau-daytrips1:Square?wid=768&fit=constrain",
      "headline": "Discover Macau Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Macau, China your way! Explore restaurants, local attractions and things to do in your favorite Macau, China neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sifnos",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/sifnos.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-sifnos-173454139926520:Square?wid=768&fit=constrain",
      "headline": "Sifnos: Hidden Aegean Gem of Sun, Sea and Story",
      "description": "Sifnos is a well-kept secret in the Aegean, celebrated for its captivating white-washed villages and the mesmerizing azure waters that surround it. The island's main town, Apollonia, is a delightful labyrinth of narrow streets, adorned with the classic Cycladic architecture, inviting artisanal shops, and welcoming tavernas. You can choose to immerse yourself in the ancient history of Sifnos by visiting its well-preserved archaeological sites, like the Castle of Kastro and the Tower of Agios Andreas, or simply unwind on one of the many pristine beaches, such as Platis Gialos and Vathi. The island's rich cultural tapestry is further woven by its lively festivals and the genuine warmth of its people, making it the ideal destination for those in search of both relaxation and discovery."
    },
    {
      "city": "Seminyak Bali",
      "country": "Indonesia",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sonoma",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "80",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "40",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/sonoma.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/napa-valley-california-vineyard-winery-sonoma:Square?wid=768&fit=constrain",
      "headline": "Discover Sonoma Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Sonoma, CA your way! Explore restaurants, local attractions and things to do in your favorite Sonoma, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kyotoshi",
      "country": "Kyotofu",
      "Beach": "",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "90",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/kyoto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/50464712-kyoto_destination_fushimi-inari-1:Square?wid=768&fit=constrain",
      "headline": "Discover Kyoto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Kyoto, Japan your way! Explore restaurants, local attractions and things to do in your favorite Kyoto, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    }
  ],
  "golf": [
    {
      "city": "San Francisco",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/san-francisco.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-GettyImages-1133891066-359793688600498:Square?wid=768&fit=constrain",
      "headline": "San Francisco Adventures Await with Marriott Bonvoy Stays",
      "description": "Stay at a Marriott Bonvoy Hotel in San Francisco, CA, and enjoy easy access to Fisherman’s Wharf, the iconic Golden Gate Bridge, and endless adventures."
    },
    {
      "city": "Boston",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "25",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/boston.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/sailing-boats-charles-river-downtown-boston:Square?wid=768&fit=constrain",
      "headline": "Boston Bites, Sights, and Scenic Nights Await You",
      "description": "Boston’s culinary scene is also not to be missed. Savor everything from fresh seafood at the Quincy Market to world-class dining in the South End. With easy access to the city’s public transportation, you can effortlessly navigate to the Harvard University campus, explore the museums of the Back Bay, or enjoy the scenic views along the Charles River. No matter your interests, Boston’s diverse neighborhoods and attractions promise an unforgettable experience."
    },
    {
      "city": "Louisville",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "1",
      "Spa": "25",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/louisville.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/gatehouse-historic-water-treatment-plant-louisville-kentucky:Square?wid=768&fit=constrain",
      "headline": "Discover Louisville Your Way with Marriott Bonvoy Stays",
      "description": "Visit Louisville, KY your way! Explore restaurants, local attractions and things to do in your favorite Louisville, KY neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Melbourne",
      "country": "Australia",
      "Beach": "75.0",
      "Culinary": "85",
      "Golf": "80",
      "Ski": "50",
      "Spa": "60",
      "Culture": "75",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/melbourne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-melmd-regent-theatre-15294:Square?wid=768&fit=constrain",
      "headline": "Discover Melbourne Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Melbourne, Australia your way! Explore restaurants, local attractions and things to do in your favorite Melbourne, Australia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cape Town",
      "country": "South Africa",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "0",
      "Spa": "70",
      "Culture": "70",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/cape-town.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aerial-vw-cape-std-33447-167001010058079:Square?wid=768&fit=constrain",
      "headline": "Discover Cape Town Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Cape Town, South Africa your way! Explore restaurants, local attractions and things to do in your favorite Cape Town, South Africa neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Los Angeles",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "85",
      "Golf": "80",
      "Ski": "50",
      "Spa": "70",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/los-angeles.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/griffith-park-los-angeles-california:Square?wid=768&fit=constrain",
      "headline": "Discover Baltimore Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Baltimore, MD your way! Explore restaurants, local attractions and more in your favorite Los Angeles neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Chicago",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "85",
      "Golf": "75",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/chicago.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1065188752:Square?wid=768&fit=constrain",
      "headline": "Discover Chicago Your Way With Marriott Bonvoy Hotels",
      "description": "Visit Chicago, IL your way! Explore restaurants, local attractions and more in your favorite Chicago neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Calgary",
      "country": "Canada",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "75",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/calgary.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/hike-view-buildings-downtown-calgary-canada:Square?wid=768&fit=constrain",
      "headline": "Discover Calgary Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Calgary, Canada your way! Explore restaurants, local attractions and things to do in your favorite Calgary, Canada neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Johannesburg",
      "country": "South Africa",
      "Beach": "1.0",
      "Culinary": "60",
      "Golf": "75",
      "Ski": "1",
      "Spa": "50",
      "Culture": "70",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/johannesburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-johannesburg-173453844620875:Square?wid=768&fit=constrain",
      "headline": "Discover Johannesburg Your Way with Marriott Bonvoy Stays",
      "description": "Visit Johannesburg, South Africa your way! Explore restaurants, local attractions and things to do in your favorite Johannesburg, South Africa neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sydney",
      "country": "Australia",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "70",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/sydney.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/mc-sydmc-sydney-harbour-skyline-30873:Square?wid=768&fit=constrain",
      "headline": "Unlock Sydney’s Best Neighborhoods with Marriott Bonvoy Stays",
      "description": "Visit Sydney, Australia your way! Explore restaurants, local attractions and things to do in your favorite Sydney, Australia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Jacksonville",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "1",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/jacksonville.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/skyline-city-jacksonville-florida:Square?wid=768&fit=constrain",
      "headline": "Jacksonville: Beaches, Trails, and Culture in One Vibrant Stay",
      "description": "For those who love the great outdoors, Jacksonville is the perfect place to be. You can spend a relaxing day at Jacksonville Beach or explore the hiking trails at the Timucuan Ecological and Historic Preserve. The city is also home to a vibrant arts and culture scene, with attractions like the Cummer Museum of Art & Gardens and the Jacksonville Symphony. Our hotels in Jacksonville come with modern amenities and exceptional service, making them the perfect choice for both business and leisure travelers. Whether you’re in town for a conference or a family vacation, we’ll make sure your stay is a memorable one."
    },
    {
      "city": "Denver",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "75",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/denver.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/downtown-denver-colorado:Square?wid=768&fit=constrain",
      "headline": "Denver Adventures Await: Stay Bonvoy, Explore Red Rocks & More",
      "description": "Stay at a Marriott Bonvoy Hotel in Denver, CO, and enjoy easy access to top attractions like Red Rocks Park, local dining, and endless city adventures."
    },
    {
      "city": "Nagano",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "90",
      "Spa": "1",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/nagano.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-nagano-173454139704022:Square?wid=768&fit=constrain",
      "headline": "Discover Nagano Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Nagano, Japan your way! Explore restaurants, local attractions and things to do in your favorite Nagano, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Orlando",
      "country": "United States",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/orlando.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lake-eola-park-water-views-orlando-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Orlando Your Way with Marriott Bonvoy Stays",
      "description": "Visit Orlando, FL your way! Explore restaurants, local attractions and more in your favorite Orlando neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Colorado Springs",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/colorado-springs.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/cheyenne-mountain-hot-air-balloon-colorado-springs:Square?wid=768&fit=constrain",
      "headline": "Discover Colorado Springs: Eat, Explore, and Stay with Marriott",
      "description": "Visit Colorado Springs, CO your way! Explore restaurants, local attractions and things to do in your favorite Colorado Springs, CO neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Miami",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Honolulu",
      "country": "United States",
      "Beach": "100.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/honolulu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-hi-honolulu-173453529708227:Square?wid=768&fit=constrain",
      "headline": "Discover Honolulu Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Honolulu, HI your way! Explore restaurants, local attractions and things to do in your favorite Honolulu, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Salt Lake City",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "90",
      "Spa": "1",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/salt-lake-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/salt-lake-city-skyline:Square?wid=768&fit=constrain",
      "headline": "Discover Salt Lake City Your Way with Marriott Bonvoy",
      "description": "Visit Salt Lake City, UT your way! Explore restaurants, local attractions and things to do in your favorite Salt Lake City, UT neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Fort Lauderdale",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/fort-lauderdale.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/canals-boat-fort-lauderdale-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Fort Lauderdale Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Fort Lauderdale, FL your way! Explore restaurants, local attractions and things to do in your favorite Fort Lauderdale, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "West Palm Beach",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/worth-avenue-palm-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Beach Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Palm Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Palm Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Santa Barbara",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-barbara.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/golf-course-goleta-california:Square?wid=768&fit=constrain",
      "headline": "Discover Santa Barbara Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Santa Barbara, CA your way! Explore restaurants, local attractions and things to do in your favorite Santa Barbara, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Augusta",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "90",
      "Ski": "1",
      "Spa": "1",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/augusta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ga-augusta-173453819539393:Square?wid=768&fit=constrain",
      "headline": "Discover Augusta, GA: Neighborhood Flavors, Local Fun, Marriott Style",
      "description": "Visit Augusta, GA your way! Explore restaurants, local attractions and things to do in your favorite Augusta, GA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Steamboat Springs",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "90",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/steamboat-springs.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/steam-boat-springs-hot-colorado-winter:Square?wid=768&fit=constrain",
      "headline": "Discover Steamboat Springs Your Way with Marriott Bonvoy",
      "description": "Visit Steamboat Springs, CO your way! Explore restaurants, local attractions and things to do in your favorite Steamboat Springs, CO neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Aspen",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "90",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/aspen.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ski-snowmass-green-cabin-colorado:Square?wid=768&fit=constrain",
      "headline": "Aspen: Where Rocky Mountain Adventure Meets Luxury and Culture",
      "description": "Aspen is a year-round playground for the senses, combining world-class skiing, snowboarding and snowmobiling with a vibrant arts and culture scene, exciting nightlife, great restaurants and luxury accommodations. This historic mining town is surrounded by the majestic peaks of the Rocky Mountains and is a haven for outdoor enthusiasts with its beautiful hiking, mountain biking, horseback riding and whitewater rafting in the summer. Aspen is also a center for the arts, hosting the annual Aspen Music Festival and the Food & Wine Classic, as well as a number of high-end art galleries."
    },
    {
      "city": "Carmel",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "1",
      "Spa": "50",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/carmel.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-in-carmel-173454023869485:Square?wid=768&fit=constrain",
      "headline": "Discover Carmel, IN Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Carmel, IN your way! Explore restaurants, local attractions and things to do in your favorite Carmel, IN neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "St George's",
      "country": "Bermuda",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Costa Navarino",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/costa-navarino.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-costa-navarino-173453293708717:Square?wid=768&fit=constrain",
      "headline": "Discover Costa Navarino: Your Personalized Greek Getaway with Marriott",
      "description": "Visit Costa Navarino, Greece your way! Explore restaurants, local attractions and things to do in your favorite Costa Navarino, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Scottsdale",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "90",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/scottsdale.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aerial-from-camelback-349440964711826:Square?wid=768&fit=constrain",
      "headline": "Unlock Scottsdale: Your Neighborhood Adventure with Marriott Bonvoy",
      "description": "Visit Scottsdale, AZ your way! Explore restaurants, local attractions and things to do in your favorite Scottsdale, AZ neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Verbier",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "90",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/verbier.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-verbier-173453812648879:Square?wid=768&fit=constrain",
      "headline": "Verbier: Alpine Adventure Playground for Year-Round Thrills",
      "description": "Verbier, the ultimate playground for snow and ski enthusiasts, is one of the largest ski areas in the Alps. The vibrant town is home to a world-class après-ski scene, with live music, cozy chalets, and a wide range of dining options. But the fun doesn't stop there. Verbier is a mecca for outdoor activities, offering everything from snowshoeing and ice climbing to hiking and mountain biking. And with its stunning mountain and valley views, Verbier is the perfect year-round destination for those who love adventure and relaxation."
    },
    {
      "city": "Hilton Head Island",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hilton-head-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/beach-hilton-head-south-carolina:Square?wid=768&fit=constrain",
      "headline": "Discover Hilton Head Island Your Way with Marriott Bonvoy",
      "description": "Visit Hilton Head Island, SC your way! Explore restaurants, local attractions and things to do in your favorite Hilton Head Island, SC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sandestin",
      "country": "USA",
      "Beach": "80.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "30",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/destin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ocean-beach-destin-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Destin Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Destin, FL your way! Explore restaurants, local attractions and things to do in your favorite Destin, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hong Kong",
      "country": "Hong Kong",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/hong-kong.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-JordHammond-HongKong-739569223059559:Square?wid=768&fit=constrain",
      "headline": "Hong Kong: Electric Nights, Timeless Sights, Endless City Delights",
      "description": "Hong Kong is a city that never stops. A place where the ancient and the modern sit side by side, it’s a city of contrasts. From the soaring skyscrapers to the bustling street markets and the serene temples, you’ll find something new to explore around every corner. As a global financial hub, Hong Kong is a city that knows how to live well. With world-class dining, luxury shopping, and efficient public transport, it’s a city that has it all. Our hotels in Hong Kong are perfectly placed to help you explore everything the city has to offer, from the iconic Victoria Peak to the famous Star Ferry and the vibrant Causeway Bay."
    },
    {
      "city": "Palm Springs",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "90",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-springs.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/biking-bike-street-palm-springs-california:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Springs Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Palm Springs, CA your way! Explore restaurants, local attractions and things to do in your favorite Palm Springs, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Palm Desert",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-desert.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-palm-desert-173453806186258:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Desert: Dine, Explore, and Stay with Marriott",
      "description": "Visit Palm Desert, CA your way! Explore restaurants, local attractions and things to do in your favorite Palm Desert, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Maui",
      "country": "USA",
      "Beach": "95.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/maui.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastline-rainbow-maui-hawaii-wesHNMWIls.708720:Square?wid=768&fit=constrain",
      "headline": "Discover Maui Your Way with Marriott Bonvoy Stays",
      "description": "Visit Maui, HI your way! Explore restaurants, local attractions and things to do in your favorite Maui, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cabo San Lucas",
      "country": "Mexico",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/cabo-san-lucas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/el-arco-lovers-beach-cabo-san-lucas-mexico:Square?wid=768&fit=constrain",
      "headline": "Discover Cabo San Lucas Your Way with Marriott Bonvoy",
      "description": "Visit Cabo San Lucas, Mexico your way! Explore restaurants, local attractions and things to do in your favorite Cabo San Lucas, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hilton Head",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hilton-head-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/beach-hilton-head-south-carolina:Square?wid=768&fit=constrain",
      "headline": "Discover Hilton Head Island Your Way with Marriott Bonvoy",
      "description": "Visit Hilton Head Island, SC your way! Explore restaurants, local attractions and things to do in your favorite Hilton Head Island, SC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Palm Beach Gardens",
      "country": "USA",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "90",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/worth-avenue-palm-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Beach Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Palm Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Palm Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Coeur D'Alene",
      "country": "USA",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "50",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/coeur-d-alene.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-id-coeur-d-alene-173454015545267:Square?wid=768&fit=constrain",
      "headline": "Discover Coeur d’Alene Your Way with Marriott Bonvoy",
      "description": "Visit Coeur d'Alene, ID your way! Explore restaurants, local attractions and things to do in your favorite Coeur d'Alene, ID neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bay Harbor",
      "country": "USA",
      "Beach": "50.0",
      "Culinary": "25",
      "Golf": "75",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/boothbay-harbor.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-me-boothbay-harbor-173453714041151:Square?wid=768&fit=constrain",
      "headline": "Boothbay Harbor: Coastal Charm, Scenic Trails, and Seaside Delights",
      "description": "Welcome to Boothbay Harbor, a coastal gem that beckons to nature enthusiasts and maritime aficionados alike. This idyllic town, with its postcard-perfect harbor, storied lighthouses, and verdant gardens, is a serene escape where the beauty of the ocean meets the peaceful charm of New England’s coast. Whether you're wandering the scenic trails of the Boothbay Region Land Trust or embarking on a leisurely cruise to spot local wildlife, you'll find enchantment at every turn. And when it's time to unwind, the lively downtown area awaits with its inviting boutiques, art galleries, and seafood eateries."
    },
    {
      "city": "Cascais",
      "country": "Portugal",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/cascais.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-cascais-173453423662064:Square?wid=768&fit=constrain",
      "headline": "Cascais: Timeless Portuguese Charm Meets Chic Seaside Escape",
      "description": "Cascais is a sun-soaked coastal gem that effortlessly marries the allure of a traditional Portuguese town with the elegance of a contemporary seaside escape. Renowned for its immaculate beaches, from the intimate Praia da Rainha to the windswept expanse of Praia do Guincho, it beckons to both sun-worshippers and aquatic adventurers. The historic heart of the city, with its cobbled streets and pastel-hued facades, is a walking tour of pure delight, while the lively marina and vibrant market offer a glimpse into local life. For the culture seeker, the galleries and museums, including the esteemed Cultural Center of Cascais, are a treasure trove of art and history."
    },
    {
      "city": "Baqueira",
      "country": "Spain",
      "Beach": "1.0",
      "Culinary": "25",
      "Golf": "90",
      "Ski": "90",
      "Spa": "1",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/baqueira.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-esp-baqueira-173454034709213:Square?wid=768&fit=constrain",
      "headline": "Baqueira: Beyond Skiing—Spas, Flavors, and Mountain Adventures",
      "description": "But Baqueira is more than just a ski resort. It’s a village with a range of dining options, from traditional mountain cuisine to international flavors, and a lively après-ski scene that brings the community together. Many of our hotels offer spa services and indoor pools, perfect for relaxing and unwinding. And if you want to explore beyond the resort, the surrounding natural beauty provides opportunities for snowshoeing, cross-country skiing, and scenic hikes. Our commitment to exceptional service ensures that your stay in Baqueira is both memorable and enjoyable."
    },
    {
      "city": "Palm Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/worth-avenue-palm-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Beach Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Palm Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Palm Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Ascona",
      "country": "Switzerland",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "80",
      "Culture": "40",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/ascona.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-ascona-173453773057922:Square?wid=768&fit=constrain",
      "headline": "Discover Ascona Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Ascona, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Ascona, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Dana Point",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "60",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "40",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/dana-point.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-dana-point-173453469866690:Square?wid=768&fit=constrain",
      "headline": "Discover Dana Point Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Dana Point, CA your way! Explore restaurants, local attractions and things to do in your favorite Dana Point, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "La Quinta",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/la-quinta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coachella-rancho-mirage-observatory-mvciPSPWMwn.1062601:Square?wid=768&fit=constrain",
      "headline": "La Quinta: Desert Luxury, Mountain Adventure, Endless Golf Getaways",
      "description": "La Quinta, the jewel of the desert, is a unique blend of beauty, luxury, and adventure. Surrounded by the Santa Rosa Mountains and the Coachella Valley, it is the perfect place for a relaxing getaway. With over 20 golf courses, you will find your perfect game. The Living Desert Zoo and Gardens is a great place to explore the unique plants and animals of the area. The La Quinta Cove is a great place to hike and explore the trails."
    },
    {
      "city": "Pinehurst",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "90",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/pinehurst.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/sh-faysh-hotel-lobby-25726:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Pinehurst: Southern Charm Meets World-Class Golf and Culture",
      "description": "Pinehurst is a charming village, boasting world-class golf, a storied history, and a relaxed Southern ambiance. The Pinehurst Resort, a celebrated destination for golf enthusiasts, is the crown jewel of this tranquil community. The picturesque landscapes and meticulously maintained greens have been the stage for numerous major championships, making it a must-visit for golfers of all levels. Beyond the fairways, Pinehurst offers a rich tapestry of cultural experiences, from art galleries and museums to unique boutiques and delightful dining options, ensuring there is something for everyone in this gracious and hospitable village."
    },
    {
      "city": "Kiawah Island",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "85",
      "Ski": "0",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kiawah-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-sc-kiawah-island-173454083152541:Square?wid=768&fit=constrain",
      "headline": "Discover Kiawah Island: Your Personalized Marriott Bonvoy Getaway",
      "description": "Visit Kiawah Island, SC your way! Explore restaurants, local attractions and things to do in your favorite Kiawah Island, SC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Monte Carlo",
      "country": "Monaco",
      "Beach": "80.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "80",
      "Culture": "50",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/monte-carlo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-mco-monte-carlo-173452968420014:Square?wid=768&fit=constrain",
      "headline": "Explore Monte-Carlo Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Monte-Carlo, Monaco your way! Explore restaurants, local attractions and things to do in your favorite Monte-Carlo, Monaco neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Destin/Miramar Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/destin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ocean-beach-destin-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Destin Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Destin, FL your way! Explore restaurants, local attractions and things to do in your favorite Destin, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Southampton",
      "country": "Bermuda",
      "Beach": "90.0",
      "Culinary": "60",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "30",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/hampton.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-va-hampton-629357764479958:Square?wid=768&fit=constrain",
      "headline": "Discover Hampton, VA Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hampton, VA your way! Explore restaurants, local attractions and things to do in your favorite Hampton, VA neighborhoods as a Marriott Bonvoy Hotel guest."
    }
  ],
  "ski": [
    {
      "city": "Sapporo",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "90",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/sapporo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-sapporo-173453757260135:Square?wid=768&fit=constrain",
      "headline": "Sapporo Seasons: Snow Sculptures, City Lights, Culture in Bloom",
      "description": "Sapporo, the dynamic capital of Hokkaido, is a city that celebrates both its winter and summer seasons with equal fervor. The Sapporo Snow Festival, a world-renowned event, sees the city come alive with intricate ice sculptures and snow activities, drawing visitors from across the globe. But beyond this winter spectacle, Sapporo offers a rich cultural tapestry, with attractions like the Historical Village of Hokkaido and the Hokkaido Museum. The Sapporo Clock Tower stands as a testament to the city's heritage, while the modern amenities and vibrant atmosphere of the city make it an ideal gateway to the natural beauty that surrounds it, from the peaceful Maruyama Park to the lively shopping districts of Susukino and Odori."
    },
    {
      "city": "Calgary",
      "country": "Canada",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "75",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/calgary.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/hike-view-buildings-downtown-calgary-canada:Square?wid=768&fit=constrain",
      "headline": "Discover Calgary Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Calgary, Canada your way! Explore restaurants, local attractions and things to do in your favorite Calgary, Canada neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Almaty",
      "country": "Kazakhstan",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "75",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/almaty.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-kaz-almaty-173453776569367:Square?wid=768&fit=constrain",
      "headline": "Almaty Awaits: Vibrant City Life, Mountain Adventures, Modern Comfort",
      "description": "In the heart of the city, you’ll find a mix of modern and traditional architecture, with a lively atmosphere and a variety of attractions. The Green Bazaar and Panfilov Street are two of the most popular shopping areas in the city, where you can find a range of local and international products. Our hotels in Almaty are equipped with everything you need for a comfortable stay, including free Wi-Fi and fitness centers. Whether you want to experience the city’s nightlife, visit the Medeo Skating Rink, or take a leisurely walk through the Alfalya Botanical Garden, our hotels provide the perfect base for your stay."
    },
    {
      "city": "Denver",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "75",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/denver.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/downtown-denver-colorado:Square?wid=768&fit=constrain",
      "headline": "Denver Adventures Await: Stay Bonvoy, Explore Red Rocks & More",
      "description": "Stay at a Marriott Bonvoy Hotel in Denver, CO, and enjoy easy access to top attractions like Red Rocks Park, local dining, and endless city adventures."
    },
    {
      "city": "Nagano",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "90",
      "Spa": "1",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/nagano.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-nagano-173454139704022:Square?wid=768&fit=constrain",
      "headline": "Discover Nagano Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Nagano, Japan your way! Explore restaurants, local attractions and things to do in your favorite Nagano, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Anchorage",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "75",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/anchorage.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/woman-lake-spenard-anchorage-alaska:Square?wid=768&fit=constrain",
      "headline": "Anchorage: Where Urban Energy Meets Untamed Alaskan Wilderness",
      "description": "Anchorage, the gateway to the great outdoors, is a unique city that combines urban amenities with the beauty of the Alaskan wilderness. Whether you're an adventure seeker or a culture enthusiast, Anchorage is the perfect place to start exploring the stunning landscapes and wildlife of the surrounding areas. From the Chugach Mountains to the shores of Cook Inlet, the views are spectacular and the activities are endless, with opportunities for hiking, skiing, and wildlife viewing. The city itself is full of Alaskan charm, with a vibrant arts scene, museums, and local markets that showcase the region's heritage and contemporary spirit."
    },
    {
      "city": "Salt Lake City",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "90",
      "Spa": "1",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/salt-lake-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/salt-lake-city-skyline:Square?wid=768&fit=constrain",
      "headline": "Discover Salt Lake City Your Way with Marriott Bonvoy",
      "description": "Visit Salt Lake City, UT your way! Explore restaurants, local attractions and things to do in your favorite Salt Lake City, UT neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Salzburg",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "75",
      "Spa": "0",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/salzburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-salzburg-1734540224442-5:Square?wid=768&fit=constrain",
      "headline": "Salzburg: Baroque Charm, Mozart Melodies, and Alpine Adventures Await",
      "description": "Salzburg, a city rich in baroque architecture and musical history, is a beautiful combination of old-world charm and modern vitality. As the birthplace of Mozart, it is a mecca for classical music lovers, with concerts and festivals honoring his legacy year-round. The city's historic center, a UNESCO World Heritage site, is a warren of cobblestone streets, elegant churches, and inviting cafes, beckoning you to step back in time. Salzburg's prime location also makes it the perfect jumping-off point to the nearby Alps, offering outdoor enthusiasts the chance to enjoy hiking, skiing, and stunning vistas."
    },
    {
      "city": "Innsbruck",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "90",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/innsbruck.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-innsbruck-173454024953950:Square?wid=768&fit=constrain",
      "headline": "Innsbruck: Alpine Adventure Meets Old-World Charm",
      "description": "Innsbruck, the capital of the Alps, is a place that combines the best of both worlds: a city steeped in history and tradition, surrounded by breathtaking natural beauty. Whether you're a culture vulture, an outdoor enthusiast, or simply looking to relax in a stunning setting, Innsbruck has something for everyone. The city's historic old town, a UNESCO World Heritage site, is a must-see, with its medieval buildings, narrow streets, and charming shops. The surrounding mountains offer a wide range of activities, from skiing and snowboarding in the winter to hiking and mountain biking in the summer. And with its vibrant arts scene, lively nightlife, and world-class restaurants, Innsbruck is the perfect place to unwind after a day of exploration."
    },
    {
      "city": "Bolzano",
      "country": "Italy",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "75",
      "Spa": "1",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/bolzano.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-bolzano-364815414850938:Square?wid=768&fit=constrain",
      "headline": "Bolzano: Where Italian Elegance Meets Alpine Innovation",
      "description": "Bolzano is a captivating blend of Italian elegance and Alpine charm, where the historic meets the contemporary in a seamless fusion. The city's old town, with its medieval architecture and vibrant market squares, is a living museum that invites visitors to step back in time. Yet, Bolzano is also a hub of innovation, known for its cutting-edge technology park and the South Tyrol Museum of Archaeology, home to the famous Ice Man, Ötzi. Whether you're exploring the city's cultural landmarks, shopping in its upscale boutiques, or savoring the local cuisine, Bolzano offers a unique and enriching experience."
    },
    {
      "city": "Ogden",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "75",
      "Spa": "0",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/ogden.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ut-ogden-173453293207342:Square?wid=768&fit=constrain",
      "headline": "Downtown Ogden: Historic Charm, River Views, and Modern Comfort",
      "description": "In the heart of downtown Ogden, you'll find a vibrant city center with a rich array of experiences. From the historic 25th Street, with its vintage shops and local restaurants, to the Ogden River, which offers walking paths and scenic views, there's something for everyone. Whether you're in town for a business conference, family vacation or to explore the city's arts and culture, our properties in Ogden offer the amenities you need for a comfortable stay, including free Wi-Fi, fitness centers and complimentary breakfast. With easy access to the Ogden-Weber Convention Center and Weber State University, our hotels are designed to make your stay both convenient and memorable."
    },
    {
      "city": "Missoula",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "25",
      "Golf": "1",
      "Ski": "75",
      "Spa": "1",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/missoula.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-mt-missoula-173453710507786:Square?wid=768&fit=constrain",
      "headline": "Missoula: Where Mountain Adventure Meets Lively College Town Vibes",
      "description": "Missoula, Montana, is a city that offers a perfect blend of natural beauty and urban vibrancy. Nestled in a valley surrounded by majestic mountains, it's a haven for outdoor enthusiasts, with easy access to top-notch hiking, biking, and rafting. The presence of the University of Montana infuses the city with a youthful spirit, creating a cultural melting pot with a flourishing arts community, diverse culinary scene, and a calendar full of lively festivals. Whether your interests lie in exploring nature or savoring city life, Missoula is the ideal place to find the perfect balance."
    },
    {
      "city": "Flagstaff",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "25",
      "Golf": "1",
      "Ski": "75",
      "Spa": "1",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/flagstaff.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/dome-lowell-observatory-flagstaff-arizona:Square?wid=768&fit=constrain",
      "headline": "Downtown Flagstaff: Gateway to Grand Canyon Adventure and Relaxation",
      "description": "Downtown Flagstaff is a vibrant area with a mix of dining, shopping, and entertainment options. The city is also close to a number of popular attractions, including the Grand Canyon and Petrified Forest National Park. Whether you're looking to take a day trip to explore the great outdoors or simply want to relax and take in the local atmosphere, our hotels provide the perfect base. Many of our properties offer amenities like free Wi-Fi, fitness centers, and complimentary breakfast, so you'll have everything you need for a great stay."
    },
    {
      "city": "Annecy",
      "country": "France",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "75",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/annecy.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-annecy-173454124038880:Square?wid=768&fit=constrain",
      "headline": "Annecy: Alpine Venice Where Medieval Charm Meets Lake Adventure",
      "description": "Annecy is a destination that effortlessly combines the allure of a medieval town with the vibrancy of modern life. Often referred to as the \"Venice of the Alps,\" its canals and ancient bridges create a peaceful and captivating ambiance. The city's lively markets and quaint cafes provide a glimpse into authentic local living. Surrounded by the majestic peaks of the Alps, Annecy is the perfect starting point for outdoor enthusiasts, offering activities such as hiking, mountain biking, and sailing on the pristine waters of Lake Annecy. The city's rich history is beautifully preserved in its old town, where every corner tells a story of times gone by."
    },
    {
      "city": "Bozeman",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "50",
      "Ski": "75",
      "Spa": "1",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/bozeman.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/hike-summer-mountains-bozeman-montana:Square?wid=768&fit=constrain",
      "headline": "Discover Bozeman Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bozeman, MT your way! Explore restaurants, local attractions and things to do in your favorite Bozeman, MT neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Aso",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "75",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/paso-robles.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/vineyard-winery-california-dusk:Square?wid=768&fit=constrain",
      "headline": "Paso Robles: Small-Town Charm Meets World-Class Wine Country",
      "description": "Paso Robles is a city that's the perfect blend of the warmth of a small town and the sophistication of a world-class wine region. Known as the \"City of Oaks,\" its landscape is dotted with rolling hills, vineyards, and majestic oak trees, providing a stunning backdrop for a variety of outdoor activities. Whether you're a wine enthusiast, a golf aficionado, or someone who enjoys the tranquility of a spa retreat, you'll find something to love in Paso Robles. The city's downtown area is a bustling hub of boutiques, art galleries, and gourmet eateries, making it an ideal place to relax and explore."
    },
    {
      "city": "Steamboat Springs",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "90",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/steamboat-springs.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/steam-boat-springs-hot-colorado-winter:Square?wid=768&fit=constrain",
      "headline": "Discover Steamboat Springs Your Way with Marriott Bonvoy",
      "description": "Visit Steamboat Springs, CO your way! Explore restaurants, local attractions and things to do in your favorite Steamboat Springs, CO neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Aspen",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "90",
      "Spa": "50",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/aspen.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/ski-snowmass-green-cabin-colorado:Square?wid=768&fit=constrain",
      "headline": "Aspen: Where Rocky Mountain Adventure Meets Luxury and Culture",
      "description": "Aspen is a year-round playground for the senses, combining world-class skiing, snowboarding and snowmobiling with a vibrant arts and culture scene, exciting nightlife, great restaurants and luxury accommodations. This historic mining town is surrounded by the majestic peaks of the Rocky Mountains and is a haven for outdoor enthusiasts with its beautiful hiking, mountain biking, horseback riding and whitewater rafting in the summer. Aspen is also a center for the arts, hosting the annual Aspen Music Festival and the Food & Wine Classic, as well as a number of high-end art galleries."
    },
    {
      "city": "Breckenridge",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "90",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/breckenridge.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/whiskey-cocktail-drink-pour-bartender-usage-mhrsHOUMWre.1053936:Square?wid=768&fit=constrain",
      "headline": "Breckenridge: Victorian Charm and Epic Rocky Mountain Adventure",
      "description": "Breckenridge is the quintessential mountain town, renowned for its breathtaking vistas and a heritage steeped in the gold mining era. Tucked away in the heart of the Rocky Mountains, the city's historic Main Street is a treasure trove of impeccably preserved Victorian buildings that now house a vibrant mix of boutiques, art galleries, and inviting eateries. A trip to Breckenridge wouldn't be complete without a visit to the Breckenridge Creative Arts District or a scenic ride on the Breckenridge Gondola, offering panoramic views of the majestic peaks. Whether you're an adventure enthusiast or seeking a serene mountain retreat, the city's dynamic energy has something for everyone."
    },
    {
      "city": "Hakodate Hokkaido",
      "country": "Japan",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "75",
      "Spa": "50",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hakodate.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-hakodate-161968837837066:Square?wid=768&fit=constrain",
      "headline": "Hakodate: Historic Harbors, Fresh Markets, and Dazzling Night Views",
      "description": "The city of Hakodate, nestled along the coast, is a destination that beckons to those who appreciate a fusion of the past and the present. Its historical precinct, featuring landmarks like the Red Brick Warehouse and the charm of Motomachi Street, offers a window into its days as a bustling port of trade. The lively morning market, brimming with the catch of the day and local delights, is a treat for the senses. And for an unforgettable vista, a journey to the summit of Mount Hakodate is a must, especially at dusk when the city lights twinkle below, earning it a place among Japan's most captivating nightscapes. Moreover, Hakodate’s prime location serves as a springboard to the wonders of the region, from the nostalgic Otaru Canal to the unspoiled beauty of Shikotsu-Toya National Park."
    },
    {
      "city": "North Conway",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "75",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/north-conway.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/covered-bridge-new-hampshire:Square?wid=768&fit=constrain",
      "headline": "Discover North Conway, NH: Your Personalized Marriott Adventure Awaits",
      "description": "Visit North Conway, NH your way! Explore restaurants, local attractions and things to do in your favorite North Conway, NH neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Park City",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "90",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/park-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/st-regis-deer-valley-fire:Square?wid=768&fit=constrain",
      "headline": "Park City: Wild West Charm Meets World‑Class Mountain Escape",
      "description": "Park City is a captivating mountain town that artfully marries the allure of the Wild West with the elegance of a contemporary resort escape. Renowned for its premier ski resorts, such as Park City Mountain and Deer Valley Resort, the city is a haven for winter enthusiasts, offering a plethora of activities from snowboarding to cross-country skiing. Yet, the allure of Park City extends beyond its slopes, with a historic Main Street adorned with upscale boutiques, art galleries, and a diverse culinary scene, ensuring there is something to captivate you throughout the year. The city’s proud mining history is reflected in its beautifully preserved Victorian architecture, while the annual Sundance Film Festival infuses the city with a global cultural buzz."
    },
    {
      "city": "Noville",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "75",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/novi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-mi-novi-173453622526097:Square?wid=768&fit=constrain",
      "headline": "Discover Novi, MI: Eat, Explore, and Stay with Marriott",
      "description": "Visit Novi, MI your way! Explore restaurants, local attractions and things to do in your favorite Novi, MI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Blue Mountains",
      "country": "Canada",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "80",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/blue-mountains.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-can-blue-mountains-173453472374056:Square?wid=768&fit=constrain",
      "headline": "Discover Blue Mountains, Canada: Your Marriott Adventure Awaits",
      "description": "Visit Blue Mountains, Canada your way! Explore restaurants, local attractions and things to do in your favorite Blue Mountains, Canada neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Vail",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "90",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/vail.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/burger-hamburger-onion-lettuce-pickle-lunch-swh.306082:Square?wid=768&fit=constrain",
      "headline": "Discover Vail Your Way: Neighborhood Eats, Adventures, and Stays",
      "description": "Visit Vail, CO your way! Explore restaurants, local attractions and things to do in your favorite Vail, CO neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Verbier",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "90",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/verbier.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-verbier-173453812648879:Square?wid=768&fit=constrain",
      "headline": "Verbier: Alpine Adventure Playground for Year-Round Thrills",
      "description": "Verbier, the ultimate playground for snow and ski enthusiasts, is one of the largest ski areas in the Alps. The vibrant town is home to a world-class après-ski scene, with live music, cozy chalets, and a wide range of dining options. But the fun doesn't stop there. Verbier is a mecca for outdoor activities, offering everything from snowshoeing and ice climbing to hiking and mountain biking. And with its stunning mountain and valley views, Verbier is the perfect year-round destination for those who love adventure and relaxation."
    },
    {
      "city": "Bakuriani",
      "country": "Georgia",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "75",
      "Spa": "0",
      "Culture": "25",
      "Music": "10",
      "pageUrl": "https://www.marriott.com/en/destinations/baku.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aze-baku-173453292196930:Square?wid=768&fit=constrain",
      "headline": "Discover Baku Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Baku, Azerbaijan your way! Explore restaurants, local attractions and things to do in your favorite Baku, Azerbaijan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Niseko",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "90",
      "Spa": "50",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/ise.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-ise-173453726802789:Square?wid=768&fit=constrain",
      "headline": "Discover Ise Your Way: Stay, Savor, and Explore with Marriott",
      "description": "Visit Ise, Japan your way! Explore restaurants, local attractions and things to do in your favorite Ise, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sugar Mountain",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "25",
      "Ski": "90",
      "Spa": "50",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/sugar-mountain.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-nc-sugar-mountain-173453615495469:Square?wid=768&fit=constrain",
      "headline": "Discover Sugar Mountain, NC: Local Flavor, Adventure, Your Marriott Stay",
      "description": "Visit Sugar Mountain, NC your way! Explore restaurants, local attractions and things to do in your favorite Sugar Mountain, NC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sion",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "75",
      "Spa": "50",
      "Culture": "60",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/sion.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-sion-173453730833626:Square?wid=768&fit=constrain",
      "headline": "Discover Sion, Switzerland: Savor, Explore, and Stay with Marriott",
      "description": "Visit Sion, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Sion, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Winter Park",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "25",
      "Ski": "75",
      "Spa": "0",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/winter-park.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-co-winter-park-173454091123119:Square?wid=768&fit=constrain",
      "headline": "Discover Winter Park, CO: Your Colorado Mountain Getaway Awaits",
      "description": "Visit Winter Park, CO your way! Explore restaurants, local attractions and things to do in your favorite Winter Park, CO neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kamloops",
      "country": "Canada",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "50",
      "Ski": "75",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kamloops.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-can-kamloops-173453499194277:Square?wid=768&fit=constrain",
      "headline": "Discover Kamloops Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Kamloops, Canada your way! Explore restaurants, local attractions and things to do in your favorite Kamloops, Canada neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "South Lake Tahoe",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "90",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/lake-tahoe.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/tree-snow-lake-tahoe-california:Square?wid=768&fit=constrain",
      "headline": "Lake Tahoe: Alpine Adventures and Serenity in Every Season",
      "description": "Lake Tahoe in a stunning alpine lake that beckons nature lovers and thrill-seekers to its shores. Nestled amidst the grandeur of the Sierra Nevada mountains, this postcard-perfect city invites you to indulge in a wealth of activities throughout the year. From the thrill of skiing to the tranquility of a summer hike, the possibilities are endless. The lake's pristine waters, the whispering forests, and the sweeping vistas set the stage for cherished memories."
    },
    {
      "city": "Mammoth Lakes",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "90",
      "Spa": "25",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/mammoth-lakes.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-mammoth-lakes-173454081648575:Square?wid=768&fit=constrain",
      "headline": "Discover Mammoth Lakes Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Mammoth Lakes, CA your way! Explore restaurants, local attractions and things to do in your favorite Mammoth Lakes, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Baqueira",
      "country": "Spain",
      "Beach": "1.0",
      "Culinary": "25",
      "Golf": "90",
      "Ski": "90",
      "Spa": "1",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/baqueira.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-esp-baqueira-173454034709213:Square?wid=768&fit=constrain",
      "headline": "Baqueira: Beyond Skiing—Spas, Flavors, and Mountain Adventures",
      "description": "But Baqueira is more than just a ski resort. It’s a village with a range of dining options, from traditional mountain cuisine to international flavors, and a lively après-ski scene that brings the community together. Many of our hotels offer spa services and indoor pools, perfect for relaxing and unwinding. And if you want to explore beyond the resort, the surrounding natural beauty provides opportunities for snowshoeing, cross-country skiing, and scenic hikes. Our commitment to exceptional service ensures that your stay in Baqueira is both memorable and enjoyable."
    },
    {
      "city": "Flims Waldhaus",
      "country": "Switzerland",
      "Beach": "1.0",
      "Culinary": "25",
      "Golf": "1",
      "Ski": "90",
      "Spa": "75",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/flims.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-flims-173453634105381:Square?wid=768&fit=constrain",
      "headline": "Discover Flims, Switzerland: Your Personalized Alpine Escape with Marriott",
      "description": "Visit Flims, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Flims, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hokkaido",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "90",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/hokkaido.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-hokkaido-173454025874820:Square?wid=768&fit=constrain",
      "headline": "Hokkaido Escape: Powder Snow, Hot Springs, and Fresh Seafood",
      "description": "Hokkaido, the northernmost island of Japan, is a place of natural beauty and adventure. From the rugged mountains and serene lakes to the lush national parks and soothing hot springs, Hokkaido is a haven for those who seek to be close to nature. In the winter, the island becomes a wonderland, offering some of the world’s best skiing and snowboarding at renowned resorts like Niseko and Furano. The island is also known for its vibrant food culture, with fresh seafood and local specialties like ramen and Genghis Khan. Whether you’re exploring the bustling markets of Sapporo or the charming streets of Otaru, Hokkaido’s hotels provide the perfect base for your adventure."
    },
    {
      "city": "Big Sky",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "25",
      "Ski": "90",
      "Spa": "0",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/big-sky.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-mt-big-sky-173454015043655:Square?wid=768&fit=constrain",
      "headline": "Big Sky Adventures: Winter Carnival Thrills to Hot Springs Chill",
      "description": "Whether you’re planning a family vacation or a romantic getaway, Big Sky’s diverse attractions and events will keep you entertained. The town hosts the famous Winter Carnival and the Big Sky Documentary Film Festival, celebrating the community’s love for winter sports and storytelling. For a more relaxed experience, the area’s hot springs and spas offer a soothing respite after a day of outdoor activities. Many of our hotels feature on-site dining, fitness centers, and family-friendly services, making it easy to unwind and refuel before your next Big Sky adventure."
    },
    {
      "city": "Lake Placid",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "90",
      "Spa": "25",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/lake-placid.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lake-placid-autumn-new-york:Square?wid=768&fit=constrain",
      "headline": "Lake Placid: Olympic Spirit Meets Adirondack Adventure All Year",
      "description": "Lake Placid is a charming village located in the heart of the Adirondack Mountains, celebrated for its breathtaking natural landscapes and storied Olympic legacy. As the proud host of the Winter Olympics on two occasions, Lake Placid continues to provide top-tier facilities for winter sports aficionados, from skiing to ice skating. When the snow melts, the village blossoms into a haven for outdoor adventure, with an array of hiking trails, pristine lakes for boating and fishing, and picturesque bike paths. The downtown area is a delightful fusion of old-world charm and modern amenities, offering a diverse range of boutiques, galleries, and dining options to suit every preference."
    },
    {
      "city": "San Carlos de Bariloche",
      "country": "Argentina",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "90",
      "Spa": "50",
      "Culture": "40",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/san-carlos-de-bariloche.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arg-san-carlos-de-bariloc-173453488379782:Square?wid=768&fit=constrain",
      "headline": "Bariloche Stays: Lakeside Serenity, Mountain Views, City Convenience",
      "description": "From the heart of the city to the quiet outskirts, our hotels in San Carlos De Bariloche are the perfect place to stay during your visit. You'll find many of our properties offer rooms with stunning views of the mountains and lakes, a peaceful setting for your trip. Plus, you'll be close to top attractions like Cerro Catedral and the Llao Llao Peninsula. With amenities like free Wi-Fi, fitness centers and spa services, you'll have everything you need for a great trip."
    }
  ],
  "spa": [
    {
      "city": "Cancun",
      "country": "Mexico",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/cancun.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-boat-riding-cst322465-166984698498724:Square?wid=768&fit=constrain",
      "headline": "Discover Cancún Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Cancún, Mexico your way! Explore restaurants, local attractions and things to do in your favorite Cancún, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Abu Dhabi",
      "country": "United Arab Emirates",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/abu-dhabi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-are-abu-dhabi-173454035351045:Square?wid=768&fit=constrain",
      "headline": "Abu Dhabi Adventures: Culture, Coastlines, and High-Speed Thrills Await",
      "description": "Whether you’re strolling the lively markets along the Corniche, or exploring the world-famous Abu Dhabi Louvre, the city’s diverse attractions beckon. Our Abu Dhabi hotels cater to every type of traveler, whether you’re visiting for business or leisure. Enjoy free Wi-Fi, well-equipped fitness centers, and tempting dining options, ensuring a comfortable and memorable stay. Whether you’re here to experience the city’s vibrant arts scene, relax on a luxurious beach, or feel the excitement of the Formula 1 track at Yas Marina Circuit, our hotels provide the perfect base for an unforgettable adventure in Abu Dhabi."
    },
    {
      "city": "Budapest",
      "country": "Hungary",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/budapest.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-hun-budapest-173454024873448:Square?wid=768&fit=constrain",
      "headline": "Discover Budapest Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Budapest, Hungary your way! Explore restaurants, local attractions and things to do in your favorite Budapest, Hungary neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Vienna",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/vienna.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-vienna-173453913119285:Square?wid=768&fit=constrain",
      "headline": "Vienna: Imperial Splendor Meets Cutting-Edge Arts and Culture",
      "description": "Vienna, a city where the grandeur of baroque architecture meets the pulse of innovative art and culture, is a masterful blend of history and modernity. As the epicenter of classical music, it boasts the prestigious Vienna State Opera and the renowned Vienna Philharmonic, delivering world-class performances throughout the year. The city's imperial legacy is on display in its opulent palaces, from Schönbrunn to the Hofburg, offering a window into the lavish past of the Habsburg dynasty. Whether you're meandering through the verdant gardens of the Belvedere Palace or savoring a coffee in a traditional café, Vienna's allure and sophistication will enchant you at every step."
    },
    {
      "city": "Bangkok",
      "country": "Thailand",
      "Beach": "80.0",
      "Culinary": "90",
      "Golf": "70",
      "Ski": "0",
      "Spa": "75",
      "Culture": "70",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/bangkok.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/wi-bkkwi-exterior-bts-day-time-13470:Square?wid=768&fit=constrain",
      "headline": "Bangkok Your Way: Eat, Explore, and Stay with Marriott",
      "description": "Visit Bangkok, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Bangkok, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Dubai",
      "country": "United Arab Emirates",
      "Beach": "80.0",
      "Culinary": "80",
      "Golf": "70",
      "Ski": "0",
      "Spa": "90",
      "Culture": "50",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/dubai.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jumeirah-mosque-snst69576-1670007351783-9:Square?wid=768&fit=constrain",
      "headline": "Discover Dubai Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Dubai, United Arab Emirates your way! Explore restaurants, local attractions and things to do in your favorite Dubai, United Arab Emirates neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paris",
      "country": "France",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "100",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/paris.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arc-de-triomphe-paris-634207441403522:Square?wid=768&fit=constrain",
      "headline": "Discover Paris Your Way with Marriott Bonvoy Stays",
      "description": "Visit Paris, France your way! Explore restaurants, local attractions and more in your favorite Paris neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Tokyo",
      "country": "Japan",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "90",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/tokyo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/al-tyoal-asakusa-32531:Square?wid=768&fit=constrain",
      "headline": "Tokyo Tastemakers: Culture, Cuisine, and City Nights Await",
      "description": "Immerse yourself in Tokyo’s rich culture and Michelin-starred culinary scene. From the sushi bars of Tsukiji Outer Market to the trendy neighborhoods of Harajuku and Ginza, there’s something for every taste. Our hotels are the perfect starting point for your adventures, with many offering complimentary breakfast and evening events that capture the spirit of the city."
    },
    {
      "city": "London",
      "country": "United Kingdom",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "90",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/london.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-skyline-w-twr-brdg94263-167001018629978:Square?wid=768&fit=constrain",
      "headline": "Discover London Your Way with Marriott Bonvoy Hotels",
      "description": "Visit London, United Kingdom your way! Explore restaurants, local attractions and more in your favorite London neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New York City",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "85",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/nyc.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lower-manhattan-skyline-new-york-city-new-york:Square?wid=768&fit=constrain",
      "headline": "Experience New York City Your Way With Marriott Bonvoy",
      "description": "Visit New York City, NY your way! Explore restaurants, local attractions and more in your favorite New York City neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Singapore",
      "country": "Singapore",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "70",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/singapore.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/rz-sinrz-hotel-within-marina-bay-36470:Square?wid=768&fit=constrain",
      "headline": "Singapore: Where Urban Energy Meets Lush Tropical Escapes",
      "description": "Singapore is a city that’s not just about the urban jungle, but also about real jungles. The Singapore Zoo, Jurong Bird Park, and the Singapore Botanic Gardens are just a few of the green spots where you can relax and reconnect with nature. Our hotels in Singapore often have their own tranquil spaces, including rooftop pools and spas, perfect for unwinding after a day of exploration. With a wide range of deals and packages, we make it easy to enjoy the best of Singapore, from its bustling markets to its serene beaches, ensuring your visit is nothing short of extraordinary."
    },
    {
      "city": "Sydney",
      "country": "Australia",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "70",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/sydney.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/mc-sydmc-sydney-harbour-skyline-30873:Square?wid=768&fit=constrain",
      "headline": "Unlock Sydney’s Best Neighborhoods with Marriott Bonvoy Stays",
      "description": "Visit Sydney, Australia your way! Explore restaurants, local attractions and things to do in your favorite Sydney, Australia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Zurich",
      "country": "Switzerland",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/zurich.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-1267692130-zurich-hero-11029:Square?wid=768&fit=constrain",
      "headline": "Discover Zurich Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Zurich, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Zurich, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Miami",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Honolulu",
      "country": "United States",
      "Beach": "100.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/honolulu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-hi-honolulu-173453529708227:Square?wid=768&fit=constrain",
      "headline": "Discover Honolulu Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Honolulu, HI your way! Explore restaurants, local attractions and things to do in your favorite Honolulu, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Fort Lauderdale",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/fort-lauderdale.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/canals-boat-fort-lauderdale-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Fort Lauderdale Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Fort Lauderdale, FL your way! Explore restaurants, local attractions and things to do in your favorite Fort Lauderdale, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lausanne",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/lausanne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-lausanne-173453832692852:Square?wid=768&fit=constrain",
      "headline": "Lausanne: Olympic Spirit, Lakeside Charm, Timeless Swiss Allure",
      "description": "Lausanne, a city that effortlessly marries the past with the present, is a charming jewel perched on the shores of Lake Geneva. As the Olympic Capital, it is home to the International Olympic Committee and the Olympic Museum, a pilgrimage site for sports aficionados. The city's old town, with its labyrinth of cobblestone streets and medieval facades, is a window to history. Lausanne is also celebrated for its dynamic arts and culture scene, with a plethora of museums, galleries, and theaters showcasing local and international talent. Whether you're indulging in the delights of Swiss cuisine at a cozy bistro or taking in the sweeping vistas from the top of the Cathédrale Notre-Dame, there's a treasure to be found for every visitor."
    },
    {
      "city": "West Palm Beach",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/worth-avenue-palm-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Beach Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Palm Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Palm Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Santa Barbara",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-barbara.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/golf-course-goleta-california:Square?wid=768&fit=constrain",
      "headline": "Discover Santa Barbara Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Santa Barbara, CA your way! Explore restaurants, local attractions and things to do in your favorite Santa Barbara, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bath",
      "country": "United Kingdom",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "75",
      "Culture": "90",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/bath.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-bath-224015010835747:Square?wid=768&fit=constrain",
      "headline": "Discover Bath Your Way with Marriott Bonvoy Stays",
      "description": "Visit Bath, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Bath, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Phuket",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/phuket.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-hktmd-phuket-beach-sunset-37586-67997:Square?wid=768&fit=constrain",
      "headline": "Discover Phuket Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Phuket, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Phuket, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hot Springs",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "90",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hot-springs.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/hot-springs-national-park-arkansas:Square?wid=768&fit=constrain",
      "headline": "Soak, Stroll, and Unwind in Historic Hot Springs",
      "description": "Hot Springs is a city where nature and relaxation converge, making it a unique destination for those seeking a serene getaway. The city is renowned for its natural thermal springs, which have been a source of healing and rejuvenation for centuries. Visitors can soak in the warm waters at the historic Bathhouse Row, a National Historic Landmark District, or explore the scenic trails of the Hot Springs National Park. The charming downtown area is filled with boutiques, art galleries, and local eateries, offering a delightful blend of natural beauty and cultural richness."
    },
    {
      "city": "Carlsbad",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/carlsbad.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-carlsbad-404672065694324:Square?wid=768&fit=constrain",
      "headline": "Carlsbad: Coastal Escape Where Relaxation Meets Endless Adventure",
      "description": "Carlsbad is a charming coastal gem that marries natural splendor with a lively recreational scene. Renowned for its pristine beaches, you can bask in the sun, take a leisurely stroll, or even try your hand at surfing. A mere stone's throw from the bustling attractions of San Diego, Carlsbad offers a more tranquil, yet accessible, retreat for those seeking a respite from city life. With its golf courses, water parks, and luxurious spas, the city provides a myriad of options for both relaxation and excitement, making it an ideal destination for those in search of a revitalizing escape."
    },
    {
      "city": "Glenwood Springs",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "50",
      "Spa": "75",
      "Culture": "25",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/glenwood-springs.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/hanging-lake-colorado:Square?wid=768&fit=constrain",
      "headline": "Glenwood Springs: Soothing Hot Springs, Big Adventure, Small-Town Charm",
      "description": "Glenwood Springs is a captivating blend of natural beauty and small-town charm, making it an ideal getaway for those seeking relaxation and adventure. Known for its world-famous hot springs, the city is a haven for spa enthusiasts and outdoor lovers alike. The Glenwood Hot Springs Pool, the largest mineral hot springs pool in the world, offers a soothing escape, while Iron Mountain Hot Springs provides a more intimate setting with stunning views. For thrill-seekers, the nearby White River National Forest and the Colorado River deliver endless opportunities for hiking, biking, and rafting. The city’s historic downtown area, lined with charming boutiques and eclectic eateries, adds a layer of cultural richness to your visit."
    },
    {
      "city": "Bath",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/bath.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-bath-224015010835747:Square?wid=768&fit=constrain",
      "headline": "Discover Bath Your Way with Marriott Bonvoy Stays",
      "description": "Visit Bath, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Bath, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Uluwatu Bali",
      "country": "Indonesia",
      "Beach": "100.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Calistoga",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/cali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-col-cali-747968479330686:Square?wid=768&fit=constrain",
      "headline": "Cali: Where Salsa Rhythms Meet Colonial Charm and Culture",
      "description": "Cali is a city that lives and breathes culture, and it's not just the warm climate that makes it so inviting. Known as the world's capital of salsa, the rhythm of the music and the dance is in the very air you breathe. The annual Salsa Festival is a must-see for anyone who loves to move to the beat, but you can find the music and the movement in the city's many dance studios and clubs all year round. But there's more to Cali than just the dance. The city is home to some of the best-preserved colonial architecture in the country, as well as a number of museums that showcase the city's rich history."
    },
    {
      "city": "Costa Navarino",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/costa-navarino.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-costa-navarino-173453293708717:Square?wid=768&fit=constrain",
      "headline": "Discover Costa Navarino: Your Personalized Greek Getaway with Marriott",
      "description": "Visit Costa Navarino, Greece your way! Explore restaurants, local attractions and things to do in your favorite Costa Navarino, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Park City",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "90",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/park-city.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/st-regis-deer-valley-fire:Square?wid=768&fit=constrain",
      "headline": "Park City: Wild West Charm Meets World‑Class Mountain Escape",
      "description": "Park City is a captivating mountain town that artfully marries the allure of the Wild West with the elegance of a contemporary resort escape. Renowned for its premier ski resorts, such as Park City Mountain and Deer Valley Resort, the city is a haven for winter enthusiasts, offering a plethora of activities from snowboarding to cross-country skiing. Yet, the allure of Park City extends beyond its slopes, with a historic Main Street adorned with upscale boutiques, art galleries, and a diverse culinary scene, ensuring there is something to captivate you throughout the year. The city’s proud mining history is reflected in its beautifully preserved Victorian architecture, while the annual Sundance Film Festival infuses the city with a global cultural buzz."
    },
    {
      "city": "Porto Cervo",
      "country": "Italy",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/porto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-porto-1734533917305-4:Square?wid=768&fit=constrain",
      "headline": "Discover Porto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Porto, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Porto, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bora Bora",
      "country": "French Polynesia",
      "Beach": "100.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/bora-bora.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pyf-bora-bora-230141600241362:Square?wid=768&fit=constrain",
      "headline": "Discover Bora Bora Your Way with Marriott Bonvoy Stays",
      "description": "Visit Bora Bora, French Polynesia your way! Explore restaurants, local attractions and things to do in your favorite Bora Bora, French Polynesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Scottsdale",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "90",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/scottsdale.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aerial-from-camelback-349440964711826:Square?wid=768&fit=constrain",
      "headline": "Unlock Scottsdale: Your Neighborhood Adventure with Marriott Bonvoy",
      "description": "Visit Scottsdale, AZ your way! Explore restaurants, local attractions and things to do in your favorite Scottsdale, AZ neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Marco Island",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/marco-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/tigertail-beach-marco-island-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Marco Island: Your Personalized Marriott Bonvoy Getaway",
      "description": "Visit Marco Island, FL your way! Explore restaurants, local attractions and things to do in your favorite Marco Island, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Vail",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "90",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/vail.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/burger-hamburger-onion-lettuce-pickle-lunch-swh.306082:Square?wid=768&fit=constrain",
      "headline": "Discover Vail Your Way: Neighborhood Eats, Adventures, and Stays",
      "description": "Visit Vail, CO your way! Explore restaurants, local attractions and things to do in your favorite Vail, CO neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nha Trang",
      "country": "Vietnam",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/nha-trang.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-NhaTrang--24284-168917108711683:Square?wid=768&fit=constrain",
      "headline": "Nha Trang: Thrills, History, and Coastal Comfort for Everyone",
      "description": "Nha Trang is more than just a pretty face. It has a little something for everyone. History buffs will love the Long Son Pagoda and Po Nagar Cham Towers. Thrill-seekers can get their fix at the Dragon King Water Park or by exploring the diving spots in Nha Trang Bay. Our properties offer modern conveniences like free Wi-Fi, fitness centers, and family-friendly rooms, so you can enjoy your stay in comfort. Whether you’re here for a romantic getaway, a family vacation, or a business trip, Nha Trang’s diverse offerings and our exceptional service will make your stay one to remember."
    },
    {
      "city": "Coronado",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/coronado.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/sanci-grounds-7810:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Discover Coronado Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Coronado, CA your way! Explore restaurants, local attractions and things to do in your favorite Coronado, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Orange Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/orange-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-al-orange-beach-173453863873276:Square?wid=768&fit=constrain",
      "headline": "Discover Orange Beach Your Way with Marriott Bonvoy Stays",
      "description": "Visit Orange Beach, AL your way! Explore restaurants, local attractions and things to do in your favorite Orange Beach, AL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bursa",
      "country": "Türkiye",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/bursa.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-bursa-173453636133579:Square?wid=768&fit=constrain",
      "headline": "Discover Bursa Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bursa, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Bursa, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bali",
      "country": "Indonesia",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Koh Samui",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "70",
      "Golf": "50",
      "Ski": "0",
      "Spa": "80",
      "Culture": "50",
      "Music": "40",
      "pageUrl": "https://www.marriott.com/en/destinations/koh-samui.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tha-koh-samui-173453461018165:Square?wid=768&fit=constrain",
      "headline": "Discover Koh Samui Your Way with Marriott Bonvoy Stays",
      "description": "Visit Koh Samui, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Koh Samui, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Baden-Baden",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "90",
      "Culture": "70",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/baden-baden.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-baden-baden-173453845619152:Square?wid=768&fit=constrain",
      "headline": "Discover Baden-Baden Your Way with Marriott Bonvoy Stays",
      "description": "Visit Baden-Baden, Germany your way! Explore restaurants, local attractions and things to do in your favorite Baden-Baden, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sharm El Sheikh",
      "country": "Egypt",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "0",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/sharm-el-sheikh.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-egy-sharm-el-sheikh-173447130965449:Square?wid=768&fit=constrain",
      "headline": "Sharm El Sheikh: Where Sunlit Serenity Meets Underwater Adventure",
      "description": "Sharm El Sheikh is a sun-drenched paradise that seamlessly blends natural beauty with world-class amenities. Known as the \"City of Peace,\" this coastal gem offers pristine beaches, crystal-clear waters, and a vibrant coral reef that is perfect for snorkeling and diving. The city’s luxury resorts and spas provide an idyllic setting for relaxation, while its bustling markets and high-end shopping areas cater to every taste. Whether you’re seeking a tranquil escape or an adrenaline-fueled adventure, Sharm El Sheikh’s diverse offerings ensure that every visit is memorable."
    },
    {
      "city": "Palm Springs",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "90",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-springs.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/biking-bike-street-palm-springs-california:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Springs Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Palm Springs, CA your way! Explore restaurants, local attractions and things to do in your favorite Palm Springs, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hua Hin",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hua-hin.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/hhqmr-pool-0043:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Discover Hua Hin Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hua Hin, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Hua Hin, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Palm Desert",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-desert.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-palm-desert-173453806186258:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Desert: Dine, Explore, and Stay with Marriott",
      "description": "Visit Palm Desert, CA your way! Explore restaurants, local attractions and things to do in your favorite Palm Desert, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Maui",
      "country": "USA",
      "Beach": "95.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/maui.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastline-rainbow-maui-hawaii-wesHNMWIls.708720:Square?wid=768&fit=constrain",
      "headline": "Discover Maui Your Way with Marriott Bonvoy Stays",
      "description": "Visit Maui, HI your way! Explore restaurants, local attractions and things to do in your favorite Maui, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cabo San Lucas",
      "country": "Mexico",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/cabo-san-lucas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/el-arco-lovers-beach-cabo-san-lucas-mexico:Square?wid=768&fit=constrain",
      "headline": "Discover Cabo San Lucas Your Way with Marriott Bonvoy",
      "description": "Visit Cabo San Lucas, Mexico your way! Explore restaurants, local attractions and things to do in your favorite Cabo San Lucas, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Geneva",
      "country": "Switzerland",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "50",
      "Spa": "75",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/geneva.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-geneva-429826027636888:Square?wid=768&fit=constrain",
      "headline": "Geneva: Where Alpine Beauty Meets Global Peace and Culture",
      "description": "Geneva is a city that effortlessly combines the best of both worlds—a stunning lakefront setting with breathtaking views of the Alps, and a place where international diplomacy meets a rich tapestry of culture and history. Known as the \"Peace Capital,\" Geneva is home to numerous international organizations, including the United Nations and the Red Cross, making it a hub for global affairs. But don't be fooled by its serious side—Geneva offers a delightful blend of sophisticated charm and natural beauty, from its iconic Jet d'Eau to the tranquil Botanical Garden. Whether you're exploring the historic Old Town, enjoying the vibrant culinary scene, or taking a leisurely stroll along the lake, every corner of the city invites you to discover its unique blend of elegance and warmth."
    },
    {
      "city": "Elounda - Crete",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/crete.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-crete-151586342206659:Square?wid=768&fit=constrain",
      "headline": "Discover Crete Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Crete, Greece your way! Explore restaurants, local attractions and things to do in your favorite Crete, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paradise Island",
      "country": "Bahamas",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/ise.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-ise-173453726802789:Square?wid=768&fit=constrain",
      "headline": "Discover Ise Your Way: Stay, Savor, and Explore with Marriott",
      "description": "Visit Ise, Japan your way! Explore restaurants, local attractions and things to do in your favorite Ise, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Phuket Island",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/phuket.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-hktmd-phuket-beach-sunset-37586-67997:Square?wid=768&fit=constrain",
      "headline": "Discover Phuket Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Phuket, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Phuket, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paros",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/paros.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-paros-173453073398731:Square?wid=768&fit=constrain",
      "headline": "Discover Paros, Greece Your Way with Marriott Bonvoy",
      "description": "Visit Paros, Greece your way! Explore restaurants, local attractions and things to do in your favorite Paros, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Aruba",
      "country": "Aruba",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/aruba.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/downtown-island-oranjestad-aruba:Square?wid=768&fit=constrain",
      "headline": "Explore Aruba Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Aruba your way! Explore restaurants, local attractions and things to do in your favorite Aruba neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kapolei - Oahu",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "25",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/oahu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-surfers-waikiki-beach-668237464326125:Square?wid=768&fit=constrain",
      "headline": "Discover Oahu Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Oahu, HI your way! Explore restaurants, local attractions and things to do in your favorite Oahu, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "HOF BEI SALZBURG",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/salzburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-salzburg-1734540224442-5:Square?wid=768&fit=constrain",
      "headline": "Salzburg: Baroque Charm, Mozart Melodies, and Alpine Adventures Await",
      "description": "Salzburg, a city rich in baroque architecture and musical history, is a beautiful combination of old-world charm and modern vitality. As the birthplace of Mozart, it is a mecca for classical music lovers, with concerts and festivals honoring his legacy year-round. The city's historic center, a UNESCO World Heritage site, is a warren of cobblestone streets, elegant churches, and inviting cafes, beckoning you to step back in time. Salzburg's prime location also makes it the perfect jumping-off point to the nearby Alps, offering outdoor enthusiasts the chance to enjoy hiking, skiing, and stunning vistas."
    },
    {
      "city": "Jeju-do",
      "country": "South Korea",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/jeju-do.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-kor-jeju-do-173453618505169:Square?wid=768&fit=constrain",
      "headline": "Your Jeju, Your Way: Explore More with Marriott Bonvoy",
      "description": "Visit Jeju-do, South Korea your way! Explore restaurants, local attractions and things to do in your favorite Jeju-do, South Korea neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lucerne",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/lucerne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-lucerne-173453504213895:Square?wid=768&fit=constrain",
      "headline": "Discover Lucerne Your Way with Marriott Bonvoy Stays",
      "description": "Visit Lucerne, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Lucerne, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nha Trang City",
      "country": "Vietnam",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "75",
      "Culture": "50",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/nha-trang.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-NhaTrang--24284-168917108711683:Square?wid=768&fit=constrain",
      "headline": "Nha Trang: Thrills, History, and Coastal Comfort for Everyone",
      "description": "Nha Trang is more than just a pretty face. It has a little something for everyone. History buffs will love the Long Son Pagoda and Po Nagar Cham Towers. Thrill-seekers can get their fix at the Dragon King Water Park or by exploring the diving spots in Nha Trang Bay. Our properties offer modern conveniences like free Wi-Fi, fitness centers, and family-friendly rooms, so you can enjoy your stay in comfort. Whether you’re here for a romantic getaway, a family vacation, or a business trip, Nha Trang’s diverse offerings and our exceptional service will make your stay one to remember."
    },
    {
      "city": "Flims Waldhaus",
      "country": "Switzerland",
      "Beach": "1.0",
      "Culinary": "25",
      "Golf": "1",
      "Ski": "90",
      "Spa": "75",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/flims.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-flims-173453634105381:Square?wid=768&fit=constrain",
      "headline": "Discover Flims, Switzerland: Your Personalized Alpine Escape with Marriott",
      "description": "Visit Flims, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Flims, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Palm Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "25",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/palm-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/worth-avenue-palm-beach-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Palm Beach Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Palm Beach, FL your way! Explore restaurants, local attractions and things to do in your favorite Palm Beach, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Ascona",
      "country": "Switzerland",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "75",
      "Ski": "0",
      "Spa": "80",
      "Culture": "40",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/ascona.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-ascona-173453773057922:Square?wid=768&fit=constrain",
      "headline": "Discover Ascona Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Ascona, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Ascona, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sedona",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "80",
      "Culture": "50",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/sedona.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/sedona-airport-road-city-arizona:Square?wid=768&fit=constrain",
      "headline": "Sedona Escapes: Art, Flavors, and Red Rock Wonders Await",
      "description": "The heart of Sedona is a treasure trove of local delights, from one-of-a-kind shops and art galleries to restaurants that serve up a mix of southwestern cuisine and international flavors. And with iconic sites like Cathedral Rock, Bell Rock, and Oak Creek Canyon just a short drive away, you can easily experience the area’s awe-inspiring vistas and serene landscapes. Our hotels in Sedona are designed to complement the natural beauty of the surroundings, with many offering stunning views, spa services, and wellness programs. Stay connected with free Wi-Fi and enjoy the convenience of being close to both the city’s vibrant heart and its serene natural wonders."
    },
    {
      "city": "Seogwipo-si, jeju-do",
      "country": "South Korea",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/jeju-do.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-kor-jeju-do-173453618505169:Square?wid=768&fit=constrain",
      "headline": "Your Jeju, Your Way: Explore More with Marriott Bonvoy",
      "description": "Visit Jeju-do, South Korea your way! Explore restaurants, local attractions and things to do in your favorite Jeju-do, South Korea neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lahaina - Maui",
      "country": "USA",
      "Beach": "100.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/maui.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/coastline-rainbow-maui-hawaii-wesHNMWIls.708720:Square?wid=768&fit=constrain",
      "headline": "Discover Maui Your Way with Marriott Bonvoy Stays",
      "description": "Visit Maui, HI your way! Explore restaurants, local attractions and things to do in your favorite Maui, HI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Montreux",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/montreux.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-montreux-173452973943830:Square?wid=768&fit=constrain",
      "headline": "Montreux Magic: Lakeside Alps, Jazz Nights, Timeless Swiss Charm",
      "description": "Montreux, a city of natural beauty and cultural vibrancy, is nestled along the shores of Lake Geneva. Its breathtaking views of the Swiss Alps and the inviting waterfront promenade make it an ideal destination for a leisurely escape or a romantic retreat. Known for its music and art scene, Montreux is home to the renowned Montreux Jazz Festival and a variety of galleries and performance venues. Whether you're exploring the history of Chillon Castle or savoring the beauty of the surrounding vineyards, Montreux offers a seamless blend of historical allure and contemporary elegance to cater to all types of travelers."
    },
    {
      "city": "Mussoorie",
      "country": "India",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/mussoorie.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-mussoorie-173453813651826:Square?wid=768&fit=constrain",
      "headline": "Mussoorie: Queen of the Hills, Your Himalayan Escape Awaits",
      "description": "Mussoorie, cradled in the emerald embrace of the Himalayan foothills, is a mesmerizing hill station that beckons you to leave the plains behind for a rejuvenating escape. Dubbed the \"Queen of the Hills,\" Mussoorie's panoramic vistas, verdant forests, and temperate climate make it an alluring destination throughout the year. The city's natural splendor, from the snow-draped Himalayan peaks to the tranquil charm of Camel's Back Road, offers a playground for both nature enthusiasts and thrill-seekers. Whether you seek solace in the tea gardens, wish to delve into the history of colonial architecture, or simply want to bask in the peaceful ambiance, Mussoorie is a sanctuary of serenity and natural grandeur."
    },
    {
      "city": "Ubud Bali",
      "country": "Indonesia",
      "Beach": "0.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "0",
      "Spa": "90",
      "Culture": "70",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Legian Bali",
      "country": "Indonesia",
      "Beach": "90.0",
      "Culinary": "70",
      "Golf": "25",
      "Ski": "0",
      "Spa": "80",
      "Culture": "30",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-bali-535715813994822:Square?wid=768&fit=constrain",
      "headline": "Discover Bali Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bali, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Bali, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Monte Carlo",
      "country": "Monaco",
      "Beach": "80.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "80",
      "Culture": "50",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/monte-carlo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-mco-monte-carlo-173452968420014:Square?wid=768&fit=constrain",
      "headline": "Explore Monte-Carlo Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Monte-Carlo, Monaco your way! Explore restaurants, local attractions and things to do in your favorite Monte-Carlo, Monaco neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Basel-Pratteln",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "50",
      "Spa": "75",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/basel.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-basel-173447133994326:Square?wid=768&fit=constrain",
      "headline": "Basel Bliss: Riverside Strolls, Green Escapes, and Cozy Stays",
      "description": "Stroll along the Rhine’s scenic banks, where boat tours, riverside promenades, and local markets await. The city’s dedication to green spaces is evident in its many parks and gardens, offering the perfect setting for a leisurely walk or a relaxing afternoon. Our hotels in Basel offer a variety of thoughtful amenities, including complimentary Wi-Fi, fitness centers, and free breakfast, to ensure your stay is as comfortable as it is memorable. With a range of locations from the city center to quieter residential areas, our hotels cater to every type of traveler, making it easy to experience the best of Basel."
    },
    {
      "city": "Muang Phuket",
      "country": "Thailand",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/phuket.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-hktmd-phuket-beach-sunset-37586-67997:Square?wid=768&fit=constrain",
      "headline": "Discover Phuket Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Phuket, Thailand your way! Explore restaurants, local attractions and things to do in your favorite Phuket, Thailand neighborhoods as a Marriott Bonvoy Hotel guest."
    }
  ],
  "culture": [
    {
      "city": "Krakow",
      "country": "Poland",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "80",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/krakow.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pol-krakow-173453508751624:Square?wid=768&fit=constrain",
      "headline": "Krakow: Timeless Streets, Moving History, and Mountain Escapes",
      "description": "Krakow's story is more than just its well-preserved architecture. It extends to the Kazimierz district, once the vibrant center of the Jewish community, and the Auschwitz-Birkenau Memorial and Museum, a poignant reminder of the past. For those who seek relaxation, the nearby Wieliczka Salt Mine offers a unique underground experience, and the Tatra Mountains are a scenic escape for nature lovers. Whether your visit is for business or pleasure, our Krakow hotels are equipped with amenities such as free Wi-Fi, fitness centers, and complimentary breakfast, ensuring you have everything you need to make your stay unforgettable."
    },
    {
      "city": "Marseille",
      "country": "France",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/marseille.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-marseille-154256989765425:Square?wid=768&fit=constrain",
      "headline": "Discover Marseille Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Marseille, France your way! Explore restaurants, local attractions and things to do in your favorite Marseille, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "San Francisco",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/san-francisco.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-GettyImages-1133891066-359793688600498:Square?wid=768&fit=constrain",
      "headline": "San Francisco Adventures Await with Marriott Bonvoy Stays",
      "description": "Stay at a Marriott Bonvoy Hotel in San Francisco, CA, and enjoy easy access to Fisherman’s Wharf, the iconic Golden Gate Bridge, and endless adventures."
    },
    {
      "city": "Liverpool",
      "country": "United Kingdom",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/liverpool.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-liverpool-173453852530936:Square?wid=768&fit=constrain",
      "headline": "Liverpool: Historic Waterfront, Beatles Beats, Vibrant City Streets",
      "description": "Liverpool is a city of great tradition and modernity, with a rich history of culture and commerce. The city's waterfront is a designated UNESCO World Heritage Site, home to such iconic landmarks as the Royal Albert Dock and Liverpool Cathedral. Visit the famous Cavern Club, where the Beatles played, or explore the city's maritime history at the Merseyside Maritime Museum. Our hotels in Liverpool are the perfect base from which to explore the city's vibrant neighborhoods and popular attractions."
    },
    {
      "city": "Turin",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "50",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/turin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-turin-173453066862739:Square?wid=768&fit=constrain",
      "headline": "Turin Treasures: Markets, Chocolate, and Baroque City Magic",
      "description": "Immerse yourself in the local culture and traditions at the Shiny Market of Porta Palazzo, the largest open-air market in Europe, or treat yourself to some of the city’s famous chocolate at one of the many artisan shops. Many of our hotels offer amenities like free Wi-Fi, fitness centers, and on-site dining to help you make the most of your stay. Whether you’re visiting for business or pleasure, Turin’s mix of baroque architecture, modern art, and cutting-edge technology promises a memorable and enriching stay."
    },
    {
      "city": "Helsinki",
      "country": "Finland",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "25",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/helsinki.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fin-helsinki-173453926085925:Square?wid=768&fit=constrain",
      "headline": "Discover Artistic Helsinki: Walkable Wonders, Museums, and Modern Comfort",
      "description": "You can also spend the day at the Design Museum or Ateneum Art Museum, where you can explore Finland’s rich artistic heritage. The city’s public transportation is efficient and its streets are walkable, so you can easily discover hidden gems and popular spots. Whether you’re here for business or leisure, our properties offer free Wi-Fi, fitness centers and complimentary breakfast to help you make the most of your time in Helsinki."
    },
    {
      "city": "Boston",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "25",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/boston.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/sailing-boats-charles-river-downtown-boston:Square?wid=768&fit=constrain",
      "headline": "Boston Bites, Sights, and Scenic Nights Await You",
      "description": "Boston’s culinary scene is also not to be missed. Savor everything from fresh seafood at the Quincy Market to world-class dining in the South End. With easy access to the city’s public transportation, you can effortlessly navigate to the Harvard University campus, explore the museums of the Back Bay, or enjoy the scenic views along the Charles River. No matter your interests, Boston’s diverse neighborhoods and attractions promise an unforgettable experience."
    },
    {
      "city": "Frankfurt am Main",
      "country": "Germany",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/frankfurt.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-frankfurt-1734538639117-1:Square?wid=768&fit=constrain",
      "headline": "Frankfurt Uncovered: Breweries, Historic Squares, Forest Escapes Await",
      "description": "Uncover the charm of Frankfurt’s neighborhoods. Trendy Sachsenhausen is home to craft breweries and traditional German pubs. The historic Römerberg square is perfect for a leisurely stroll or a visit to the town hall. Nature lovers can escape to the Frankfurt City Forest or one of the city’s many parks. Our hotels are strategically located to give you easy access to all these attractions and more."
    },
    {
      "city": "Cuenca",
      "country": "Ecuador",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/cuenca.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ecu-cuenca-173453916145818:Square?wid=768&fit=constrain",
      "headline": "Cuenca Getaways: Cloud Forest Adventures, Culture, and Relaxing Stays",
      "description": "For those who want to explore the natural beauty of the area, Cuenca is the perfect starting point for a variety of day trips. The nearby Cajas National Park offers a range of outdoor activities, including hiking, bird watching, and exploring the Andean cloud forest. After a day of adventure, return to one of our hotels in Cuenca to relax and recharge with modern amenities and locally inspired cuisine. Whether you’re planning a weekend escape or a longer stay, Cuenca’s mix of history, culture, and natural beauty is sure to create a memorable experience."
    },
    {
      "city": "Wroclaw",
      "country": "Poland",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/wroclaw.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pol-wroclaw-173454131893824:Square?wid=768&fit=constrain",
      "headline": "Discover Wroclaw Your Way With Marriott Bonvoy Adventures",
      "description": "Visit Wroclaw, Poland your way! Explore restaurants, local attractions and things to do in your favorite Wroclaw, Poland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Memphis",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/memphis.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/downtown-memphis-aerial-skyline:Square?wid=768&fit=constrain",
      "headline": "Discover Memphis Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Memphis, TN your way! Explore restaurants, local attractions and things to do in your favorite Memphis, TN neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Stuttgart",
      "country": "Germany",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/stuttgart.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-stuttgart-173454035853014:Square?wid=768&fit=constrain",
      "headline": "Stuttgart: Where World-Class Cars Meet Culture, Vines, and Charm",
      "description": "Stuttgart, a city synonymous with automotive excellence and a rich cultural tapestry, is a masterful blend of industrial might and artistic charm. As the home to the headquarters of major car manufacturers, the city is a living museum of automotive engineering, with the Porsche and Mercedes-Benz museums offering a captivating look into the past, present, and future of the industry. Beyond the industrial landscape, Stuttgart is a haven for art, culture, and history enthusiasts, with attractions like the State Gallery and the Old Castle adding an air of sophistication. The Wilhelma Zoo and Botanical Garden, along with the vineyards of the surrounding hills, offer a serene escape, making Stuttgart a destination that caters to all tastes."
    },
    {
      "city": "Glasgow",
      "country": "United Kingdom",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/glasgow.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-glasgow-173453761787895:Square?wid=768&fit=constrain",
      "headline": "Glasgow Your Way: Eat, Explore, and Stay with Marriott",
      "description": "Visit Glasgow, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Glasgow, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Beirut",
      "country": "Lebanon",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/beirut.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-lbn-beirut-1734535307137-5:Square?wid=768&fit=constrain",
      "headline": "Experience Beirut Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Beirut, Lebanon your way! Explore restaurants, local attractions and things to do in your favorite Beirut, Lebanon neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bucharest",
      "country": "Romania",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bucharest.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-rou-bucharest-173453502708534:Square?wid=768&fit=constrain",
      "headline": "Discover Bucharest Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bucharest, Romania your way! Explore restaurants, local attractions and things to do in your favorite Bucharest, Romania neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hamburg",
      "country": "Germany",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/hamburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-hamburg-173454132906462:Square?wid=768&fit=constrain",
      "headline": "Discover Hamburg Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hamburg, Germany your way! Explore restaurants, local attractions and things to do in your favorite Hamburg, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sharjah",
      "country": "United Arab Emirates",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/sharjah.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-tx-grapevine-173453848689180:Square?wid=768&fit=constrain",
      "headline": "Discover Sharjah Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Sharjah, United Arab Emirates your way! Explore restaurants, local attractions and things to do in your favorite Sharjah, United Arab Emirates neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Minsk",
      "country": "Belarus",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/minsk.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-blr-minsk-145720570254087:Square?wid=768&fit=constrain",
      "headline": "Discover Minsk Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Minsk, Belarus your way! Explore restaurants, local attractions and things to do in your favorite Minsk, Belarus neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Budapest",
      "country": "Hungary",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/budapest.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-hun-budapest-173454024873448:Square?wid=768&fit=constrain",
      "headline": "Discover Budapest Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Budapest, Hungary your way! Explore restaurants, local attractions and things to do in your favorite Budapest, Hungary neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Warsaw",
      "country": "Poland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/warsaw.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pol-warsaw-173453759267713:Square?wid=768&fit=constrain",
      "headline": "Warsaw Wonders: Culture, Cuisine, and Comfort Await You",
      "description": "No trip to Warsaw is complete without taking in the city’s rich cultural offerings, from the world-class Chopin Museum to the vast collection of art and artifacts at the National Museum. And with dining options ranging from traditional Polish cuisine to international flavors, you’ll find something to satisfy every craving. Our hotels offer a variety of amenities to make your stay as comfortable as possible, including complimentary Wi-Fi, fitness centers, and easy access to major transportation hubs. Whether you’re here for business or leisure, our hotels are designed to make your stay in this fascinating city even more enjoyable."
    },
    {
      "city": "Vienna",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/vienna.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-vienna-173453913119285:Square?wid=768&fit=constrain",
      "headline": "Vienna: Imperial Splendor Meets Cutting-Edge Arts and Culture",
      "description": "Vienna, a city where the grandeur of baroque architecture meets the pulse of innovative art and culture, is a masterful blend of history and modernity. As the epicenter of classical music, it boasts the prestigious Vienna State Opera and the renowned Vienna Philharmonic, delivering world-class performances throughout the year. The city's imperial legacy is on display in its opulent palaces, from Schönbrunn to the Hofburg, offering a window into the lavish past of the Habsburg dynasty. Whether you're meandering through the verdant gardens of the Belvedere Palace or savoring a coffee in a traditional café, Vienna's allure and sophistication will enchant you at every step."
    },
    {
      "city": "Melbourne",
      "country": "Australia",
      "Beach": "75.0",
      "Culinary": "85",
      "Golf": "80",
      "Ski": "50",
      "Spa": "60",
      "Culture": "75",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/melbourne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-melmd-regent-theatre-15294:Square?wid=768&fit=constrain",
      "headline": "Discover Melbourne Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Melbourne, Australia your way! Explore restaurants, local attractions and things to do in your favorite Melbourne, Australia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Alexandria",
      "country": "Egypt",
      "Beach": "70.0",
      "Culinary": "50",
      "Golf": "10",
      "Ski": "0",
      "Spa": "20",
      "Culture": "75",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/alexandria.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-egy-alexandria-173452977459227:Square?wid=768&fit=constrain",
      "headline": "Discover Alexandria Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Alexandria, Egypt your way! Explore restaurants, local attractions and things to do in your favorite Alexandria, Egypt neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kolkata",
      "country": "India",
      "Beach": "20.0",
      "Culinary": "70",
      "Golf": "20",
      "Ski": "0",
      "Spa": "30",
      "Culture": "80",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/kolkata.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-kolkata-173453644661676:Square?wid=768&fit=constrain",
      "headline": "Discover Kolkata Your Way with Marriott Bonvoy Stays",
      "description": "Visit Kolkata, India your way! Explore restaurants, local attractions and things to do in your favorite Kolkata, India neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Los Angeles",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "85",
      "Golf": "80",
      "Ski": "50",
      "Spa": "70",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/los-angeles.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/griffith-park-los-angeles-california:Square?wid=768&fit=constrain",
      "headline": "Discover Baltimore Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Baltimore, MD your way! Explore restaurants, local attractions and more in your favorite Los Angeles neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Berlin",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "80",
      "Golf": "40",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/berlin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-berlin-173453772557748:Square?wid=768&fit=constrain",
      "headline": "Discover Berlin Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Berlin, Germany your way! Explore restaurants, local attractions and things to do in your favorite Berlin, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Barcelona",
      "country": "Spain",
      "Beach": "90.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/barcelona.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-sagrat-cor-temple92601-1669848202478-2:Square?wid=768&fit=constrain",
      "headline": "Discover Barcelona Your Way with Marriott Bonvoy Stays",
      "description": "Visit Barcelona, Spain your way! Explore restaurants, local attractions and things to do in your favorite Barcelona, Spain neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Philadelphia",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/philadelphia.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/river-skyline-philadelphia-pennsylvania:Square?wid=768&fit=constrain",
      "headline": "Discover Philadelphia Your Way with Marriott Bonvoy Stays",
      "description": "Visit Philadelphia, PA your way! Explore restaurants, local attractions and things to do in your favorite Philadelphia, PA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Stockholm",
      "country": "Sweden",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/stockholm.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-swe-stockholm-173453462024427:Square?wid=768&fit=constrain",
      "headline": "Stockholm Stays: Nordic Flavors, Scenic Walks, Effortless Connections",
      "description": "Dining in Stockholm is a culinary journey through Nordic flavors, with a range of Michelin-starred restaurants and cozy local eateries just steps away from many of our properties. For a relaxing day, head to one of the city’s beautiful parks, such as Djurgården, or take a stroll along the waterfront promenades. Business travelers will appreciate the modern conference facilities and free Wi-Fi, while leisure guests can enjoy complimentary breakfast and fitness centers. With easy access to the central train station and major airports, your stay in Stockholm will be as smooth and enjoyable as the city itself."
    },
    {
      "city": "Buenos Aires",
      "country": "Argentina",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/buenos-aires.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-centro-cultural-recoleta-485852901431222:Square?wid=768&fit=constrain",
      "headline": "Experience Buenos Aires Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Buenos Aires, Argentina your way! Explore restaurants, local attractions and things to do in your favorite Buenos Aires, Argentina neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Quito",
      "country": "Ecuador",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/quito.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ecu-quito-173453637630687:Square?wid=768&fit=constrain",
      "headline": "Discover Quito Your Way with Marriott Bonvoy Stays",
      "description": "Visit Quito, Ecuador your way! Explore restaurants, local attractions and things to do in your favorite Quito, Ecuador neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Osaka",
      "country": "Japan",
      "Beach": "25.0",
      "Culinary": "85",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/osaka.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/rz-osarz-osaka-shinsaibashi-23169:Square?wid=768&fit=constrain",
      "headline": "Discover Osaka Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Osaka, Japan your way! Explore restaurants, local attractions and things to do in your favorite Osaka, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Jaipur",
      "country": "India",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/jaipur.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-jaipur-173454140428245:Square?wid=768&fit=constrain",
      "headline": "Jaipur: Timeless Heritage, Modern Comforts, Unforgettable Stays",
      "description": "Savor authentic Rajasthani cuisine, visit the intricate Jantar Mantar observatory, or take a leisurely stroll through the serene gardens of the City Palace. Many of our hotels feature amenities like free Wi-Fi, fitness centers, and complimentary breakfast, ensuring a comfortable and convenient stay. Whether you are here for business or leisure, Jaipur’s rich cultural heritage and modern conveniences make it a destination that promises to captivate and delight every traveler."
    },
    {
      "city": "Chicago",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "85",
      "Golf": "75",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/chicago.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1065188752:Square?wid=768&fit=constrain",
      "headline": "Discover Chicago Your Way With Marriott Bonvoy Hotels",
      "description": "Visit Chicago, IL your way! Explore restaurants, local attractions and more in your favorite Chicago neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Dublin",
      "country": "Ireland",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/dublin.mi",
      "imageUrl": "https://cache.marriott.com/marriottassets/icons/mrw_default_profile_placeholder1.png",
      "headline": "Dublin Delights: Music, River Views & Unforgettable City Stays",
      "description": "Stroll the colorful streets of Temple Bar, where the sound of Irish music spills from the pubs, or take a leisurely walk along the River Liffey, soaking in the views and local life. Many of our hotels offer amenities like free Wi-Fi, on-site dining and fitness centers, ensuring your stay is as comfortable as it is memorable. Whether you’re in town for a business meeting or a leisurely getaway, Dublin’s diverse offerings, from historic castles to modern shopping districts, promise an unforgettable experience."
    },
    {
      "city": "Brussels",
      "country": "Belgium",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/brussels.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bel-brussels-1734540377219-8:Square?wid=768&fit=constrain",
      "headline": "Discover Brussels Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Brussels, Belgium your way! Explore restaurants, local attractions and things to do in your favorite Brussels, Belgium neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Islamabad",
      "country": "Pakistan",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/islamabad.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pak-islamabad-173453712035585:Square?wid=768&fit=constrain",
      "headline": "Discover Islamabad Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Islamabad, Pakistan your way! Explore restaurants, local attractions and things to do in your favorite Islamabad, Pakistan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Rotterdam",
      "country": "Netherlands",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/rotterdam.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-nld-rotterdam-247789534125239:Square?wid=768&fit=constrain",
      "headline": "Discover Rotterdam: Neighborhood Adventures Await Marriott Bonvoy Guests",
      "description": "Visit Rotterdam, Netherlands your way! Explore restaurants, local attractions and things to do in your favorite Rotterdam, Netherlands neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Manhattan",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "50",
      "Culture": "90",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/manhattan-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-manhattan-beach-173453721276755:Square?wid=768&fit=constrain",
      "headline": "Manhattan Beach: Where Laid-Back Coastal Charm Meets Urban Sophistication",
      "description": "Manhattan Beach is a charming coastal town that effortlessly marries the allure of a small beach community with the elegance of a thriving coastal city. Its wide, sandy beaches and lively boardwalk attract beachgoers and water sports enthusiasts alike. The Strand, a picturesque bike path, offers stunning ocean vistas and is perfect for a leisurely stroll or invigorating bike ride. Just moments from the vibrant downtown area, you'll find an array of high-end boutiques, art galleries, and gourmet dining options, catering to those in search of both tranquility and urban energy."
    },
    {
      "city": "Madurai",
      "country": "India",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/madurai.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-madurai-382257835347794:Square?wid=768&fit=constrain",
      "headline": "Discover Madurai Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Madurai, India your way! Explore restaurants, local attractions and things to do in your favorite Madurai, India neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kyoto",
      "country": "Japan",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "50",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kyoto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/50464712-kyoto_destination_fushimi-inari-1:Square?wid=768&fit=constrain",
      "headline": "Discover Kyoto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Kyoto, Japan your way! Explore restaurants, local attractions and things to do in your favorite Kyoto, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kathmandu",
      "country": "Nepal",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kathmandu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-npl-kathmandu-173452956339419:Square?wid=768&fit=constrain",
      "headline": "Discover Kathmandu Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Kathmandu, Nepal your way! Explore restaurants, local attractions and things to do in your favorite Kathmandu, Nepal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Agra",
      "country": "India",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "90",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/agra.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-agra-173447132490696:Square?wid=768&fit=constrain",
      "headline": "Agra: Timeless Taj, Majestic Forts, Echoes of Mughal Grandeur",
      "description": "Agra, a city steeped in history and culture, is an essential stop for any traveler seeking to experience the grandeur of India’s past. The city is crowned by the majestic Taj Mahal, a UNESCO World Heritage site and one of the most recognizable buildings in the world, which stands as a timeless symbol of love and architectural brilliance. Beyond the Taj, Agra is home to other significant landmarks such as the Agra Fort, a massive red sandstone fortress that once served as the main residence of the Mughal emperors, and the Fatehpur Sikri, an abandoned city that offers a glimpse into the opulence of the 16th century. Whether you’re a history buff, a culture enthusiast, or simply looking to capture the essence of a bygone era, Agra’s rich tapestry of sites and stories will leave you in awe."
    },
    {
      "city": "Milan",
      "country": "Italy",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/milan.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-907949732-milan-italy-23312:Square?wid=768&fit=constrain",
      "headline": "Discover Milan Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Milan, Italy your way! Explore restaurants, local attractions and things to do in your favorite Milan, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Algiers",
      "country": "Algeria",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/algiers.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-dza-algiers-173453522179792:Square?wid=768&fit=constrain",
      "headline": "Discover Algiers Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Algiers, Algeria your way! Explore restaurants, local attractions and things to do in your favorite Algiers, Algeria neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Rome",
      "country": "Italy",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "100",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/rome.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-colosseum-amphitheatre-567863631375111:Square?wid=768&fit=constrain",
      "headline": "Discover Rome Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Rome, Italy your way! Explore restaurants, local attractions and things to do in your favorite Rome, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paris",
      "country": "France",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "100",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/paris.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arc-de-triomphe-paris-634207441403522:Square?wid=768&fit=constrain",
      "headline": "Discover Paris Your Way with Marriott Bonvoy Stays",
      "description": "Visit Paris, France your way! Explore restaurants, local attractions and more in your favorite Paris neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "La Paz",
      "country": "Bolivia",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/la-paz.mi",
      "imageUrl": "https://cache.marriott.com/marriottassets/icons/mrw_default_profile_placeholder1.png",
      "headline": "Discover La Paz, Mexico: Your Neighborhood Adventure with Marriott Bonvoy",
      "description": "Visit La Paz, Mexico your way! Explore restaurants, local attractions and things to do in your favorite La Paz, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Tashkent",
      "country": "Uzbekistan",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/tashkent.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-uzb-tashkent-173453704797966:Square?wid=768&fit=constrain",
      "headline": "Stay Central in Tashkent: Metro Magic, Culture, and Comfort",
      "description": "No visit to Tashkent is complete without a visit to the Tashkent Metro, with its unique and ornate stations, or the Amir Timur Square, a symbol of the city’s growth and resilience. Our hotels are strategically located to give you easy access to these and other top attractions, including the Tashkent TV Tower and the State Museum of Arts. With a range of amenities such as free Wi-Fi, fitness centers, and complimentary breakfast, our properties ensure that you have everything you need to make the most of your time in this dynamic and enchanting city."
    },
    {
      "city": "Dresden",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/dresden.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-dresden-173454133902928:Square?wid=768&fit=constrain",
      "headline": "Discover Dresden: Neighborhood Gems Await Marriott Bonvoy Guests",
      "description": "Visit Dresden, Germany your way! Explore restaurants, local attractions and things to do in your favorite Dresden, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bremen",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/bremen.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-bremen-173454104199352:Square?wid=768&fit=constrain",
      "headline": "Bremen Getaway: Historic Charm, Global Flavors, and Relaxing Stays",
      "description": "From the charming Schnoor district to the peaceful Bremen Gardens, you will find an array of attractions to explore in Bremen. The city’s culinary landscape is equally varied, with traditional German taverns serving local delights and international eateries offering a global menu. For those seeking relaxation, our hotels boast onsite spa facilities and fitness centers, ensuring you can unwind after a day of exploration. Whether for business or leisure, our hotels' strategic locations provide convenient access to the city’s main sights, shopping areas, and business hubs, streamlining your stay in Bremen to be both delightful and productive."
    },
    {
      "city": "Vilnius",
      "country": "Lithuania",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/vilnius.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ltu-vilnius-956769673772786:Square?wid=768&fit=constrain",
      "headline": "Discover Vilnius Your Way with Marriott Bonvoy Stays",
      "description": "Visit Vilnius, Lithuania your way! Explore restaurants, local attractions and things to do in your favorite Vilnius, Lithuania neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Shanghai",
      "country": "China",
      "Beach": "10.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/shanghai.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-Destination-Marketing-SH-476057048542497:Square?wid=768&fit=constrain",
      "headline": "Discover Shanghai Your Way with Marriott Bonvoy Stays",
      "description": "Visit Shanghai, China your way! Explore restaurants, local attractions and things to do in your favorite Shanghai, China neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Beijing",
      "country": "China",
      "Beach": "1.0",
      "Culinary": "70",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/beijing.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-chn-beijing-1734536170003-0:Square?wid=768&fit=constrain",
      "headline": "Discover Beijing Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Beijing, China your way! Explore restaurants, local attractions and things to do in your favorite Beijing, China neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sao Paulo",
      "country": "Brazil",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/sao-paulo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ibirapuera-neighborhood-649944870849732:Square?wid=768&fit=constrain",
      "headline": "Sao Paulo Getaway: Art, Green Escapes, and Urban Style",
      "description": "Discover the vibrant arts and culture scene of Sao Paulo at the Pinacoteca or the Museu de Arte de Sao Paulo, or take a stroll through the greenery of Ibirapuera Park, an urban oasis. Many of our hotels offer amenities like complimentary Wi-Fi, fitness centers, and on-site dining, ensuring your stay is comfortable and convenient. From the historic downtown to the trendy Vila Madalena, our hotels provide the perfect gateway to experience the city’s unique blend of tradition and innovation."
    },
    {
      "city": "Seoul",
      "country": "Korea, Republic of",
      "Beach": "25.0",
      "Culinary": "80",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "70",
      "pageUrl": "https://www.marriott.com/en/destinations/seoul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-656494262-22627:Square?wid=768&fit=constrain",
      "headline": "Discover Seoul Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Seoul, South Korea your way! Explore restaurants, local attractions and things to do in your favorite Seoul, South Korea neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Tokyo",
      "country": "Japan",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "90",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/tokyo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/al-tyoal-asakusa-32531:Square?wid=768&fit=constrain",
      "headline": "Tokyo Tastemakers: Culture, Cuisine, and City Nights Await",
      "description": "Immerse yourself in Tokyo’s rich culture and Michelin-starred culinary scene. From the sushi bars of Tsukiji Outer Market to the trendy neighborhoods of Harajuku and Ginza, there’s something for every taste. Our hotels are the perfect starting point for your adventures, with many offering complimentary breakfast and evening events that capture the spirit of the city."
    },
    {
      "city": "Cairo",
      "country": "Egypt",
      "Beach": "25.0",
      "Culinary": "60",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/cairo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tahrir-square-views40075-167025883497675:Square?wid=768&fit=constrain",
      "headline": "Discover Cairo Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Cairo, Egypt your way! Explore restaurants, local attractions and things to do in your favorite Cairo, Egypt neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "London",
      "country": "United Kingdom",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "90",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/london.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-skyline-w-twr-brdg94263-167001018629978:Square?wid=768&fit=constrain",
      "headline": "Discover London Your Way with Marriott Bonvoy Hotels",
      "description": "Visit London, United Kingdom your way! Explore restaurants, local attractions and more in your favorite London neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New York City",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "85",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/nyc.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lower-manhattan-skyline-new-york-city-new-york:Square?wid=768&fit=constrain",
      "headline": "Experience New York City Your Way With Marriott Bonvoy",
      "description": "Visit New York City, NY your way! Explore restaurants, local attractions and more in your favorite New York City neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Rio de Janeiro",
      "country": "Brazil",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/rio-de-janeiro.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bra-rio-de-janeiro-173453854225540:Square?wid=768&fit=constrain",
      "headline": "Discover Rio de Janeiro Your Way with Marriott Bonvoy",
      "description": "Visit Rio de Janeiro, Brazil your way! Explore restaurants, local attractions and things to do in your favorite Rio de Janeiro, Brazil neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Jodhpur",
      "country": "India",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/jodhpur.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-jodhpur-173453755257380:Square?wid=768&fit=constrain",
      "headline": "Explore Jodhpur Your Way with Marriott Bonvoy Stays",
      "description": "Visit Jodhpur, India your way! Explore restaurants, local attractions and things to do in your favorite Jodhpur, India neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cartagena",
      "country": "Colombia",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/cartagena.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-col-cartagena-173453849689140:Square?wid=768&fit=constrain",
      "headline": "Discover Cartagena Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Cartagena, Colombia your way! Explore restaurants, local attractions and things to do in your favorite Cartagena, Colombia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Naples",
      "country": "Italy",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/naples-florida.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/beach-sunset-naples-florida:Square?wid=768&fit=constrain",
      "headline": "Discover Naples, FL Your Way with Marriott Bonvoy",
      "description": "Visit Naples, FL your way! Explore restaurants, local attractions and things to do in your favorite Naples, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Genoa",
      "country": "Italy",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/genoa.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-genoa-173453074904827:Square?wid=768&fit=constrain",
      "headline": "Discover Genoa Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Genoa, Italy your way! Explore restaurants, local attractions and things to do in your favorite Genoa, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Baltimore",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/baltimore.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/harbor-boats-skyline-baltimore-maryland:Square?wid=768&fit=constrain",
      "headline": "Discover Baltimore Your Way with Marriott Bonvoy Stays",
      "description": "Visit Baltimore, MD your way! Explore restaurants, local attractions and things to do in your favorite Baltimore, MD neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Poznan",
      "country": "Poland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/poznan.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pol-poznan-173453810139832:Square?wid=768&fit=constrain",
      "headline": "Poznan: Where Urban Style Meets Nature and Culture",
      "description": "If you're looking to venture beyond the city center, Poznan has a wealth of cultural and natural attractions to explore. The Poznan Zoo is one of the largest in Europe and is home to a wide variety of species, as well as an impressive botanical garden. The University of Poznan and the botanical gardens at the Institute of Botany are perfect for a peaceful afternoon, while the historic Old Brewery and the modern shopping districts cater to all tastes. Whether you're in Poznan for business or leisure, our hotels provide the perfect base with amenities like free Wi-Fi, fitness centers, and complimentary breakfast, ensuring your stay is as enjoyable as the city itself."
    },
    {
      "city": "Manchester",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/chester.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-chester-173453914624154:Square?wid=768&fit=constrain",
      "headline": "Discover Chester Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Chester, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Chester, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Tunis",
      "country": "Tunisia",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/tunis.mi",
      "imageUrl": "https://cache.marriott.com/marriottassets/icons/mrw_default_profile_placeholder1.png",
      "headline": "Discover Tunis Your Way with Marriott Bonvoy",
      "description": "Visit Tunis, Tunisia your way! Explore restaurants, local attractions and things to do in your favorite Tunis, Tunisia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Athens",
      "country": "Greece",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/athens.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ga-athens-1734538306865-3:Square?wid=768&fit=constrain",
      "headline": "Discover Athens, GA Your Way with Marriott Bonvoy Stays",
      "description": "Visit Athens, GA your way! Explore restaurants, local attractions and things to do in your favorite Athens, GA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Zagreb",
      "country": "Croatia",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/zagreb.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-hrv-zagreb-173453507246625:Square?wid=768&fit=constrain",
      "headline": "Zagreb: Artful Escapes, Local Flavors, and Effortless City Stays",
      "description": "For the art aficionado, Zagreb is a treasure trove with its galleries and museums, such as the Museum of Broken Relationships and the Zagreb City Museum, each offering a unique perspective on the city’s rich cultural heritage. To get a true taste of local life, a visit to the Dolac Market is a must, where you can sample fresh produce and traditional Croatian delicacies. Our hotels in Zagreb come with amenities like complimentary Wi-Fi, fitness centers, and breakfast options, allowing you to recharge and plan your next adventure with ease. Whether you’re here for a business conference or a leisurely weekend, our hotels are strategically located to provide easy access to all the city has to offer."
    },
    {
      "city": "Amsterdam",
      "country": "Netherlands",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/amsterdam.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-1313361488-amsterdam-hero-10682:Square?wid=768&fit=constrain",
      "headline": "Discover Amsterdam Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Amsterdam, Netherlands your way! Explore restaurants, local attractions and things to do in your favorite Amsterdam, Netherlands neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Seattle",
      "country": "United States",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "50",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/seattle.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-Seattle-Destination-844280376200442:Square?wid=768&fit=constrain",
      "headline": "Discover Seattle Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Seattle, WA your way! Explore restaurants, local attractions and things to do in your favorite Seattle, WA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Baku",
      "country": "Azerbaijan",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/baku.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aze-baku-173453292196930:Square?wid=768&fit=constrain",
      "headline": "Discover Baku Your Way: Eat, Explore, Stay with Marriott",
      "description": "Visit Baku, Azerbaijan your way! Explore restaurants, local attractions and things to do in your favorite Baku, Azerbaijan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Amritsar",
      "country": "India",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/amritsar.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-amritsar-173453470366054:Square?wid=768&fit=constrain",
      "headline": "Discover Amritsar Your Way with Marriott Bonvoy Stays",
      "description": "Visit Amritsar, India your way! Explore restaurants, local attractions and things to do in your favorite Amritsar, India neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Tbilisi",
      "country": "Georgia",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/tbilisi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-bonvoy-546242868-13442-50842:Square?wid=768&fit=constrain",
      "headline": "Discover Tbilisi Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Tbilisi, Georgia your way! Explore restaurants, local attractions and things to do in your favorite Tbilisi, Georgia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Prague",
      "country": "Czech Republic",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/prague.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-cze-prague-801029132422535:Square?wid=768&fit=constrain",
      "headline": "Discover Prague Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Prague, Czech Republic your way! Explore restaurants, local attractions and things to do in your favorite Prague, Czech Republic neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Copenhagen",
      "country": "Denmark",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/copenhagen.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-dnk-copenhagen-173447135499986:Square?wid=768&fit=constrain",
      "headline": "Discover Copenhagen’s Best Neighborhoods with Marriott Bonvoy Stays",
      "description": "Visit Copenhagen, Denmark your way! Explore restaurants, local attractions and things to do in your favorite Copenhagen, Denmark neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sofia",
      "country": "Bulgaria",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/sofia.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bgr-sofia-173453614491233:Square?wid=768&fit=constrain",
      "headline": "Discover Sofia Your Way: Neighborhood Adventures with Marriott Bonvoy",
      "description": "Visit Sofia, Bulgaria your way! Explore restaurants, local attractions and things to do in your favorite Sofia, Bulgaria neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Yerevan",
      "country": "Armenia",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/yerevan.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arm-yerevan-173454130387815:Square?wid=768&fit=constrain",
      "headline": "Discover Yerevan Your Way with Marriott Bonvoy Stays",
      "description": "Visit Yerevan, Armenia your way! Explore restaurants, local attractions and things to do in your favorite Yerevan, Armenia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Munich",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "80",
      "Golf": "50",
      "Ski": "0",
      "Spa": "0",
      "Culture": "80",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/munich.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-munich-173453527700652:Square?wid=768&fit=constrain",
      "headline": "Explore Munich Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Munich, Germany your way! Explore restaurants, local attractions and things to do in your favorite Munich, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Leipzig",
      "country": "Germany",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/leipzig.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-leipzig-343406197308221:Square?wid=768&fit=constrain",
      "headline": "Discover Leipzig Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Leipzig, Germany your way! Explore restaurants, local attractions and things to do in your favorite Leipzig, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Toulouse",
      "country": "France",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/toulouse.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-toulouse-1734539156446-9:Square?wid=768&fit=constrain",
      "headline": "Discover Toulouse Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Toulouse, France your way! Explore restaurants, local attractions and things to do in your favorite Toulouse, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cusco",
      "country": "Peru",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/cusco.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-per-cusco-173453073904499:Square?wid=768&fit=constrain",
      "headline": "Discover Cusco Your Way with Marriott Bonvoy Stays",
      "description": "Visit Cusco, Peru your way! Explore restaurants, local attractions and things to do in your favorite Cusco, Peru neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Zurich",
      "country": "Switzerland",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/zurich.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-1267692130-zurich-hero-11029:Square?wid=768&fit=constrain",
      "headline": "Discover Zurich Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Zurich, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Zurich, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Utrecht",
      "country": "Netherlands",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/utrecht.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/ox-amsou-moxy-bike-2-33789:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Utrecht: Sustainable Innovation Meets Historic Canals and Culture",
      "description": "Utrecht is more than just a city with a rich history and a lot of culture. It is a modern city with a strong focus on sustainability and innovation. Utrecht is home to the largest university in the Netherlands and has a growing tech and business sector. This makes the city attractive for visitors and professionals. Whether you are in Utrecht for business or leisure, our hotels offer a great place to stay. Most of our hotels offer free Wi-Fi, fitness center and are close to the city’s main attractions. Visit the Oudegracht, the Rijksmuseum Volkenkunde or take a stroll through the city’s charming streets."
    },
    {
      "city": "Yogyakarta",
      "country": "Indonesia",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/yogyakarta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-idn-yogyakarta-173453396038968:Square?wid=768&fit=constrain",
      "headline": "Discover Yogyakarta Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Yogyakarta, Indonesia your way! Explore restaurants, local attractions and things to do in your favorite Yogyakarta, Indonesia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cardiff",
      "country": "United Kingdom",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/cardiff.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-cardiff-173454022864117:Square?wid=768&fit=constrain",
      "headline": "Experience Cardiff Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Cardiff, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Cardiff, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Florence",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/florence.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-florence-991758286415192:Square?wid=768&fit=constrain",
      "headline": "Discover Florence Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Florence, Italy your way! Explore restaurants, local attractions and things to do in your favorite Florence, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New Delhi",
      "country": "India",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/new-delhi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-new-delhi-173453713038356:Square?wid=768&fit=constrain",
      "headline": "Discover New Delhi Your Way with Marriott Bonvoy Hotels",
      "description": "Visit New Delhi, India your way! Explore restaurants, local attractions and things to do in your favorite New Delhi, India neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bristol",
      "country": "United Kingdom",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/bristol.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-bristol-1734535272004-7:Square?wid=768&fit=constrain",
      "headline": "Bristol: Where Historic Harbors, Street Art and Innovation Collide",
      "description": "Bristol, a city with a rich history and a contemporary vibe, is a place where creativity and heritage converge. Internationally recognized for its street art, which includes the enigmatic works of Banksy, Bristol's walls are a canvas of vibrant murals and graffiti, each telling a story of the city's journey. From the historic harborside, now a hub of chic bars, eateries, and shops, to the iconic Clifton Suspension Bridge, there's a wealth of sights to explore. The city's dedication to sustainability and innovation is evident in its green spaces, eco-friendly projects, and burgeoning tech sector, making it a compelling choice for all types of travelers."
    },
    {
      "city": "Gdansk",
      "country": "Poland",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/gdansk.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pol-gdansk-173454121993391:Square?wid=768&fit=constrain",
      "headline": "Discover Gdansk Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Gdansk, Poland your way! Explore restaurants, local attractions and things to do in your favorite Gdansk, Poland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Halifax",
      "country": "Canada",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/halifax.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/old-town-clock-halifax-nova-scotia-canada:Square?wid=768&fit=constrain",
      "headline": "Halifax: Waterfront Wonders, Arts, and Adventure at Your Doorstep",
      "description": "Halifax's scenic beauty is yours to explore, from the picturesque waterfront to the city's vibrant arts scene. Stroll along the boardwalk, visit the Seaport Farmers' Market, or take a ferry to Dartmouth. The city's cultural institutions, including the Neptune Theatre and the Art Gallery of Nova Scotia, offer plenty of opportunities for enrichment. Many of our hotels are located near major attractions and offer easy access to the city's dining and shopping districts, making your stay in Halifax both convenient and memorable."
    },
    {
      "city": "Minneapolis",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "25",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/minneapolis.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/hamburger-fries-cheeese-burger-cyLHRCY.1063398:Square?wid=768&fit=constrain",
      "headline": "Minneapolis: Where Urban Energy Meets Lakeside Calm",
      "description": "Minneapolis is a city that effortlessly combines the thrill of urban living with the serenity of nature. Its lively arts scene is a testament to its cultural richness, with renowned institutions like the Walker Art Center and the Minneapolis Institute of Art waiting to captivate you with their diverse exhibits. For those who love the outdoors, the Chain of Lakes and the expansive Minneapolis Sculpture Garden offer scenic beauty and ample space for leisurely strolls. The city's dedication to sustainability and pedestrian-friendly spaces ensures that exploring is a delight, with bike paths and a comprehensive public transit system to take you to all the must-see spots."
    },
    {
      "city": "Bologna",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/bologna.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-bologna-173453460515988:Square?wid=768&fit=constrain",
      "headline": "Discover Bologna Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bologna, Italy your way! Explore restaurants, local attractions and things to do in your favorite Bologna, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Tallinn",
      "country": "Estonia",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "80",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/tallinn.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-est-tallinn-173454123036841:Square?wid=768&fit=constrain",
      "headline": "Discover Tallinn Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Tallinn, Estonia your way! Explore restaurants, local attractions and things to do in your favorite Tallinn, Estonia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New Orleans",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/new-orleans.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-NOLA-DESTINATION-260136935781775:Square?wid=768&fit=constrain",
      "headline": "Discover New Orleans Your Way with Marriott Bonvoy Stays",
      "description": "Visit New Orleans, LA your way! Explore restaurants, local attractions and more in your favorite New Orleans neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Brno",
      "country": "Czech Republic",
      "Beach": "1.0",
      "Culinary": "25",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/brno.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-cze-brno-260194747338283:Square?wid=768&fit=constrain",
      "headline": "Brno: Historic Heart, Modern Soul of Moravia",
      "description": "Brno, the capital of Moravia, is a city that effortlessly combines history with a modern touch. As the second-largest city in the Czech Republic, Brno is a vibrant cultural center, home to the iconic Spilberk Castle, which offers breathtaking views of the city. The city is a major educational hub, with a number of prestigious universities, and is known for its innovative spirit, as evidenced by the Brno Exhibition Centre, one of the largest in Central Europe. Whether you're exploring the labyrinth of underground passages in the Old Town or strolling through the beautiful Brno Botanical Garden, there's something for everyone in this lively city."
    },
    {
      "city": "Nice",
      "country": "France",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/nice.mi",
      "imageUrl": "https://cache.marriott.com//is/image/marriotts7prod/md-ncemd-pool-with-sea-view-16606-36184:Wide-Hor?output-quality=90&interpolation=progressive-bilinear;*,*&downsize=715px:*",
      "headline": "Nice: Sunlit Riviera Charm, Culture, and Coastal Color",
      "description": "Nice, the picturesque jewel of the French Riviera, is a city that effortlessly marries the allure of its historic roots with the vibrancy of a modern Mediterranean hub. The iconic Promenade des Anglais invites you to savor a leisurely stroll along the sun-kissed coastline, indulge in beachfront relaxation, or join the lively nocturnal scene. The Old Town, a tapestry of narrow cobblestone lanes, vividly hued façades, and bustling markets, beckons you to partake in its rich local culture and culinary delights. Whether you're captivated by the Matisse Museum, unwinding in the Jardin Albert I, or savoring a dish of freshly caught seafood and a classic Niçoise salad, Nice presents a diverse palette of experiences to satisfy every traveler's palate."
    },
    {
      "city": "Pittsburgh",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/pittsburgh.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/blue-flowers-botanic-gardens:Square?wid=768&fit=constrain",
      "headline": "Downtown Pittsburgh: Riverfront Skyline, Sports Thrills, Neighborhood Flavor",
      "description": "Downtown Pittsburgh is a vibrant area, with its towering buildings and scenic riverfront, and is home to popular attractions like PNC Park and Heinz Field. Many of our hotels offer amenities such as complimentary Wi-Fi, on-site dining, and fitness centers to help you make the most of your stay. Whether you’re visiting for business or pleasure, Pittsburgh’s varied neighborhoods, such as the trendy Lawrenceville and the historic Mount Washington, are within easy reach, offering you the chance to explore the city’s local culture and cuisine."
    },
    {
      "city": "Bergen",
      "country": "Norway",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "50",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bergen.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-nor-bergen-1734541434467-5:Square?wid=768&fit=constrain",
      "headline": "Bergen: Gateway to Fjords, Culture, and Breathtaking Mountain Views",
      "description": "As the gateway to the fjords, Bergen is a city of natural beauty and cultural riches. Known as the \"Gateway to the Fjords,\" the city offers breathtaking views of the surrounding mountains and water, making it a perfect base for exploring the region's stunning landscapes. Visitors can stroll through the historic Bryggen Wharf, a UNESCO World Heritage site, or take a scenic ride on the Fløibanen funicular to enjoy panoramic vistas of the city and its vibrant harbor. With a variety of museums, galleries, and a thriving culinary scene, Bergen has something to captivate every traveler."
    },
    {
      "city": "Kaunas",
      "country": "Lithuania",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/kaunas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ltu-kaunas-1734536431558-5:Square?wid=768&fit=constrain",
      "headline": "Discover Kaunas Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Kaunas, Lithuania your way! Explore restaurants, local attractions and things to do in your favorite Kaunas, Lithuania neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lyon",
      "country": "France",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/lyon.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-lyon-173453626543266:Square?wid=768&fit=constrain",
      "headline": "Discover Lyon Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Lyon, France your way! Explore restaurants, local attractions and things to do in your favorite Lyon, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lisbon",
      "country": "Portugal",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/lisbon.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-lisbon-753951065845487:Square?wid=768&fit=constrain",
      "headline": "Discover Lisbon Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Lisbon, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Lisbon, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Edinburgh",
      "country": "United Kingdom",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/edinburgh.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-edinburgh-173453784118881:Square?wid=768&fit=constrain",
      "headline": "Edinburgh: Where Ancient Streets Meet Electric Festival Nights",
      "description": "Edinburgh, the historic and vibrant capital, is a city that seamlessly blends ancient tradition with contemporary culture. Home to the iconic Edinburgh Castle, which looms over the city from its volcanic perch, this destination offers a wealth of historical sites, including the Royal Mile, the Palace of Holyroodhouse, and the historic Old Town, a UNESCO World Heritage site. The city’s rich cultural calendar is highlighted by the annual Edinburgh Festival Fringe, the largest arts festival in the world, and the spectacular Hogmanay celebrations, making it a year-round hub of entertainment and creativity."
    },
    {
      "city": "Cordoba",
      "country": "Spain",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/cordoba.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-esp-cordoba-173454068231184:Square?wid=768&fit=constrain",
      "headline": "Discover Córdoba, Spain Your Way with Marriott Bonvoy",
      "description": "Visit Córdoba, Spain your way! Explore restaurants, local attractions and things to do in your favorite Córdoba, Spain neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Belfast",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/belfast.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-belfast-476151815070451:Square?wid=768&fit=constrain",
      "headline": "Belfast: Where Historic Streets Meet Coastal Charm and Culture",
      "description": "Steeped in history and culture, Belfast is a city that invites you to explore its vibrant streets and enjoy its warm hospitality. From the iconic Titanic Belfast, where you can discover the city's rich maritime history, to the cobbled streets of the Cathedral Quarter, home to a bustling arts and dining scene, there's something for everyone in this city of transformation. Whether you're wandering through the picturesque Botanic Gardens or enjoying the beauty of the nearby coastal drives, Belfast offers the perfect blend of urban excitement and natural beauty."
    },
    {
      "city": "Bilbao",
      "country": "Spain",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/bilbao.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-esp-bilbao-173454138699547:Square?wid=768&fit=constrain",
      "headline": "Discover Bilbao Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bilbao, Spain your way! Explore restaurants, local attractions and things to do in your favorite Bilbao, Spain neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Astana",
      "country": "Kazakhstan",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/astana.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-kaz-nur-sultan-173454024369191:Square?wid=768&fit=constrain",
      "headline": "Discover Astana Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Astana, Kazakhstan your way! Explore restaurants, local attractions and things to do in your favorite Astana, Kazakhstan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Strasbourg",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "70",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "80",
      "Music": "40",
      "pageUrl": "https://www.marriott.com/en/destinations/strasbourg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-annecy-173454124038880:Square?wid=768&fit=constrain",
      "headline": "Discover Strasbourg Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Strasbourg, France your way! Explore restaurants, local attractions and things to do in your favorite Strasbourg, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bordeaux",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "10",
      "pageUrl": "https://www.marriott.com/en/destinations/bordeaux.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-bordeaux-173454025372459:Square?wid=768&fit=constrain",
      "headline": "Unlock Bordeaux’s Best Neighborhoods with Marriott Bonvoy Hotels",
      "description": "Visit Bordeaux, France your way! Explore restaurants, local attractions and things to do in your favorite Bordeaux, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Rouen",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/rouen.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-rouen-173453639639860:Square?wid=768&fit=constrain",
      "headline": "Rouen: Where Medieval Magic Meets Modern Norman Flavor",
      "description": "Rouen, a city of rich history and culture, offers a unique blend of medieval and modern charm. As the capital of Normandy, Rouen is celebrated for its stunning Gothic architecture, including the awe-inspiring Cathedral of Notre-Dame, famously depicted by Claude Monet. A leisurely stroll through the old town's cobblestone streets, lined with half-timbered houses and lively markets, is like stepping back in time to the Middle Ages. The city's culinary scene is equally impressive, with a wealth of traditional Norman fare and delectable pastries to savor."
    },
    {
      "city": "Lille",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/lille.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-lille-1734530703817-7:Square?wid=768&fit=constrain",
      "headline": "Lille: Historic Fortress, Vibrant Arts, and Effortless City Comfort",
      "description": "Lille is a city that’s full of life, with a vibrant arts and cultural scene that’s celebrated through numerous festivals and events throughout the year. The Lille Citadelle, a 17th-century fortress, is a must-see for history buffs, offering panoramic views from its ramparts and a fascinating insight into the city’s military past. For a more contemporary experience, head to the La Piscine museum, which is home to an impressive collection of art and design in a beautifully restored art deco building. Our hotels in Lille are designed to make your stay as comfortable and convenient as possible, with a range of thoughtful amenities including free Wi-Fi, fitness centers, and complimentary breakfast."
    },
    {
      "city": "Durham",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/durham-north-carolina.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-nc-durham-173453721778112:Square?wid=768&fit=constrain",
      "headline": "Discover Durham Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Durham, NC your way! Explore restaurants, local attractions and things to do in your favorite Durham, NC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Porto",
      "country": "Portugal",
      "Beach": "50.0",
      "Culinary": "80",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/porto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-porto-1734533917305-4:Square?wid=768&fit=constrain",
      "headline": "Discover Porto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Porto, Portugal your way! Explore restaurants, local attractions and things to do in your favorite Porto, Portugal neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Montpellier",
      "country": "France",
      "Beach": "50.0",
      "Culinary": "70",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/montpellier.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-montpellier-173453846622391:Square?wid=768&fit=constrain",
      "headline": "Discover Montpellier Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Montpellier, France your way! Explore restaurants, local attractions and things to do in your favorite Montpellier, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sousse",
      "country": "Tunisia",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/sousse.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tun-sousse-173453487877866:Square?wid=768&fit=constrain",
      "headline": "Sousse: Timeless Medina Charms Meet Sunlit Mediterranean Shores",
      "description": "Sousse is a bustling coastal city that effortlessly marries ancient history with contemporary allure. As one of the largest cities on the Mediterranean coast, it is home to a plethora of cultural gems, such as the UNESCO-listed Ribat, a medieval fortress that proudly showcases the city's rich heritage. The Old City, or Medina, with its maze-like streets and magnificent architecture, beckons you to journey back in time. Sousse is also a haven for water sports and beach enthusiasts, with its sun-kissed sands and clear waters creating the perfect backdrop for swimming and diving."
    },
    {
      "city": "Mainz",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/mainz.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-mainz-173452975450830:Square?wid=768&fit=constrain",
      "headline": "Mainz: Where Gutenberg’s Legacy Meets Rhine Wine and Romance",
      "description": "Mainz, a city that sits on the banks of the Rhine River, is a place where history and culture are woven into the very fabric of the streets you walk. The city is home to the Gutenberg Museum, a UNESCO World Heritage site, which is dedicated to the life and work of Johannes Gutenberg and the history of printing. Mainz is also a great place for wine lovers, with the Rheinhessen wine region just a stone's throw away. The city's old town is a great place to wander, with its cobbled streets and half-timbered houses. The Romanesque St. Martin's Cathedral is also worth a visit, as is the riverfront promenade, which is a great place to relax and watch the world go by."
    },
    {
      "city": "Novi Sad",
      "country": "Serbia",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/novi-sad.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-srb-novi-sad-222923666672726:Square?wid=768&fit=constrain",
      "headline": "Novi Sad: Danube Charm, Fortress Views, European Vibes",
      "description": "Novi Sad, a city of rich history and contemporary European allure, is a vibrant destination that offers a unique blend of cultural heritage and modern European charm. Situated on the banks of the Danube River, Novi Sad is home to the Petrovaradin Fortress, an iconic landmark that provides breathtaking panoramic views and hosts a variety of cultural events. The city center is a bustling area with pedestrian-friendly streets, charming squares, and a wide selection of cafes, boutiques, and restaurants that offer both traditional Serbian cuisine and international flavors. Whether you are exploring the cobblestone streets of the Stari Grad (Old Town) or enjoying the city's lively nightlife, Novi Sad provides a memorable experience for every traveler."
    },
    {
      "city": "Linz",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/linz.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-linz-173453734847976:Square?wid=768&fit=constrain",
      "headline": "Riverside Flavors and City Delights: Discover Linz, Effortlessly",
      "description": "Linz's prime location on the Danube River means you're just steps from scenic river cruises and beautiful waterfront strolls. And with a variety of local eateries and international cuisine options, you can savor every meal in this food lover's paradise. Our Linz hotels offer modern amenities, including complimentary Wi-Fi and fitness centers, to make your stay as comfortable as possible. From the bustling main square to the serene K Witcher Park, our properties are perfectly situated to help you explore the best of Linz."
    },
    {
      "city": "Padova",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/padova.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-padova-173454141941118:Square?wid=768&fit=constrain",
      "headline": "Padova: Where Ancient Academia Meets Art, Science and Strolls",
      "description": "If you’re looking to soak up the city’s academic heritage, a visit to the University of Padova is a must. One of the oldest in the world, the university’s ancient halls and botanical gardens are a joy to explore. Padova is also a city of art and science, with the Prato della Valle, a large elliptical square surrounded by statues, being a particularly pleasant place for a stroll. Our hotels are conveniently located near these attractions, making them the perfect base for your business or leisure trip."
    },
    {
      "city": "Portsmouth",
      "country": "United Kingdom",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/portsmouth-united-kingdom.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-portsmouth-173453505226786:Square?wid=768&fit=constrain",
      "headline": "Portsmouth: Where Historic Harbours Meet Modern Coastal Buzz",
      "description": "Portsmouth, a jewel on the south coast, is a city of contrasts, blending rich maritime history with a vibrant contemporary scene. The Historic Dockyard is a must-see, with the iconic HMS Victory and the fascinating Mary Rose Museum. For a bird's-eye view, the Spinnaker Tower is the place to be, or perhaps a leisurely stroll along the lively Gunwharf Quays, home to chic outlets and fine dining. The city's cultural heart beats at the Portsmouth Cathedral and the D-Day Story, offering a perfect mix of old and new for every visitor to enjoy."
    },
    {
      "city": "Ljubljana",
      "country": "Slovenia",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/ljubljana.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-svn-ljubljana-173453853723258:Square?wid=768&fit=constrain",
      "headline": "Discover Ljubljana: Eat, Explore, and Stay with Marriott Bonvoy",
      "description": "Visit Ljubljana, Slovenia your way! Explore restaurants, local attractions and things to do in your favorite Ljubljana, Slovenia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Oxford",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/oxford.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-oxford-253445679048832:Square?wid=768&fit=constrain",
      "headline": "Oxford: Dreaming Spires, Timeless Streets, Unforgettable City Escapes",
      "description": "Oxford is a city of Dreaming Spires, with its mix of ancient and modern, world-famous university city with a mix of old and new, where the historic spires of its 38 colleges rise above the bustling streets and charming cafes. The city is steeped in history and culture, with plenty of iconic landmarks to visit, including the Radcliffe Camera, Bodleian Library and Ashmolean Museum. Whether you’re here to explore the university’s 38 colleges, take a punt along the River Cherwell or visit the city’s literary heritage, our hotels in Oxford provide the perfect base for your stay."
    },
    {
      "city": "Burgos",
      "country": "Spain",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/burgos.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-esp-burgos-173453490389033:Square?wid=768&fit=constrain",
      "headline": "Burgos: Gothic Splendor, Medieval Charm, and Castilian Flavors",
      "description": "Burgos, with its breathtaking Gothic architecture and rich medieval history, is a city that enchants from the very first glance. The jewel in its crown, the Cathedral of Burgos, is a UNESCO World Heritage site and a must-see for those who appreciate the city's cultural legacy. A leisurely stroll through the historic city center, with its cobbled streets and charming squares like Plaza Mayor and Plaza del Cid, offers a delightful journey through time. The city's culinary scene, renowned for its traditional Castilian cuisine, is yet another highlight, with its robust stews and the world-famous Burgos sheep cheese to tantalize your taste buds."
    },
    {
      "city": "Basel",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/basel.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-basel-173447133994326:Square?wid=768&fit=constrain",
      "headline": "Basel Bliss: Riverside Strolls, Green Escapes, and Cozy Stays",
      "description": "Stroll along the Rhine’s scenic banks, where boat tours, riverside promenades, and local markets await. The city’s dedication to green spaces is evident in its many parks and gardens, offering the perfect setting for a leisurely walk or a relaxing afternoon. Our hotels in Basel offer a variety of thoughtful amenities, including complimentary Wi-Fi, fitness centers, and free breakfast, to ensure your stay is as comfortable as it is memorable. With a range of locations from the city center to quieter residential areas, our hotels cater to every type of traveler, making it easy to experience the best of Basel."
    },
    {
      "city": "Dijon",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/dijon.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-dijon-173453625541198:Square?wid=768&fit=constrain",
      "headline": "Discover Dijon Your Way: Savor, Explore, Stay with Marriott",
      "description": "Visit Dijon, France your way! Explore restaurants, local attractions and things to do in your favorite Dijon, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Salzburg",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "75",
      "Spa": "0",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/salzburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-salzburg-1734540224442-5:Square?wid=768&fit=constrain",
      "headline": "Salzburg: Baroque Charm, Mozart Melodies, and Alpine Adventures Await",
      "description": "Salzburg, a city rich in baroque architecture and musical history, is a beautiful combination of old-world charm and modern vitality. As the birthplace of Mozart, it is a mecca for classical music lovers, with concerts and festivals honoring his legacy year-round. The city's historic center, a UNESCO World Heritage site, is a warren of cobblestone streets, elegant churches, and inviting cafes, beckoning you to step back in time. Salzburg's prime location also makes it the perfect jumping-off point to the nearby Alps, offering outdoor enthusiasts the chance to enjoy hiking, skiing, and stunning vistas."
    },
    {
      "city": "York",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/york.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-york-368750268357195:Square?wid=768&fit=constrain",
      "headline": "York: Timeless Streets, Towering Views, Perfect Stays for All",
      "description": "York is a city of contrasts. From the panoramic views at Clifford's Tower to the many museums, galleries and shops, there is something for everyone. The city is also home to the Shambles, a narrow, cobbled street lined with shops and restaurants. The York Railway Station is the main station in the city and offers regular services to a number of destinations. Many of our hotels offer on-site dining, fitness and leisure facilities and free Wi-Fi. With a range of modern and historic hotels, we have the perfect place to stay for every type of traveler."
    },
    {
      "city": "Split",
      "country": "Croatia",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/split.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-hrv-split-173453640645885:Square?wid=768&fit=constrain",
      "headline": "Discover Split, Croatia: Local Flavors, Hidden Gems, Marriott Comfort",
      "description": "Visit Split, Croatia your way! Explore restaurants, local attractions and things to do in your favorite Split, Croatia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Savannah",
      "country": "United States",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/savannah.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/cocktail-bar-martini-glass-mhrsSJCSJre.383128:Square?wid=768&fit=constrain",
      "headline": "Discover Savannah Your Way with Marriott Bonvoy Stays",
      "description": "Visit Savannah, GA your way! Explore restaurants, local attractions and things to do in your favorite Savannah, GA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cambridge",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/cambridge.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-cambridge-173453469362429:Square?wid=768&fit=constrain",
      "headline": "Cambridge: Where Timeless Academia Meets Cutting-Edge Innovation",
      "description": "Cambridge, a city that beautifully blends the ancient with the modern, is a place where you can experience the best of both worlds. Home to the world-renowned University of Cambridge, the city is rich in academic history and boasts stunning Gothic architecture, such as the King’s College Chapel and the Bridge of Sighs. Beyond its scholarly roots, Cambridge is also a hotbed for innovation, with a bustling tech sector and numerous science parks. Whether you’re here to soak up the academic atmosphere, explore the city’s cultural heritage, or engage in business, our hotels in Cambridge provide the perfect base for your stay."
    },
    {
      "city": "Lausanne",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/lausanne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-lausanne-173453832692852:Square?wid=768&fit=constrain",
      "headline": "Lausanne: Olympic Spirit, Lakeside Charm, Timeless Swiss Allure",
      "description": "Lausanne, a city that effortlessly marries the past with the present, is a charming jewel perched on the shores of Lake Geneva. As the Olympic Capital, it is home to the International Olympic Committee and the Olympic Museum, a pilgrimage site for sports aficionados. The city's old town, with its labyrinth of cobblestone streets and medieval facades, is a window to history. Lausanne is also celebrated for its dynamic arts and culture scene, with a plethora of museums, galleries, and theaters showcasing local and international talent. Whether you're indulging in the delights of Swiss cuisine at a cozy bistro or taking in the sweeping vistas from the top of the Cathédrale Notre-Dame, there's a treasure to be found for every visitor."
    },
    {
      "city": "Charleston",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/charleston-south-carolina.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/street-house-charleston-south-carolina:Square?wid=768&fit=constrain",
      "headline": "Discover Charleston Your Way with Marriott Bonvoy Stays",
      "description": "Visit Charleston, SC your way! Explore restaurants, local attractions and things to do in your favorite Charleston, SC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Innsbruck",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "50",
      "Ski": "90",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/innsbruck.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-innsbruck-173454024953950:Square?wid=768&fit=constrain",
      "headline": "Innsbruck: Alpine Adventure Meets Old-World Charm",
      "description": "Innsbruck, the capital of the Alps, is a place that combines the best of both worlds: a city steeped in history and tradition, surrounded by breathtaking natural beauty. Whether you're a culture vulture, an outdoor enthusiast, or simply looking to relax in a stunning setting, Innsbruck has something for everyone. The city's historic old town, a UNESCO World Heritage site, is a must-see, with its medieval buildings, narrow streets, and charming shops. The surrounding mountains offer a wide range of activities, from skiing and snowboarding in the winter to hiking and mountain biking in the summer. And with its vibrant arts scene, lively nightlife, and world-class restaurants, Innsbruck is the perfect place to unwind after a day of exploration."
    },
    {
      "city": "Maastricht",
      "country": "Netherlands",
      "Beach": "1.0",
      "Culinary": "60",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/maastricht.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-nld-maastricht-173453846120594:Square?wid=768&fit=constrain",
      "headline": "Maastricht: Timeless History, Lively Culture, Unforgettable European Charm",
      "description": "Maastricht is a city with a rich history, tracing back to Roman times, which makes it a captivating destination for history enthusiasts and culture aficionados. The city's historic center is a picturesque ensemble of medieval architecture, featuring the renowned St. Servatius Bridge and the impressive St. Servatius Basilica. In addition to these historical landmarks, Maastricht boasts a lively arts scene, with a variety of galleries and museums, as well as a diverse culinary landscape that spans from authentic Dutch cuisine to international gastronomy. Whether you're strolling through the city's quaint streets or savoring a peaceful evening at a local café, Maastricht guarantees a memorable and fulfilling visit."
    },
    {
      "city": "Bern",
      "country": "Switzerland",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "25",
      "Spa": "1",
      "Culture": "80",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/bern.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-bern-173453484868016:Square?wid=768&fit=constrain",
      "headline": "Bern: Medieval Charm, Riverside Views, and Capital City Convenience",
      "description": "Welcome to Bern, the UNESCO World Heritage site that is the capital of the Swiss Confederation. Here, you can explore the city’s medieval architecture and charming cobbled streets, which lead to the iconic Zytglogge tower and the gothic Bern Cathedral. The old town is surrounded by the Aare River, offering beautiful views and recreational activities. Whether you’re visiting for business or leisure, our hotels in Bern provide a comfortable and convenient base for your stay. With locations near the main train station and key business districts, you can easily access the city’s attractions and amenities."
    },
    {
      "city": "Santiago de Compostela",
      "country": "Spain",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/santiago.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-skyline-andes-mountains-859940256730875:Square?wid=768&fit=constrain",
      "headline": "Discover Santiago, Chile Your Way with Marriott Bonvoy",
      "description": "Visit Santiago, Chile your way! Explore restaurants, local attractions and things to do in your favorite Santiago, Chile neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Pisa",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/pisa.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-pisa-173453466037821:Square?wid=768&fit=constrain",
      "headline": "Pisa Getaways: Riverside Charm, Culture, and Comfortable Stays",
      "description": "Along the Arno River, Pisa is a beautiful city that’s easy to explore. Museums like the Museo Nazionale di San Matteo and the Museo delle Navi provide a glimpse into the city’s artistic and maritime past. The Lungarni promenades along the river are perfect for a leisurely stroll or a relaxing afternoon. Our Pisa hotels offer comfortable accommodations and easy access to the city’s most popular attractions. Many of our properties also feature modern amenities like free Wi-Fi, fitness centers, and complimentary breakfast to make your stay more enjoyable. Whether you’re visiting Pisa for a quick getaway or an extended stay, our hotels are designed to make your stay unforgettable."
    },
    {
      "city": "Vicenza",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "10",
      "pageUrl": "https://www.marriott.com/en/destinations/vicenza.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-vicenza-173453391717152:Square?wid=768&fit=constrain",
      "headline": "Vicenza: Savor, Sip, and Stay in Style",
      "description": "Vicenza’s culinary scene is a must-see, with local trattorias serving up traditional dishes like bigoli in salsa and baccalà mantecato. The city is also a great starting point for wine tours, with the Veneto countryside offering some of the best vintages in the region. After a day of exploration, relax in one of our hotels with modern amenities, including free Wi-Fi and fitness centers. Whether you’re visiting for leisure or business, our hotels in Vicenza offer convenience and comfort for an unforgettable trip."
    },
    {
      "city": "Ann Arbor",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/ann-arbor.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-mi-ann-arbor-717388133189628:Square?wid=768&fit=constrain",
      "headline": "Discover Ann Arbor Your Way with Marriott Bonvoy Stays",
      "description": "Visit Ann Arbor, MI your way! Explore restaurants, local attractions and things to do in your favorite Ann Arbor, MI neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Asheville",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/asheville.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/band-voilin-drums-musicians-music-folk-blues:Square?wid=768&fit=constrain",
      "headline": "Asheville: Mountain Art Haven with Old-World Charm",
      "description": "Asheville, a city nestled in the Blue Ridge Mountains, is a place of vibrant culture and rich history. Known as the \"Paris of the South,\" it is home to a myriad of art galleries, craft breweries, and unique boutiques, making it a haven for those with a creative spirit. The historic Biltmore Estate, America’s largest privately-owned home, is a must-see, with its opulent rooms, extensive gardens, and award-winning winery. The downtown area, with its well-preserved Art Deco architecture, offers a unique blend of old-world charm and modern sophistication, where you can enjoy live music, street performances, and a diverse culinary scene."
    },
    {
      "city": "Bath",
      "country": "United Kingdom",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "75",
      "Culture": "90",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/bath.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-bath-224015010835747:Square?wid=768&fit=constrain",
      "headline": "Discover Bath Your Way with Marriott Bonvoy Stays",
      "description": "Visit Bath, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Bath, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Thimphu",
      "country": "Bhutan",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/thimphu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-btn-thimphu-173453529206595:Square?wid=768&fit=constrain",
      "headline": "Discover Thimphu Your Way: Bhutan Adventures with Marriott Bonvoy",
      "description": "Visit Thimphu, Bhutan your way! Explore restaurants, local attractions and things to do in your favorite Thimphu, Bhutan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Chester",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/chester.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-chester-173453914624154:Square?wid=768&fit=constrain",
      "headline": "Discover Chester Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Chester, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Chester, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Santa Fe",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "85",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santa-fe.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/santa-fe-train-station-new-mexico:Square?wid=768&fit=constrain",
      "headline": "Discover Santa Fe Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Santa Fe, NM your way! Explore restaurants, local attractions and things to do in your favorite Santa Fe, NM neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Guadalajara",
      "country": "Spain",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/guadalajara.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-mex-guadalajara-173454107711087:Square?wid=768&fit=constrain",
      "headline": "Discover Guadalajara Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Guadalajara, Mexico your way! Explore restaurants, local attractions and things to do in your favorite Guadalajara, Mexico neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Creteil",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/crete.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-crete-151586342206659:Square?wid=768&fit=constrain",
      "headline": "Discover Crete Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Crete, Greece your way! Explore restaurants, local attractions and things to do in your favorite Crete, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Como",
      "country": "Italy",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/lake-como.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-lake-como-173453822550183:Square?wid=768&fit=constrain",
      "headline": "Discover Lake Como Your Way with Marriott Bonvoy Stays",
      "description": "Visit Lake Como, Italy your way! Explore restaurants, local attractions and things to do in your favorite Lake Como, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Toledo",
      "country": "Spain",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/toledo-spain.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-oh-toledo-spain-173452972938875:Square?wid=768&fit=constrain",
      "headline": "Discover Toledo Your Way with Marriott Bonvoy Stays",
      "description": "Visit Toledo, OH your way! Explore restaurants, local attractions and things to do in your favorite Toledo, OH neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lucca",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/lucca.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-lucca-228130211076355:Square?wid=768&fit=constrain",
      "headline": "Discover Lucca Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Lucca, Italy your way! Explore restaurants, local attractions and things to do in your favorite Lucca, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nikko",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "10",
      "pageUrl": "https://www.marriott.com/en/destinations/nikko.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-nikko-173453072894825:Square?wid=768&fit=constrain",
      "headline": "Nikko: Where Sacred Traditions Meet Timeless Natural Serenity",
      "description": "Nikko is a city that effortlessly marries the beauty of nature with the richness of cultural heritage, inviting you to a tranquil retreat in the heart of Japan’s historical and spiritual essence. Famed for its magnificent temples and shrines, including the ornate Toshogu Shrine, a UNESCO World Heritage site, Nikko is a destination for those who seek a profound connection with Japanese tradition. The surrounding landscapes, from the majestic Kegon Falls to the peaceful Lake Chuzenji, offer a myriad of opportunities for outdoor enthusiasts to savor the delights of hiking, boating, and the sheer serenity of the environment."
    },
    {
      "city": "Siena",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "60",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "80",
      "Music": "20",
      "pageUrl": "https://www.marriott.com/en/destinations/siena.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-siena-173453069878483:Square?wid=768&fit=constrain",
      "headline": "Discover Siena Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Siena, Italy your way! Explore restaurants, local attractions and things to do in your favorite Siena, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Charlottesville",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/charlotte.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/park-skyline-downtown-charlotte-north-carolina:Square?wid=768&fit=constrain",
      "headline": "Discover Charlotte Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Charlotte, NC your way! Explore restaurants, local attractions and things to do in your favorite Charlotte, NC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Venice",
      "country": "Italy",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/venice.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-venice-416204426953302:Square?wid=768&fit=constrain",
      "headline": "Discover Venice Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Venice, Italy your way! Explore restaurants, local attractions and things to do in your favorite Venice, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Inverness",
      "country": "United Kingdom",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/inverness.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-inverness-173453618003220:Square?wid=768&fit=constrain",
      "headline": "Inverness Adventures: Wild Highlands, Great Food, Cozy Stays",
      "description": "For those who love the great outdoors, Inverness is the perfect base for your adventures. Hike, fish, or spot wildlife in the nearby Cairngorms National Park. The city is also home to a vibrant culinary scene, with a mix of traditional Scottish and international cuisine. Many of our Inverness hotels also offer amenities like free Wi-Fi, on-site fitness centers, and breakfast options to help you start your day right. Whether you’re here for a short break or an extended stay, Inverness and its surrounding beauty will captivate and inspire."
    },
    {
      "city": "Durham",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/durham.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-durham-471151142219990:Square?wid=768&fit=constrain",
      "headline": "Discover Durham Your Way with Marriott Bonvoy Stays",
      "description": "Visit Durham, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Durham, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Corfu",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/corfu.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-corfu-173453640142985:Square?wid=768&fit=constrain",
      "headline": "Discover Corfu Your Way with Marriott Bonvoy Stays",
      "description": "Visit Corfu, Greece your way! Explore restaurants, local attractions and things to do in your favorite Corfu, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Florence",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/florence.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-florence-991758286415192:Square?wid=768&fit=constrain",
      "headline": "Discover Florence Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Florence, Italy your way! Explore restaurants, local attractions and things to do in your favorite Florence, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Winchester",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/winchester.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-va-winchester-173453853221729:Square?wid=768&fit=constrain",
      "headline": "Winchester: Where History, Southern Charm, and Scenic Beauty Meet",
      "description": "Winchester is a city where history and natural beauty converge, offering a unique blend of Southern charm and vibrant cultural experiences. Known for its pivotal role during the Civil War, the city is dotted with historic sites and museums that bring the past to life, such as the Museum of the Shenandoah Valley and the Stonewall Jackson House. Visitors can enjoy a leisurely stroll through the picturesque downtown, lined with quaint shops, art galleries, and local eateries that showcase the region’s culinary traditions. Whether you’re a history enthusiast, nature lover, or simply looking for a relaxing getaway, Winchester’s rich heritage and scenic surroundings make it an ideal destination for your next trip."
    },
    {
      "city": "Sintra",
      "country": "Portugal",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "90",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/sintra.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-prt-sintra-173453463030965:Square?wid=768&fit=constrain",
      "headline": "Sintra: Fairytale Palaces Amid Lush, Enchanted Hills",
      "description": "Sintra is a city where history and nature blend seamlessly, creating a truly magical atmosphere. Known for its opulent palaces and castles, the city offers a glimpse into Portugal’s royal past, with each monument telling a story of its own. The colorful Pena Palace, perched atop a hill, is a must-visit, as is the mysterious Quinta da Regaleira, with its enigmatic symbols and underground tunnels. Sintra’s lush, verdant landscapes, including the Serra de Sintra, provide a serene backdrop for hiking and picnics, making it a perfect escape for those seeking natural beauty and tranquility."
    },
    {
      "city": "Colonia del Sacramento",
      "country": "Uruguay",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/colonia-del-sacramento.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ury-colonia-del-sacrament-173453720775738:Square?wid=768&fit=constrain",
      "headline": "Colonia del Sacramento: Historic Charm Meets Beaches, Cafés, and Calm",
      "description": "But the city isn’t just about history. It also has a thriving cultural scene, with artisan markets, quaint cafes, and local restaurants serving up traditional Uruguayan cuisine. And with sandy beaches and leafy parks nearby, it’s the perfect place to relax and enjoy some outdoor activities. Whether you’re a history buff or just looking for a peaceful getaway, our accommodations in Colonia Del Sacramento offer the perfect mix of comfort and convenience to make your visit special."
    },
    {
      "city": "Kilkenny",
      "country": "Ireland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/kilkenny.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-irl-kilkenny-173453509253894:Square?wid=768&fit=constrain",
      "headline": "Kilkenny: Medieval Charm, Modern Culture, and Castles with Character",
      "description": "Kilkenny is a medieval city that seamlessly blends the old and the new. The city’s most iconic building, Kilkenny Castle, is an 800-year-old symbol of the city’s rich history. The castle and its beautiful gardens are well worth a visit. The city is also home to a number of art galleries and craft workshops, making it a great place to pick up a unique souvenir. Kilkenny is also a great place to eat, with a number of restaurants and cafes serving up traditional Irish food and international cuisine."
    },
    {
      "city": "Williamsburg",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/williamsburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/williamsburg-virginia-historic-home:Square?wid=768&fit=constrain",
      "headline": "Discover Williamsburg, VA Your Way with Marriott Bonvoy",
      "description": "Visit Williamsburg, VA your way! Explore restaurants, local attractions and things to do in your favorite Williamsburg, VA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cambridge",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/cambridge.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-cambridge-173453469362429:Square?wid=768&fit=constrain",
      "headline": "Cambridge: Where Timeless Academia Meets Cutting-Edge Innovation",
      "description": "Cambridge, a city that beautifully blends the ancient with the modern, is a place where you can experience the best of both worlds. Home to the world-renowned University of Cambridge, the city is rich in academic history and boasts stunning Gothic architecture, such as the King’s College Chapel and the Bridge of Sighs. Beyond its scholarly roots, Cambridge is also a hotbed for innovation, with a bustling tech sector and numerous science parks. Whether you’re here to soak up the academic atmosphere, explore the city’s cultural heritage, or engage in business, our hotels in Cambridge provide the perfect base for your stay."
    },
    {
      "city": "Paro",
      "country": "Bhutan",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/paros.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-paros-173453073398731:Square?wid=768&fit=constrain",
      "headline": "Discover Paros, Greece Your Way with Marriott Bonvoy",
      "description": "Visit Paros, Greece your way! Explore restaurants, local attractions and things to do in your favorite Paros, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Princeton",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "1",
      "pageUrl": "https://www.marriott.com/en/destinations/princeton.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-nj-princeton-173453398547337:Square?wid=768&fit=constrain",
      "headline": "Princeton Getaway: Historic Charm, Scenic Trails, Relaxing Stays",
      "description": "In addition to its academic attractions, Princeton also offers a rich history and a robust community. The town is home to a number of parks and gardens, perfect for a leisurely stroll or a picnic. For those who love the outdoors, the nearby Delaware and Raritan Canal offers scenic bike paths and walking trails. Whether you are planning a weekend escape or a longer visit, our hotels in Princeton offer the amenities you need, including complimentary Wi-Fi, fitness centers and on-site dining, to make your stay as relaxing and enjoyable as possible."
    },
    {
      "city": "Bath",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/bath.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-bath-224015010835747:Square?wid=768&fit=constrain",
      "headline": "Discover Bath Your Way with Marriott Bonvoy Stays",
      "description": "Visit Bath, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Bath, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Gettysburg",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/gettysburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-pa-gettysburg-173453624031531:Square?wid=768&fit=constrain",
      "headline": "Discover Gettysburg Your Way with Marriott Bonvoy Stays",
      "description": "Visit Gettysburg, PA your way! Explore restaurants, local attractions and things to do in your favorite Gettysburg, PA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nagoya Honshu",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/nagoya.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-nagoya-737012206932219:Square?wid=768&fit=constrain",
      "headline": "Discover Nagoya Your Way with Marriott Bonvoy Stays",
      "description": "Visit Nagoya, Japan your way! Explore restaurants, local attractions and things to do in your favorite Nagoya, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Newcastle",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/newcastle.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-newcastle-173453912116177:Square?wid=768&fit=constrain",
      "headline": "Discover Newcastle Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Newcastle, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Newcastle, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Beyoglu/Istanbul",
      "country": "Türkiye",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/istanbul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-istanbul-173454093632192:Square?wid=768&fit=constrain",
      "headline": "Discover Istanbul Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Istanbul, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Istanbul, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Izmir",
      "country": "Türkiye",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/izmir.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-izmir-173454751712818:Square?wid=768&fit=constrain",
      "headline": "Discover Izmir Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Izmir, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Izmir, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paris La Défense",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/paris.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arc-de-triomphe-paris-634207441403522:Square?wid=768&fit=constrain",
      "headline": "Discover Paris Your Way with Marriott Bonvoy Stays",
      "description": "Visit Paris, France your way! Explore restaurants, local attractions and more in your favorite Paris neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Frankfurt",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/frankfurt.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-frankfurt-1734538639117-1:Square?wid=768&fit=constrain",
      "headline": "Frankfurt Uncovered: Breweries, Historic Squares, Forest Escapes Await",
      "description": "Uncover the charm of Frankfurt’s neighborhoods. Trendy Sachsenhausen is home to craft breweries and traditional German pubs. The historic Römerberg square is perfect for a leisurely stroll or a visit to the town hall. Nature lovers can escape to the Frankfurt City Forest or one of the city’s many parks. Our hotels are strategically located to give you easy access to all these attractions and more."
    },
    {
      "city": "Istanbul",
      "country": "Türkiye",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/istanbul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-istanbul-173454093632192:Square?wid=768&fit=constrain",
      "headline": "Discover Istanbul Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Istanbul, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Istanbul, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nr Stratford-upon-Avon",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/stratford-upon-avon.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-stratford-upon-avon-173453808694025:Square?wid=768&fit=constrain",
      "headline": "Discover Stratford-upon-Avon: Shakespeare, Charm, and Marriott Comfort",
      "description": "Visit Stratford-upon-Avon, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Stratford-upon-Avon, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bursa",
      "country": "Türkiye",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/bursa.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-bursa-173453636133579:Square?wid=768&fit=constrain",
      "headline": "Discover Bursa Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bursa, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Bursa, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paris/Bagnolet",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/paris.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arc-de-triomphe-paris-634207441403522:Square?wid=768&fit=constrain",
      "headline": "Discover Paris Your Way with Marriott Bonvoy Stays",
      "description": "Visit Paris, France your way! Explore restaurants, local attractions and more in your favorite Paris neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nara City",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/nara.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lc-osanl-nara-park-0387-10533:Square?wid=768&fit=constrain",
      "headline": "Nara: Walk Japan’s Ancient Capital of Temples and Tranquility",
      "description": "Nara, a city with a rich history and cultural significance, is an essential stop for those who want to delve into Japan's ancient past. As the country's first permanent capital, Nara is home to a number of UNESCO World Heritage sites, including the famous Todai-ji Temple, which houses the world's largest bronze statue of Buddha, and the peaceful forests of Mt. Wakakusa. The city's serene parks and historic temples provide a welcome escape from the hustle and bustle of modern life, and its quaint streets are filled with traditional shops and restaurants that give you a taste of local living."
    },
    {
      "city": "Cologne",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/cologne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-cologne-704089741300265:Square?wid=768&fit=constrain",
      "headline": "Discover Cologne Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Cologne, Germany your way! Explore restaurants, local attractions and things to do in your favorite Cologne, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Bratislava",
      "country": "Slovak Republic",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/bratislava.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-svk-bratislava-173453862369512:Square?wid=768&fit=constrain",
      "headline": "Discover Bratislava Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Bratislava, Slovakia your way! Explore restaurants, local attractions and things to do in your favorite Bratislava, Slovakia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New York",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/york.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-york-368750268357195:Square?wid=768&fit=constrain",
      "headline": "York: Timeless Streets, Towering Views, Perfect Stays for All",
      "description": "York is a city of contrasts. From the panoramic views at Clifford's Tower to the many museums, galleries and shops, there is something for everyone. The city is also home to the Shambles, a narrow, cobbled street lined with shops and restaurants. The York Railway Station is the main station in the city and offers regular services to a number of destinations. Many of our hotels offer on-site dining, fitness and leisure facilities and free Wi-Fi. With a range of modern and historic hotels, we have the perfect place to stay for every type of traveler."
    },
    {
      "city": "St. Augustine",
      "country": "USA",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/st-augustine.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/aerial-view-st-augustine-florida:Square?wid=768&fit=constrain",
      "headline": "Discover St. Augustine Your Way with Marriott Bonvoy Hotels",
      "description": "Visit St. Augustine, FL your way! Explore restaurants, local attractions and things to do in your favorite St. Augustine, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Chapel Hill",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/chapel-hill.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-nc-chapel-hill-173453851025980:Square?wid=768&fit=constrain",
      "headline": "Discover Chapel Hill Your Way with Marriott Bonvoy Stays",
      "description": "Visit Chapel Hill, NC your way! Explore restaurants, local attractions and things to do in your favorite Chapel Hill, NC neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Antwerp",
      "country": "Belgium",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "80",
      "Music": "60",
      "pageUrl": "https://www.marriott.com/en/destinations/antwerp.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bel-antwerp-173453933670517:Square?wid=768&fit=constrain",
      "headline": "Discover Antwerp Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Antwerp, Belgium your way! Explore restaurants, local attractions and things to do in your favorite Antwerp, Belgium neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Macau",
      "country": "China",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/macau.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/macau-daytrips1:Square?wid=768&fit=constrain",
      "headline": "Discover Macau Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Macau, China your way! Explore restaurants, local attractions and things to do in your favorite Macau, China neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hong Kong",
      "country": "Hong Kong",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/hong-kong.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-JordHammond-HongKong-739569223059559:Square?wid=768&fit=constrain",
      "headline": "Hong Kong: Electric Nights, Timeless Sights, Endless City Delights",
      "description": "Hong Kong is a city that never stops. A place where the ancient and the modern sit side by side, it’s a city of contrasts. From the soaring skyscrapers to the bustling street markets and the serene temples, you’ll find something new to explore around every corner. As a global financial hub, Hong Kong is a city that knows how to live well. With world-class dining, luxury shopping, and efficient public transport, it’s a city that has it all. Our hotels in Hong Kong are perfectly placed to help you explore everything the city has to offer, from the iconic Victoria Peak to the famous Star Ferry and the vibrant Causeway Bay."
    },
    {
      "city": "Weimar",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "25",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/weimar.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-weimar-173454138197795:Square?wid=768&fit=constrain",
      "headline": "Weimar: Where Classic Culture Meets Contemporary City Charm",
      "description": "But Weimar isn’t just a place to look back. The city is also a thriving modern metropolis with plenty of charming cafes, boutique shops, and contemporary galleries to explore. And the city’s parks, like the Park an der Ilm, offer peaceful spots to relax and take in the beauty of nature. Whether you’re here for a cultural pilgrimage or a leisurely weekend, our hotels in Weimar offer amenities like free Wi-Fi, fitness centers, and complimentary breakfast to make your stay more enjoyable. From the heart of the city to quieter residential areas, our properties offer the perfect home base for exploring all that Weimar has to offer."
    },
    {
      "city": "Georgetown",
      "country": "Malaysia",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "St Augustine",
      "country": "USA",
      "Beach": "50.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/st-augustine.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/aerial-view-st-augustine-florida:Square?wid=768&fit=constrain",
      "headline": "Discover St. Augustine Your Way with Marriott Bonvoy Hotels",
      "description": "Visit St. Augustine, FL your way! Explore restaurants, local attractions and things to do in your favorite St. Augustine, FL neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New Haven",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/new-haven.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ct-new-haven-173453849214349:Square?wid=768&fit=constrain",
      "headline": "New Haven: Where Timeless History Meets Vibrant Modern Energy",
      "description": "New Haven is a city that celebrates the best of both worlds: a rich history and a bright future. As the home of Yale University, the city is a haven for history and culture buffs, with a variety of museums, galleries, and historic sites to explore. The Yale University Art Gallery and the Peabody Museum of Natural History are just two of the many attractions that draw visitors from near and far. New Haven’s vibrant downtown area, known as the Green, is the perfect place to start your adventure, with its outdoor events, farmers' markets, and diverse dining options."
    },
    {
      "city": "Sirkeci / Fatih / Istanbul",
      "country": "Türkiye",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/istanbul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-istanbul-173454093632192:Square?wid=768&fit=constrain",
      "headline": "Discover Istanbul Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Istanbul, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Istanbul, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Osaka Honshu",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/osaka.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/rz-osarz-osaka-shinsaibashi-23169:Square?wid=768&fit=constrain",
      "headline": "Discover Osaka Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Osaka, Japan your way! Explore restaurants, local attractions and things to do in your favorite Osaka, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Long Island City",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/long-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/seafood-wine-dinner-restaurant-candle-swh.438335:Square?wid=768&fit=constrain",
      "headline": "Experience Long Island Your Way with Marriott Bonvoy Stays",
      "description": "Visit Long Island, NY your way! Explore restaurants, local attractions and things to do in your favorite Long Island, NY neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hollywood",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/hollywood.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-hollywood-173453621519438:Square?wid=768&fit=constrain",
      "headline": "Discover Hollywood Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hollywood, CA your way! Explore restaurants, local attractions and things to do in your favorite Hollywood, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Ankara",
      "country": "Türkiye",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/ankara.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-ankara-173452949464726:Square?wid=768&fit=constrain",
      "headline": "Ankara Awaits: Savor, Shop, and Stay in Style",
      "description": "If you’re looking to explore beyond the historical sites, Ankara’s culinary scene is a must-try, with an array of traditional Turkish dishes and international cuisine available in its diverse restaurants. The city’s shopping districts, such as Çankaya and Ulus, offer everything from local handicrafts to high-end fashion, making it a shopper’s paradise. Whether you’re here for business or leisure, our hotels provide the perfect base with amenities like free Wi-Fi, fitness centers, and complimentary breakfast, ensuring your stay is as enjoyable as it is productive."
    },
    {
      "city": "Santorini",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/santorini.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-santorini-587986249568062:Square?wid=768&fit=constrain",
      "headline": "Discover Santorini Your Way with Marriott Bonvoy Stays",
      "description": "Visit Santorini, Greece your way! Explore restaurants, local attractions and things to do in your favorite Santorini, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Geneva",
      "country": "Switzerland",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "50",
      "Spa": "75",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/geneva.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-geneva-429826027636888:Square?wid=768&fit=constrain",
      "headline": "Geneva: Where Alpine Beauty Meets Global Peace and Culture",
      "description": "Geneva is a city that effortlessly combines the best of both worlds—a stunning lakefront setting with breathtaking views of the Alps, and a place where international diplomacy meets a rich tapestry of culture and history. Known as the \"Peace Capital,\" Geneva is home to numerous international organizations, including the United Nations and the Red Cross, making it a hub for global affairs. But don't be fooled by its serious side—Geneva offers a delightful blend of sophisticated charm and natural beauty, from its iconic Jet d'Eau to the tranquil Botanical Garden. Whether you're exploring the historic Old Town, enjoying the vibrant culinary scene, or taking a leisurely stroll along the lake, every corner of the city invites you to discover its unique blend of elegance and warmth."
    },
    {
      "city": "Saint Rémy de Provence",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/saint-remy-de-provence.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-saint-remy-de-provenc-173453391742515:Square?wid=768&fit=constrain",
      "headline": "Discover Saint-Rémy-de-Provence: Your Marriott Bonvoy Getaway Awaits",
      "description": "Visit Saint-Rémy-de-Provence, France your way! Explore restaurants, local attractions and things to do in your favorite Saint-Rémy-de-Provence, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nara",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/nara.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lc-osanl-nara-park-0387-10533:Square?wid=768&fit=constrain",
      "headline": "Nara: Walk Japan’s Ancient Capital of Temples and Tranquility",
      "description": "Nara, a city with a rich history and cultural significance, is an essential stop for those who want to delve into Japan's ancient past. As the country's first permanent capital, Nara is home to a number of UNESCO World Heritage sites, including the famous Todai-ji Temple, which houses the world's largest bronze statue of Buddha, and the peaceful forests of Mt. Wakakusa. The city's serene parks and historic temples provide a welcome escape from the hustle and bustle of modern life, and its quaint streets are filled with traditional shops and restaurants that give you a taste of local living."
    },
    {
      "city": "Frankfurt/Offenbach",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/frankfurt.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-frankfurt-1734538639117-1:Square?wid=768&fit=constrain",
      "headline": "Frankfurt Uncovered: Breweries, Historic Squares, Forest Escapes Await",
      "description": "Uncover the charm of Frankfurt’s neighborhoods. Trendy Sachsenhausen is home to craft breweries and traditional German pubs. The historic Römerberg square is perfect for a leisurely stroll or a visit to the town hall. Nature lovers can escape to the Frankfurt City Forest or one of the city’s many parks. Our hotels are strategically located to give you easy access to all these attractions and more."
    },
    {
      "city": "Hong Kong",
      "country": "China",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/hong-kong.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-JordHammond-HongKong-739569223059559:Square?wid=768&fit=constrain",
      "headline": "Hong Kong: Electric Nights, Timeless Sights, Endless City Delights",
      "description": "Hong Kong is a city that never stops. A place where the ancient and the modern sit side by side, it’s a city of contrasts. From the soaring skyscrapers to the bustling street markets and the serene temples, you’ll find something new to explore around every corner. As a global financial hub, Hong Kong is a city that knows how to live well. With world-class dining, luxury shopping, and efficient public transport, it’s a city that has it all. Our hotels in Hong Kong are perfectly placed to help you explore everything the city has to offer, from the iconic Victoria Peak to the famous Star Ferry and the vibrant Causeway Bay."
    },
    {
      "city": "Zanzibar",
      "country": "United Republic of Tanzania",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/zanzibar.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tza-zanzibar-173453395536835:Square?wid=768&fit=constrain",
      "headline": "Discover Zanzibar Your Way with Marriott Bonvoy Stays",
      "description": "Visit Zanzibar, Tanzania your way! Explore restaurants, local attractions and things to do in your favorite Zanzibar, Tanzania neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "HOF BEI SALZBURG",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/salzburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-salzburg-1734540224442-5:Square?wid=768&fit=constrain",
      "headline": "Salzburg: Baroque Charm, Mozart Melodies, and Alpine Adventures Await",
      "description": "Salzburg, a city rich in baroque architecture and musical history, is a beautiful combination of old-world charm and modern vitality. As the birthplace of Mozart, it is a mecca for classical music lovers, with concerts and festivals honoring his legacy year-round. The city's historic center, a UNESCO World Heritage site, is a warren of cobblestone streets, elegant churches, and inviting cafes, beckoning you to step back in time. Salzburg's prime location also makes it the perfect jumping-off point to the nearby Alps, offering outdoor enthusiasts the chance to enjoy hiking, skiing, and stunning vistas."
    },
    {
      "city": "Heidelberg",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/heidelberg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-heidelberg-1734538618600-1:Square?wid=768&fit=constrain",
      "headline": "Heidelberg: Where Romantic Ruins Meet Riverside Charm",
      "description": "Heidelberg is a city that effortlessly blends history and natural beauty. The medieval charm of its architecture is complemented by the verdant landscapes of the Neckar River valley. The Heidelberg Castle, with its commanding position on the hill, invites you to explore its rich history and the romance of its ruins. The Old Town, a postcard-perfect scene of cobblestone streets and half-timbered houses, is a treasure trove of charm waiting to be discovered. Whether you're strolling through the hallowed halls of the historic Heidelberg University, meandering along the Philosopher’s Walk, or enjoying a serene boat ride on the Neckar, the city offers a perfect balance of cultural immersion and relaxation."
    },
    {
      "city": "Ghent",
      "country": "Belgium",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/ghent.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bel-ghent-620282404307491:Square?wid=768&fit=constrain",
      "headline": "Ghent: Where Timeless Canals Meet Bold, Modern Culture",
      "description": "Ghent is a city where history and innovation blend seamlessly, creating a vibrant and dynamic atmosphere for visitors. The medieval architecture, including the iconic Gravensteen and the majestic Belfry, stands as a testament to the city's rich heritage, while the bustling streets of Sint-Niklaas and the trendy neighborhoods like Patershol offer a modern twist on traditional Belgian charm. Ghent is also a hub of culture, with museums such as the Museum of Fine Arts and the Design Museum Gent providing a deep dive into artistic and design excellence. For a more relaxed experience, the city's picturesque canals and charming parks, like Citadelpark, offer serene spots to unwind and enjoy the local scenery."
    },
    {
      "city": "Lucerne",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/lucerne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-lucerne-173453504213895:Square?wid=768&fit=constrain",
      "headline": "Discover Lucerne Your Way with Marriott Bonvoy Stays",
      "description": "Visit Lucerne, Switzerland your way! Explore restaurants, local attractions and things to do in your favorite Lucerne, Switzerland neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Osaka-City",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/osaka.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/rz-osarz-osaka-shinsaibashi-23169:Square?wid=768&fit=constrain",
      "headline": "Discover Osaka Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Osaka, Japan your way! Explore restaurants, local attractions and things to do in your favorite Osaka, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sarajevo",
      "country": "Bosnia Herzegovina",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "40",
      "pageUrl": "https://www.marriott.com/en/destinations/sarajevo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bih-sarajevo-173453855228925:Square?wid=768&fit=constrain",
      "headline": "Sarajevo: Where East Meets West in Timeless Harmony",
      "description": "Sarajevo, a city with a storied past and a unique blend of East and West, is often referred to as the “Jerusalem of Europe.” This vibrant city is home to a variety of religious landmarks, including mosques, synagogues, and churches, which coexist in a singular harmony. The Old Town, or Baščaršija, is a must-see, with its narrow streets, traditional craft shops, and the iconic Gazi Husrev-bey Mosque. Sarajevo’s lively markets, historic sites, and the remnants of the 1984 Winter Olympics are just a few of the many attractions that make it a city worth exploring."
    },
    {
      "city": "Kyoto-City",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/kyoto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/50464712-kyoto_destination_fushimi-inari-1:Square?wid=768&fit=constrain",
      "headline": "Discover Kyoto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Kyoto, Japan your way! Explore restaurants, local attractions and things to do in your favorite Kyoto, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Freiburg im Breisgau",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/freiburg-im-breisgau.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-freiburg-im-breisgau-173453722280713:Square?wid=768&fit=constrain",
      "headline": "Sun-Kissed Freiburg: Medieval Charm Meets Green Innovation",
      "description": "Tucked away in the heart of the Black Forest, Freiburg is a city that basks in the sun, radiating a unique blend of medieval allure and contemporary sustainability. Its cobblestone streets and timber-framed buildings tell stories of bygone eras, while its dedication to green living and renewable energy speaks volumes about its forward-thinking spirit. Freiburg's cultural landscape is equally impressive, with a plethora of museums, galleries, and the esteemed Albert-Ludwigs-University, a beacon for scholars and students worldwide. Whether you're taking in the sights at the historic Minster Square, following the meandering Bächle waterways, or indulging in the local cuisine at a quaint wine tavern, Freiburg promises an experience that is both distinctive and indelible."
    },
    {
      "city": "Venice Tessera",
      "country": "Italy",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/venice.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-venice-416204426953302:Square?wid=768&fit=constrain",
      "headline": "Discover Venice Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Venice, Italy your way! Explore restaurants, local attractions and things to do in your favorite Venice, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Skopje",
      "country": "Macedonia",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/skopje.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-mkd-skopje-173453756256636:Square?wid=768&fit=constrain",
      "headline": "Discover Skopje Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Skopje, Macedonia your way! Explore restaurants, local attractions and things to do in your favorite Skopje, Macedonia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Pushkar",
      "country": "India",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/pushkar.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ind-pushkar-173453521678066:Square?wid=768&fit=constrain",
      "headline": "Pushkar: Where Sacred Serenity Meets Adventure and Vibrant Culture",
      "description": "Whether you’re here for a spiritual journey or to explore the city’s cultural heritage, Pushkar offers the perfect blend of relaxation and adventure. Take a boat ride on the lake at sunrise or hike up to the Savitri Temple for panoramic views of the city. Our hotels offer modern amenities and thoughtful services to ensure a comfortable stay. With easy access to local attractions and a commitment to exceptional guest experiences, our hotels make it simple to enjoy the charm and tranquility of this enchanting city."
    },
    {
      "city": "Montreux",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/montreux.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-montreux-173452973943830:Square?wid=768&fit=constrain",
      "headline": "Montreux Magic: Lakeside Alps, Jazz Nights, Timeless Swiss Charm",
      "description": "Montreux, a city of natural beauty and cultural vibrancy, is nestled along the shores of Lake Geneva. Its breathtaking views of the Swiss Alps and the inviting waterfront promenade make it an ideal destination for a leisurely escape or a romantic retreat. Known for its music and art scene, Montreux is home to the renowned Montreux Jazz Festival and a variety of galleries and performance venues. Whether you're exploring the history of Chillon Castle or savoring the beauty of the surrounding vineyards, Montreux offers a seamless blend of historical allure and contemporary elegance to cater to all types of travelers."
    },
    {
      "city": "Pienza",
      "country": "Italy",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "20",
      "Culture": "80",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/pienza.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ita-pienza-173454120488043:Square?wid=768&fit=constrain",
      "headline": "Pienza: Tuscany’s Timeless Renaissance Dream in Rolling Hills",
      "description": "Pienza, a small gem in the heart of Tuscany, is a place that captures the hearts of those who visit with its harmonious Renaissance architecture and stunning landscapes. Pienza was designed to be the \"ideal city\" by Pope Pius II in the 15th century. The historic center of Pienza is a UNESCO World Heritage site and is home to beautiful works of art, such as the Palazzo Piccolomini and the Cathedral of Santa Maria Assunta. The city’s narrow streets and charming squares invite you to wander and take in the timeless beauty, while the surrounding vineyards and rolling hills are the perfect setting for a leisurely walk or a scenic drive."
    },
    {
      "city": "Rhodes",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/rhodes.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-rhodes-173453775566454:Square?wid=768&fit=constrain",
      "headline": "Discover Rhodes, Greece: Local Flavors, Hidden Gems, Marriott Style",
      "description": "Visit Rhodes, Greece your way! Explore restaurants, local attractions and things to do in your favorite Rhodes, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "George Town",
      "country": "Pulau Pinang",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/george.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-zaf-george-173453774563784:Square?wid=768&fit=constrain",
      "headline": "George: Heritage, Forest Trails & Golf on the Garden Route",
      "description": "George’s vibrant downtown area is a hub of activity, with a charming mix of modern shops, traditional markets, and a variety of dining options that cater to every palate. The city is also steeped in history, with numerous heritage sites and museums that tell the story of its past, including the Outeniqua Transport Museum, which showcases a fascinating collection of rail and road vehicles. For those looking to unwind, many of our hotels feature luxurious amenities such as spa services, swimming pools, and free Wi-Fi, ensuring a comfortable and stress-free stay. Whether you’re here to hike the Tsitsikamma Forest, play a round of golf at one of the city’s renowned courses, or simply soak up the serene atmosphere, George promises an unforgettable experience."
    },
    {
      "city": "Kyoto City",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/kyoto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/50464712-kyoto_destination_fushimi-inari-1:Square?wid=768&fit=constrain",
      "headline": "Discover Kyoto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Kyoto, Japan your way! Explore restaurants, local attractions and things to do in your favorite Kyoto, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nuremberg",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/nuremberg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-nuremberg-173453862871113:Square?wid=768&fit=constrain",
      "headline": "Nuremberg: Where Timeless History Meets Vibrant Modern Culture",
      "description": "Nuremberg is a city that effortlessly marries its medieval past with a modern, forward-thinking present. The Nuremberg Castle and Old Town are just two of the many historical sites that tell the story of the city’s significant role in European history. But beyond the historical sites, the city is also home to a thriving arts and culture scene, with a number of museums and galleries to explore, including the Germanisches Nationalmuseum, the largest museum of cultural history in Germany. Our hotels in Nuremberg are the perfect base for your travels, ensuring you’re close to the city’s top attractions and much more."
    },
    {
      "city": "Reims",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "0",
      "pageUrl": "https://www.marriott.com/en/destinations/reims.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-fra-reims-173453638635767:Square?wid=768&fit=constrain",
      "headline": "Discover Reims Your Way with Marriott Bonvoy Stays",
      "description": "Visit Reims, France your way! Explore restaurants, local attractions and things to do in your favorite Reims, France neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Berkeley",
      "country": "USA",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/berkeley.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-berkeley-173453512275196:Square?wid=768&fit=constrain",
      "headline": "Berkeley: Where Free Spirits, Great Minds, and Bay Views Meet",
      "description": "Berkeley is a vibrant and culturally rich city that seamlessly blends academic prestige with a laid-back, progressive atmosphere. As the home of the University of California, Berkeley, the city is a hub of intellectual activity and innovation, where the spirit of free thought and creativity flourishes. Stroll through the bustling Telegraph Avenue, lined with eclectic shops and street performers, or explore the diverse culinary scene that showcases everything from farm-to-table dining to international flavors. With its proximity to the San Francisco Bay and the East Bay Regional Parks, Berkeley offers both urban excitement and natural beauty, making it a perfect destination for travelers of all interests."
    },
    {
      "city": "Hiroshima City",
      "country": "Japan",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "90",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/hiroshima.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jpn-hiroshima-1734540244517-9:Square?wid=768&fit=constrain",
      "headline": "Hiroshima & Miyajima: Timeless Heritage Amid Scenic Island Landscapes",
      "description": "The natural beauty of Hiroshima is just as impressive as its cityscape. A short ferry ride away, Miyajima Island is home to the iconic floating torii gate and ancient shrines set in a lush forest. In the city, the Hiroshima Castle and Shukkeien Garden offer a peaceful retreat into Japanese tradition. Our hotels offer a range of amenities and services, including free Wi-Fi and fitness centers, to help you plan a seamless and memorable trip. Whether you're looking to relax, explore, or connect with Hiroshima's heritage, we have a hotel to suit your needs."
    },
    {
      "city": "Santiago de Chile",
      "country": "Chile",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "50",
      "Spa": "25",
      "Culture": "75",
      "Music": "50",
      "pageUrl": "https://www.marriott.com/en/destinations/santiago.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-skyline-andes-mountains-859940256730875:Square?wid=768&fit=constrain",
      "headline": "Discover Santiago, Chile Your Way with Marriott Bonvoy",
      "description": "Visit Santiago, Chile your way! Explore restaurants, local attractions and things to do in your favorite Santiago, Chile neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Basel-Pratteln",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "50",
      "Spa": "75",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/basel.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-basel-173447133994326:Square?wid=768&fit=constrain",
      "headline": "Basel Bliss: Riverside Strolls, Green Escapes, and Cozy Stays",
      "description": "Stroll along the Rhine’s scenic banks, where boat tours, riverside promenades, and local markets await. The city’s dedication to green spaces is evident in its many parks and gardens, offering the perfect setting for a leisurely walk or a relaxing afternoon. Our hotels in Basel offer a variety of thoughtful amenities, including complimentary Wi-Fi, fitness centers, and free breakfast, to ensure your stay is as comfortable as it is memorable. With a range of locations from the city center to quieter residential areas, our hotels cater to every type of traveler, making it easy to experience the best of Basel."
    },
    {
      "city": "Lenox",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/lenox.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ma-lenox-173453809195499:Square?wid=768&fit=constrain",
      "headline": "Lenox: Berkshires Escape of Art, Music, and Timeless Charm",
      "description": "Lenox, a quintessential New England town, is a delightful blend of scenic beauty and cultural charm. Tucked away in the rolling hills and lush forests of the Berkshires, it's a serene retreat for those in search of a peaceful escape. The town's historic Main Street is a treasure trove of quaint shops, art galleries, and fine dining establishments, perfect for a leisurely stroll and a taste of local life. Lenox is also a haven for music and arts aficionados, with its world-renowned festivals such as the illustrious Tanglewood Music Festival, a mecca for classical music lovers. Whether you're planning a quick weekend break or a more extended stay, Lenox's selection of elegant inns and hotels provide a luxurious and welcoming home base to explore all the town has to offer."
    },
    {
      "city": "Chania – Crete",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/crete.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-crete-151586342206659:Square?wid=768&fit=constrain",
      "headline": "Discover Crete Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Crete, Greece your way! Explore restaurants, local attractions and things to do in your favorite Crete, Greece neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Macau",
      "country": "Macau",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/macau.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/macau-daytrips1:Square?wid=768&fit=constrain",
      "headline": "Discover Macau Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Macau, China your way! Explore restaurants, local attractions and things to do in your favorite Macau, China neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Mostar",
      "country": "Bosnia Herzegovina",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "25",
      "pageUrl": "https://www.marriott.com/en/destinations/mostar.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bih-mostar-173453810641585:Square?wid=768&fit=constrain",
      "headline": "Mostar’s Old Bridge: Timeless Charm Over the Neretva River",
      "description": "Mostar is a city that has managed to retain its historic and cultural heritage while also embracing a modern way of life. The city's most famous landmark is the Stari Most, or Old Bridge, which was rebuilt in the early 2000s and is now a UNESCO World Heritage site. The bridge spans the Neretva River and is a symbol of the city's resilience and unity. The Old Town, which is located around the bridge, is a maze of cobblestone streets, Ottoman-era mosques, and traditional craft shops, and is a great place to explore and learn about the city's past."
    },
    {
      "city": "Kyotoshi",
      "country": "Kyotofu",
      "Beach": "",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "90",
      "Music": "30",
      "pageUrl": "https://www.marriott.com/en/destinations/kyoto.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/50464712-kyoto_destination_fushimi-inari-1:Square?wid=768&fit=constrain",
      "headline": "Discover Kyoto Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Kyoto, Japan your way! Explore restaurants, local attractions and things to do in your favorite Kyoto, Japan neighborhoods as a Marriott Bonvoy Hotel guest."
    }
  ],
  "music": [
    {
      "city": "San Francisco",
      "country": "United States",
      "Beach": "75.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/san-francisco.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-GettyImages-1133891066-359793688600498:Square?wid=768&fit=constrain",
      "headline": "San Francisco Adventures Await with Marriott Bonvoy Stays",
      "description": "Stay at a Marriott Bonvoy Hotel in San Francisco, CA, and enjoy easy access to Fisherman’s Wharf, the iconic Golden Gate Bridge, and endless adventures."
    },
    {
      "city": "Liverpool",
      "country": "United Kingdom",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/liverpool.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-liverpool-173453852530936:Square?wid=768&fit=constrain",
      "headline": "Liverpool: Historic Waterfront, Beatles Beats, Vibrant City Streets",
      "description": "Liverpool is a city of great tradition and modernity, with a rich history of culture and commerce. The city's waterfront is a designated UNESCO World Heritage Site, home to such iconic landmarks as the Royal Albert Dock and Liverpool Cathedral. Visit the famous Cavern Club, where the Beatles played, or explore the city's maritime history at the Merseyside Maritime Museum. Our hotels in Liverpool are the perfect base from which to explore the city's vibrant neighborhoods and popular attractions."
    },
    {
      "city": "Boston",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "25",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/boston.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/sailing-boats-charles-river-downtown-boston:Square?wid=768&fit=constrain",
      "headline": "Boston Bites, Sights, and Scenic Nights Await You",
      "description": "Boston’s culinary scene is also not to be missed. Savor everything from fresh seafood at the Quincy Market to world-class dining in the South End. With easy access to the city’s public transportation, you can effortlessly navigate to the Harvard University campus, explore the museums of the Back Bay, or enjoy the scenic views along the Charles River. No matter your interests, Boston’s diverse neighborhoods and attractions promise an unforgettable experience."
    },
    {
      "city": "Portland",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "25",
      "Spa": "50",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/portland-maine.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/portland-maine-coast-boats:Square?wid=768&fit=constrain",
      "headline": "Discover Portland, ME: Eat, Explore, and Stay with Marriott",
      "description": "Visit Portland, ME your way! Explore restaurants, local attractions and things to do in your favorite Portland, ME neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Memphis",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/memphis.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/downtown-memphis-aerial-skyline:Square?wid=768&fit=constrain",
      "headline": "Discover Memphis Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Memphis, TN your way! Explore restaurants, local attractions and things to do in your favorite Memphis, TN neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Glasgow",
      "country": "United Kingdom",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/glasgow.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-glasgow-173453761787895:Square?wid=768&fit=constrain",
      "headline": "Glasgow Your Way: Eat, Explore, and Stay with Marriott",
      "description": "Visit Glasgow, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Glasgow, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Las Vegas",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "25",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/las-vegas.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/momofuku-couple-dining-las-vegas-nevada:Square?wid=768&fit=constrain",
      "headline": "Beyond the Strip: Las Vegas Adventures and Relaxing Hotel Retreats",
      "description": "But there’s more to Las Vegas than the Strip. The city is a gateway to outdoor adventure and natural beauty. Drive a short distance to explore the stunning Red Rock Canyon, hike in the Valley of Fire State Park, or take a day trip to the awe-inspiring Grand Canyon. Our hotels offer a peaceful retreat after a day of exploration, with spacious rooms, top-notch dining, and serene pools that provide a relaxing escape from the city’s energy. Whether you’re planning a romantic getaway, a family vacation, or a business trip, Las Vegas has something for everyone, and our hotels are here to make your stay unforgettable."
    },
    {
      "city": "Beirut",
      "country": "Lebanon",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/beirut.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-lbn-beirut-1734535307137-5:Square?wid=768&fit=constrain",
      "headline": "Experience Beirut Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Beirut, Lebanon your way! Explore restaurants, local attractions and things to do in your favorite Beirut, Lebanon neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hamburg",
      "country": "Germany",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/hamburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-hamburg-173454132906462:Square?wid=768&fit=constrain",
      "headline": "Discover Hamburg Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hamburg, Germany your way! Explore restaurants, local attractions and things to do in your favorite Hamburg, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Vienna",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/vienna.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-vienna-173453913119285:Square?wid=768&fit=constrain",
      "headline": "Vienna: Imperial Splendor Meets Cutting-Edge Arts and Culture",
      "description": "Vienna, a city where the grandeur of baroque architecture meets the pulse of innovative art and culture, is a masterful blend of history and modernity. As the epicenter of classical music, it boasts the prestigious Vienna State Opera and the renowned Vienna Philharmonic, delivering world-class performances throughout the year. The city's imperial legacy is on display in its opulent palaces, from Schönbrunn to the Hofburg, offering a window into the lavish past of the Habsburg dynasty. Whether you're meandering through the verdant gardens of the Belvedere Palace or savoring a coffee in a traditional café, Vienna's allure and sophistication will enchant you at every step."
    },
    {
      "city": "Melbourne",
      "country": "Australia",
      "Beach": "75.0",
      "Culinary": "85",
      "Golf": "80",
      "Ski": "50",
      "Spa": "60",
      "Culture": "75",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/melbourne.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/md-melmd-regent-theatre-15294:Square?wid=768&fit=constrain",
      "headline": "Discover Melbourne Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Melbourne, Australia your way! Explore restaurants, local attractions and things to do in your favorite Melbourne, Australia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Los Angeles",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "85",
      "Golf": "80",
      "Ski": "50",
      "Spa": "70",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/los-angeles.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/griffith-park-los-angeles-california:Square?wid=768&fit=constrain",
      "headline": "Discover Baltimore Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Baltimore, MD your way! Explore restaurants, local attractions and more in your favorite Los Angeles neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Berlin",
      "country": "Germany",
      "Beach": "0.0",
      "Culinary": "80",
      "Golf": "40",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/berlin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-berlin-173453772557748:Square?wid=768&fit=constrain",
      "headline": "Discover Berlin Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Berlin, Germany your way! Explore restaurants, local attractions and things to do in your favorite Berlin, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Barcelona",
      "country": "Spain",
      "Beach": "90.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/barcelona.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-sagrat-cor-temple92601-1669848202478-2:Square?wid=768&fit=constrain",
      "headline": "Discover Barcelona Your Way with Marriott Bonvoy Stays",
      "description": "Visit Barcelona, Spain your way! Explore restaurants, local attractions and things to do in your favorite Barcelona, Spain neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Buenos Aires",
      "country": "Argentina",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/buenos-aires.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-centro-cultural-recoleta-485852901431222:Square?wid=768&fit=constrain",
      "headline": "Experience Buenos Aires Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Buenos Aires, Argentina your way! Explore restaurants, local attractions and things to do in your favorite Buenos Aires, Argentina neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Chicago",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "85",
      "Golf": "75",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/chicago.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1065188752:Square?wid=768&fit=constrain",
      "headline": "Discover Chicago Your Way With Marriott Bonvoy Hotels",
      "description": "Visit Chicago, IL your way! Explore restaurants, local attractions and more in your favorite Chicago neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Dublin",
      "country": "Ireland",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/dublin.mi",
      "imageUrl": "https://cache.marriott.com/marriottassets/icons/mrw_default_profile_placeholder1.png",
      "headline": "Dublin Delights: Music, River Views & Unforgettable City Stays",
      "description": "Stroll the colorful streets of Temple Bar, where the sound of Irish music spills from the pubs, or take a leisurely walk along the River Liffey, soaking in the views and local life. Many of our hotels offer amenities like free Wi-Fi, on-site dining and fitness centers, ensuring your stay is as comfortable as it is memorable. Whether you’re in town for a business meeting or a leisurely getaway, Dublin’s diverse offerings, from historic castles to modern shopping districts, promise an unforgettable experience."
    },
    {
      "city": "Austin",
      "country": "United States",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/austin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/skyline-downtown-austin-texas:Square?wid=768&fit=constrain",
      "headline": "Discover Austin’s Vibe: Stay, Play, and Explore with Marriott",
      "description": "Stay at a Marriott Bonvoy Hotel in Austin, TX, and experience the city’s culture. Explore exceptional live music venues, Lady Bird Lake, and South Congress!"
    },
    {
      "city": "Manhattan",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "50",
      "Culture": "90",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/manhattan-beach.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-manhattan-beach-173453721276755:Square?wid=768&fit=constrain",
      "headline": "Manhattan Beach: Where Laid-Back Coastal Charm Meets Urban Sophistication",
      "description": "Manhattan Beach is a charming coastal town that effortlessly marries the allure of a small beach community with the elegance of a thriving coastal city. Its wide, sandy beaches and lively boardwalk attract beachgoers and water sports enthusiasts alike. The Strand, a picturesque bike path, offers stunning ocean vistas and is perfect for a leisurely stroll or invigorating bike ride. Just moments from the vibrant downtown area, you'll find an array of high-end boutiques, art galleries, and gourmet dining options, catering to those in search of both tranquility and urban energy."
    },
    {
      "city": "Milan",
      "country": "Italy",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "1",
      "Ski": "1",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/milan.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-907949732-milan-italy-23312:Square?wid=768&fit=constrain",
      "headline": "Discover Milan Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Milan, Italy your way! Explore restaurants, local attractions and things to do in your favorite Milan, Italy neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Cali",
      "country": "Colombia",
      "Beach": "0.0",
      "Culinary": "70",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/cali.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-col-cali-747968479330686:Square?wid=768&fit=constrain",
      "headline": "Cali: Where Salsa Rhythms Meet Colonial Charm and Culture",
      "description": "Cali is a city that lives and breathes culture, and it's not just the warm climate that makes it so inviting. Known as the world's capital of salsa, the rhythm of the music and the dance is in the very air you breathe. The annual Salsa Festival is a must-see for anyone who loves to move to the beat, but you can find the music and the movement in the city's many dance studios and clubs all year round. But there's more to Cali than just the dance. The city is home to some of the best-preserved colonial architecture in the country, as well as a number of museums that showcase the city's rich history."
    },
    {
      "city": "Paris",
      "country": "France",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "75",
      "Culture": "100",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/paris.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arc-de-triomphe-paris-634207441403522:Square?wid=768&fit=constrain",
      "headline": "Discover Paris Your Way with Marriott Bonvoy Stays",
      "description": "Visit Paris, France your way! Explore restaurants, local attractions and more in your favorite Paris neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Medellin",
      "country": "Colombia",
      "Beach": "0.0",
      "Culinary": "70",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "60",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/medellin.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-col-medellin-173453502204360:Square?wid=768&fit=constrain",
      "headline": "Discover Medellín Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Medellín, Colombia your way! Explore restaurants, local attractions and things to do in your favorite Medellín, Colombia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Lagos",
      "country": "Nigeria",
      "Beach": "30.0",
      "Culinary": "60",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "50",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/lagos-nigeria.mi",
      "imageUrl": "https://cache.marriott.com/marriottassets/icons/mrw_default_profile_placeholder1.png",
      "headline": "Discover Lagos Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Lagos, Nigeria your way! Explore restaurants, local attractions and things to do in your favorite Lagos, Nigeria neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Mumbai",
      "country": "India",
      "Beach": "60.0",
      "Culinary": "85",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "70",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/mumbai.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-chhatrapati-shivaji-12840-167045141964092:Square?wid=768&fit=constrain",
      "headline": "Discover Mumbai Your Way with Marriott Bonvoy Hotel Stays",
      "description": "Visit Mumbai, India your way! Explore restaurants, local attractions and things to do in your favorite Mumbai, India neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sao Paulo",
      "country": "Brazil",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/sao-paulo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-ibirapuera-neighborhood-649944870849732:Square?wid=768&fit=constrain",
      "headline": "Sao Paulo Getaway: Art, Green Escapes, and Urban Style",
      "description": "Discover the vibrant arts and culture scene of Sao Paulo at the Pinacoteca or the Museu de Arte de Sao Paulo, or take a stroll through the greenery of Ibirapuera Park, an urban oasis. Many of our hotels offer amenities like complimentary Wi-Fi, fitness centers, and on-site dining, ensuring your stay is comfortable and convenient. From the historic downtown to the trendy Vila Madalena, our hotels provide the perfect gateway to experience the city’s unique blend of tradition and innovation."
    },
    {
      "city": "Tokyo",
      "country": "Japan",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "90",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/tokyo.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/al-tyoal-asakusa-32531:Square?wid=768&fit=constrain",
      "headline": "Tokyo Tastemakers: Culture, Cuisine, and City Nights Await",
      "description": "Immerse yourself in Tokyo’s rich culture and Michelin-starred culinary scene. From the sushi bars of Tsukiji Outer Market to the trendy neighborhoods of Harajuku and Ginza, there’s something for every taste. Our hotels are the perfect starting point for your adventures, with many offering complimentary breakfast and evening events that capture the spirit of the city."
    },
    {
      "city": "London",
      "country": "United Kingdom",
      "Beach": "1.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "90",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/london.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-skyline-w-twr-brdg94263-167001018629978:Square?wid=768&fit=constrain",
      "headline": "Discover London Your Way with Marriott Bonvoy Hotels",
      "description": "Visit London, United Kingdom your way! Explore restaurants, local attractions and more in your favorite London neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New York City",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "75",
      "Culture": "85",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/nyc.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lower-manhattan-skyline-new-york-city-new-york:Square?wid=768&fit=constrain",
      "headline": "Experience New York City Your Way With Marriott Bonvoy",
      "description": "Visit New York City, NY your way! Explore restaurants, local attractions and more in your favorite New York City neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Rio de Janeiro",
      "country": "Brazil",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "25",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/rio-de-janeiro.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-bra-rio-de-janeiro-173453854225540:Square?wid=768&fit=constrain",
      "headline": "Discover Rio de Janeiro Your Way with Marriott Bonvoy",
      "description": "Visit Rio de Janeiro, Brazil your way! Explore restaurants, local attractions and things to do in your favorite Rio de Janeiro, Brazil neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sydney",
      "country": "Australia",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "1",
      "Spa": "75",
      "Culture": "70",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/sydney.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/mc-sydmc-sydney-harbour-skyline-30873:Square?wid=768&fit=constrain",
      "headline": "Unlock Sydney’s Best Neighborhoods with Marriott Bonvoy Stays",
      "description": "Visit Sydney, Australia your way! Explore restaurants, local attractions and things to do in your favorite Sydney, Australia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Kingston",
      "country": "Jamaica",
      "Beach": "75.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "1",
      "Spa": "25",
      "Culture": "50",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/kingston.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-jam-kingston-998348525078006:Square?wid=768&fit=constrain",
      "headline": "Discover Kingston, Jamaica: Local Flavors, Sights, and Stays",
      "description": "Visit Kingston, Jamaica your way! Explore restaurants, local attractions and things to do in your favorite Kingston, Jamaica neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Manchester",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/chester.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-chester-173453914624154:Square?wid=768&fit=constrain",
      "headline": "Discover Chester Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Chester, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Chester, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Nashville",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/nashville.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lower-broadway-nashville-tennessee:Square?wid=768&fit=constrain",
      "headline": "Discover Nashville Your Way with Marriott Bonvoy Stays",
      "description": "Visit Nashville, TN your way! Explore restaurants, local attractions and more in your favorite Nashville neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Amsterdam",
      "country": "Netherlands",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/amsterdam.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-1313361488-amsterdam-hero-10682:Square?wid=768&fit=constrain",
      "headline": "Discover Amsterdam Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Amsterdam, Netherlands your way! Explore restaurants, local attractions and things to do in your favorite Amsterdam, Netherlands neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Seattle",
      "country": "United States",
      "Beach": "50.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "50",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/seattle.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-Seattle-Destination-844280376200442:Square?wid=768&fit=constrain",
      "headline": "Discover Seattle Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Seattle, WA your way! Explore restaurants, local attractions and things to do in your favorite Seattle, WA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Tbilisi",
      "country": "Georgia",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/tbilisi.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-bonvoy-546242868-13442-50842:Square?wid=768&fit=constrain",
      "headline": "Discover Tbilisi Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Tbilisi, Georgia your way! Explore restaurants, local attractions and things to do in your favorite Tbilisi, Georgia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Barranquilla",
      "country": "Colombia",
      "Beach": "25.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/barranquilla.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-col-barranquilla-173447134997789:Square?wid=768&fit=constrain",
      "headline": "Discover Barranquilla Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Barranquilla, Colombia your way! Explore restaurants, local attractions and things to do in your favorite Barranquilla, Colombia neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Birmingham",
      "country": "United Kingdom",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/birmingham-united-kingdom.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-birmingham-173453727806163:Square?wid=768&fit=constrain",
      "headline": "Discover Birmingham Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Birmingham, United Kingdom your way! Explore restaurants, local attractions and things to do in your favorite Birmingham, United Kingdom neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Belgrade",
      "country": "Serbia",
      "Beach": "0.0",
      "Culinary": "60",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "70",
      "Music": "80",
      "pageUrl": "https://www.marriott.com/en/destinations/belgrade.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-srb-belgrade-173453462525795:Square?wid=768&fit=constrain",
      "headline": "Belgrade Getaway: Savor Food, Culture, and Riverside Charm",
      "description": "Immerse yourself in Belgrade's vibrant food and cultural scene, from traditional kafanas to contemporary restaurants. Enjoy a complimentary breakfast at many of our hotels, then head out to explore the city’s lively markets, fascinating museums, and scenic riverside promenades. Our hotels are located in the city center and in peaceful residential areas, offering the perfect balance of easy access to top attractions and a quiet place to relax at the end of the day. Whether you’re planning a quick weekend trip or an extended stay, our hotels will keep you close to the action."
    },
    {
      "city": "Atlanta",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "1",
      "Spa": "25",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/atlanta.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-Atlanta-Destination-358889675313710:Square?wid=768&fit=constrain",
      "headline": "Discover Atlanta Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Atlanta, GA your way! Explore restaurants, local attractions and things to do in your favorite Atlanta, GA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Leipzig",
      "country": "Germany",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/leipzig.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-deu-leipzig-343406197308221:Square?wid=768&fit=constrain",
      "headline": "Discover Leipzig Your Way with Marriott Bonvoy Hotels",
      "description": "Visit Leipzig, Germany your way! Explore restaurants, local attractions and things to do in your favorite Leipzig, Germany neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "San Juan",
      "country": "Puerto Rico",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/san-juan.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-pri-san-juan-231034152762676:Square?wid=768&fit=constrain",
      "headline": "San Juan Getaway: Beaches, Festivals, and Culture at Your Doorstep",
      "description": "Immerse yourself in the vibrant spirit of San Juan, where lively markets, pristine beaches and a calendar of cultural events await. The city’s rich arts scene and annual festivals, such as the San Juan Jazz Festival, add an extra layer of excitement. Our hotels in San Juan are equipped with modern amenities, including complimentary Wi-Fi and fitness centers, to keep you connected and refreshed. With a range of locations across the city, from the historic district to the beachfront, our hotels ensure you’re never far from the action."
    },
    {
      "city": "Bristol",
      "country": "United Kingdom",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "0",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/bristol.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-bristol-1734535272004-7:Square?wid=768&fit=constrain",
      "headline": "Bristol: Where Historic Harbors, Street Art and Innovation Collide",
      "description": "Bristol, a city with a rich history and a contemporary vibe, is a place where creativity and heritage converge. Internationally recognized for its street art, which includes the enigmatic works of Banksy, Bristol's walls are a canvas of vibrant murals and graffiti, each telling a story of the city's journey. From the historic harborside, now a hub of chic bars, eateries, and shops, to the iconic Clifton Suspension Bridge, there's a wealth of sights to explore. The city's dedication to sustainability and innovation is evident in its green spaces, eco-friendly projects, and burgeoning tech sector, making it a compelling choice for all types of travelers."
    },
    {
      "city": "Miami",
      "country": "United States",
      "Beach": "90.0",
      "Culinary": "80",
      "Golf": "75",
      "Ski": "0",
      "Spa": "75",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Minneapolis",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "25",
      "Spa": "25",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/minneapolis.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/hamburger-fries-cheeese-burger-cyLHRCY.1063398:Square?wid=768&fit=constrain",
      "headline": "Minneapolis: Where Urban Energy Meets Lakeside Calm",
      "description": "Minneapolis is a city that effortlessly combines the thrill of urban living with the serenity of nature. Its lively arts scene is a testament to its cultural richness, with renowned institutions like the Walker Art Center and the Minneapolis Institute of Art waiting to captivate you with their diverse exhibits. For those who love the outdoors, the Chain of Lakes and the expansive Minneapolis Sculpture Garden offer scenic beauty and ample space for leisurely strolls. The city's dedication to sustainability and pedestrian-friendly spaces ensures that exploring is a delight, with bike paths and a comprehensive public transit system to take you to all the must-see spots."
    },
    {
      "city": "New Orleans",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "1",
      "Spa": "25",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/new-orleans.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-NOLA-DESTINATION-260136935781775:Square?wid=768&fit=constrain",
      "headline": "Discover New Orleans Your Way with Marriott Bonvoy Stays",
      "description": "Visit New Orleans, LA your way! Explore restaurants, local attractions and more in your favorite New Orleans neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Edinburgh",
      "country": "United Kingdom",
      "Beach": "1.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/edinburgh.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-edinburgh-173453784118881:Square?wid=768&fit=constrain",
      "headline": "Edinburgh: Where Ancient Streets Meet Electric Festival Nights",
      "description": "Edinburgh, the historic and vibrant capital, is a city that seamlessly blends ancient tradition with contemporary culture. Home to the iconic Edinburgh Castle, which looms over the city from its volcanic perch, this destination offers a wealth of historical sites, including the Royal Mile, the Palace of Holyroodhouse, and the historic Old Town, a UNESCO World Heritage site. The city’s rich cultural calendar is highlighted by the annual Edinburgh Festival Fringe, the largest arts festival in the world, and the spectacular Hogmanay celebrations, making it a year-round hub of entertainment and creativity."
    },
    {
      "city": "Novi Sad",
      "country": "Serbia",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "1",
      "Ski": "0",
      "Spa": "1",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/novi-sad.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-srb-novi-sad-222923666672726:Square?wid=768&fit=constrain",
      "headline": "Novi Sad: Danube Charm, Fortress Views, European Vibes",
      "description": "Novi Sad, a city of rich history and contemporary European allure, is a vibrant destination that offers a unique blend of cultural heritage and modern European charm. Situated on the banks of the Danube River, Novi Sad is home to the Petrovaradin Fortress, an iconic landmark that provides breathtaking panoramic views and hosts a variety of cultural events. The city center is a bustling area with pedestrian-friendly streets, charming squares, and a wide selection of cafes, boutiques, and restaurants that offer both traditional Serbian cuisine and international flavors. Whether you are exploring the cobblestone streets of the Stari Grad (Old Town) or enjoying the city's lively nightlife, Novi Sad provides a memorable experience for every traveler."
    },
    {
      "city": "Salzburg",
      "country": "Austria",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "75",
      "Spa": "0",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/salzburg.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-aut-salzburg-1734540224442-5:Square?wid=768&fit=constrain",
      "headline": "Salzburg: Baroque Charm, Mozart Melodies, and Alpine Adventures Await",
      "description": "Salzburg, a city rich in baroque architecture and musical history, is a beautiful combination of old-world charm and modern vitality. As the birthplace of Mozart, it is a mecca for classical music lovers, with concerts and festivals honoring his legacy year-round. The city's historic center, a UNESCO World Heritage site, is a warren of cobblestone streets, elegant churches, and inviting cafes, beckoning you to step back in time. Salzburg's prime location also makes it the perfect jumping-off point to the nearby Alps, offering outdoor enthusiasts the chance to enjoy hiking, skiing, and stunning vistas."
    },
    {
      "city": "Asheville",
      "country": "United States",
      "Beach": "1.0",
      "Culinary": "75",
      "Golf": "50",
      "Ski": "1",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/asheville.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/band-voilin-drums-musicians-music-folk-blues:Square?wid=768&fit=constrain",
      "headline": "Asheville: Mountain Art Haven with Old-World Charm",
      "description": "Asheville, a city nestled in the Blue Ridge Mountains, is a place of vibrant culture and rich history. Known as the \"Paris of the South,\" it is home to a myriad of art galleries, craft breweries, and unique boutiques, making it a haven for those with a creative spirit. The historic Biltmore Estate, America’s largest privately-owned home, is a must-see, with its opulent rooms, extensive gardens, and award-winning winery. The downtown area, with its well-preserved Art Deco architecture, offers a unique blend of old-world charm and modern sophistication, where you can enjoy live music, street performances, and a diverse culinary scene."
    },
    {
      "city": "Bristol",
      "country": "United States",
      "Beach": "25.0",
      "Culinary": "70",
      "Golf": "1",
      "Ski": "1",
      "Spa": "1",
      "Culture": "60",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/bristol.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-bristol-1734535272004-7:Square?wid=768&fit=constrain",
      "headline": "Bristol: Where Historic Harbors, Street Art and Innovation Collide",
      "description": "Bristol, a city with a rich history and a contemporary vibe, is a place where creativity and heritage converge. Internationally recognized for its street art, which includes the enigmatic works of Banksy, Bristol's walls are a canvas of vibrant murals and graffiti, each telling a story of the city's journey. From the historic harborside, now a hub of chic bars, eateries, and shops, to the iconic Clifton Suspension Bridge, there's a wealth of sights to explore. The city's dedication to sustainability and innovation is evident in its green spaces, eco-friendly projects, and burgeoning tech sector, making it a compelling choice for all types of travelers."
    },
    {
      "city": "Beyoglu/Istanbul",
      "country": "Türkiye",
      "Beach": "25.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/istanbul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-istanbul-173454093632192:Square?wid=768&fit=constrain",
      "headline": "Discover Istanbul Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Istanbul, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Istanbul, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Istanbul",
      "country": "Türkiye",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "50",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/istanbul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-istanbul-173454093632192:Square?wid=768&fit=constrain",
      "headline": "Discover Istanbul Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Istanbul, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Istanbul, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Paris/Bagnolet",
      "country": "France",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "25",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/paris.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-arc-de-triomphe-paris-634207441403522:Square?wid=768&fit=constrain",
      "headline": "Discover Paris Your Way with Marriott Bonvoy Stays",
      "description": "Visit Paris, France your way! Explore restaurants, local attractions and more in your favorite Paris neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Mykonos",
      "country": "Greece",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/mykonos.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-grc-mykonos-173454136693238:Square?wid=768&fit=constrain",
      "headline": "Mykonos Magic: Where Sunlit Streets Meet Aegean Nights",
      "description": "Mykonos, with its iconic windmills and pristine beaches, is a vibrant island that captures the essence of the Aegean Sea. Known for its lively nightlife and chic boutiques, the city offers a perfect blend of relaxation and excitement. Whether you're exploring the historic Little Venice district with its colorful buildings and seaside balconies, or enjoying the sun at one of the many stunning beaches, Mykonos ensures a memorable experience. The city's white-washed Cycladic architecture and charming cobblestone streets are a photographer’s dream, while its rich cultural heritage is evident in the numerous museums and archaeological sites."
    },
    {
      "city": "Miami Beach",
      "country": "USA",
      "Beach": "90.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "50",
      "Culture": "50",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/miami.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/lifeguard-stand-miami-beach-miami-forida:Square?wid=768&fit=constrain",
      "headline": "Discover Miami Your Way with Marriott Bonvoy Stays",
      "description": "Visit Miami, FL your way! Explore restaurants, local attractions and more in your favorite Miami neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "New York",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "90",
      "Golf": "25",
      "Ski": "0",
      "Spa": "50",
      "Culture": "90",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/york.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-gbr-york-368750268357195:Square?wid=768&fit=constrain",
      "headline": "York: Timeless Streets, Towering Views, Perfect Stays for All",
      "description": "York is a city of contrasts. From the panoramic views at Clifford's Tower to the many museums, galleries and shops, there is something for everyone. The city is also home to the Shambles, a narrow, cobbled street lined with shops and restaurants. The York Railway Station is the main station in the city and offers regular services to a number of destinations. Many of our hotels offer on-site dining, fitness and leisure facilities and free Wi-Fi. With a range of modern and historic hotels, we have the perfect place to stay for every type of traveler."
    },
    {
      "city": "Hong Kong",
      "country": "Hong Kong",
      "Beach": "50.0",
      "Culinary": "90",
      "Golf": "75",
      "Ski": "0",
      "Spa": "50",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/hong-kong.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-JordHammond-HongKong-739569223059559:Square?wid=768&fit=constrain",
      "headline": "Hong Kong: Electric Nights, Timeless Sights, Endless City Delights",
      "description": "Hong Kong is a city that never stops. A place where the ancient and the modern sit side by side, it’s a city of contrasts. From the soaring skyscrapers to the bustling street markets and the serene temples, you’ll find something new to explore around every corner. As a global financial hub, Hong Kong is a city that knows how to live well. With world-class dining, luxury shopping, and efficient public transport, it’s a city that has it all. Our hotels in Hong Kong are perfectly placed to help you explore everything the city has to offer, from the iconic Victoria Peak to the famous Star Ferry and the vibrant Causeway Bay."
    },
    {
      "city": "West Hollywood",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "25",
      "Culture": "50",
      "Music": "85",
      "pageUrl": "https://www.marriott.com/en/destinations/hollywood.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-hollywood-173453621519438:Square?wid=768&fit=constrain",
      "headline": "Discover Hollywood Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hollywood, CA your way! Explore restaurants, local attractions and things to do in your favorite Hollywood, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Sirkeci / Fatih / Istanbul",
      "country": "Türkiye",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "90",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/istanbul.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-tur-istanbul-173454093632192:Square?wid=768&fit=constrain",
      "headline": "Discover Istanbul Your Way with Marriott Bonvoy Adventures",
      "description": "Visit Istanbul, Turkey your way! Explore restaurants, local attractions and things to do in your favorite Istanbul, Turkey neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Long Island City",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "75",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/long-island.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/seafood-wine-dinner-restaurant-candle-swh.438335:Square?wid=768&fit=constrain",
      "headline": "Experience Long Island Your Way with Marriott Bonvoy Stays",
      "description": "Visit Long Island, NY your way! Explore restaurants, local attractions and things to do in your favorite Long Island, NY neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Hollywood",
      "country": "USA",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "0",
      "Ski": "0",
      "Spa": "0",
      "Culture": "75",
      "Music": "75",
      "pageUrl": "https://www.marriott.com/en/destinations/hollywood.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-usa-ca-hollywood-173453621519438:Square?wid=768&fit=constrain",
      "headline": "Discover Hollywood Your Way with Marriott Bonvoy Stays",
      "description": "Visit Hollywood, CA your way! Explore restaurants, local attractions and things to do in your favorite Hollywood, CA neighborhoods as a Marriott Bonvoy Hotel guest."
    },
    {
      "city": "Montreux",
      "country": "Switzerland",
      "Beach": "0.0",
      "Culinary": "50",
      "Golf": "25",
      "Ski": "0",
      "Spa": "75",
      "Culture": "75",
      "Music": "90",
      "pageUrl": "https://www.marriott.com/en/destinations/montreux.mi",
      "imageUrl": "https://cache.marriott.com/is/image/marriotts7prod/pdt-che-montreux-173452973943830:Square?wid=768&fit=constrain",
      "headline": "Montreux Magic: Lakeside Alps, Jazz Nights, Timeless Swiss Charm",
      "description": "Montreux, a city of natural beauty and cultural vibrancy, is nestled along the shores of Lake Geneva. Its breathtaking views of the Swiss Alps and the inviting waterfront promenade make it an ideal destination for a leisurely escape or a romantic retreat. Known for its music and art scene, Montreux is home to the renowned Montreux Jazz Festival and a variety of galleries and performance venues. Whether you're exploring the history of Chillon Castle or savoring the beauty of the surrounding vineyards, Montreux offers a seamless blend of historical allure and contemporary elegance to cater to all types of travelers."
    }
  ]
}
